/* tslint:disable */
/* eslint-disable */
/**
 * Laravel
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
export { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

export interface GetApiAccountsDebugAuth200Response {
    'header'?: string;
    'bearer'?: string;
    'all_headers'?: Array<string>;
}
export interface GetApiAdminCartsRequest {
    /**
     * 
     */
    'id'?: number | null;
    /**
     * 
     */
    'search'?: string | null;
    /**
     * 
     */
    'sort_column'?: string | null;
    /**
     * 
     */
    'sort_type'?: GetApiAdminCartsRequestSortTypeEnum | null;
}

export const GetApiAdminCartsRequestSortTypeEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type GetApiAdminCartsRequestSortTypeEnum = typeof GetApiAdminCartsRequestSortTypeEnum[keyof typeof GetApiAdminCartsRequestSortTypeEnum];

export interface GetApiAttributesSeoIdRequest {
    /**
     * 
     */
    'id'?: number;
    /**
     * 
     */
    'list'?: number;
}
export interface GetApiAttributesSeos403Response {
    'message'?: string;
    'exception'?: string;
    'file'?: string;
    'line'?: number;
    'trace'?: Array<GetApiAttributesSeos403ResponseTraceInner>;
}
export interface GetApiAttributesSeos403ResponseTraceInner {
    'file'?: string;
    'line'?: number;
    'function'?: string;
    'class'?: string;
    'type'?: string;
}
export interface GetApiAttributesSeosRequest {
    /**
     * 
     */
    'id'?: number;
    /**
     * 
     */
    'list'?: number;
}
export interface GetApiBillingCreditIdRequest {
    /**
     * 
     */
    'username'?: string;
}
export interface GetApiBillingCreditsRequest {
    /**
     * 
     */
    'username'?: string;
}
export interface GetApiCatalogAttributeIdRequest {
    /**
     * 
     */
    'id'?: number;
}
export interface GetApiCatalogAttributesValuesRequest {
    /**
     * 
     */
    'id'?: number;
}
export interface GetApiCatalogBrandIdRequest {
    /**
     * 
     */
    'id'?: number;
    /**
     * 
     */
    'list'?: number;
}
export interface GetApiCatalogBrandsRequest {
    /**
     * 
     */
    'id'?: number;
    /**
     * 
     */
    'list'?: number;
}
export interface GetApiCatalogCategoriesRequest {
    /**
     * 
     */
    'id'?: number | null;
    /**
     * 
     */
    'list'?: number | null;
}
export interface GetApiCatalogCategoryIdRequest {
    /**
     * 
     */
    'id'?: number | null;
    /**
     * 
     */
    'list'?: number | null;
}
export interface GetApiCatalogProductIdRequest {
    /**
     * 
     */
    'id'?: number;
    /**
     * 
     */
    'list'?: number;
    /**
     * 
     */
    'name'?: string | null;
    /**
     * 
     */
    'sku'?: string | null;
    /**
     * 
     */
    'brand'?: number | null;
    /**
     * 
     */
    'category'?: number | null;
    /**
     * 
     */
    'active'?: string | null;
    /**
     * 
     */
    'price_from'?: number | null;
    /**
     * 
     */
    'price_to'?: number | null;
}
export interface GetApiCatalogProductSearchRequest {
    /**
     * 
     */
    'name'?: string;
    /**
     * 
     */
    'sku'?: string;
    /**
     * 
     */
    'sort_column'?: string;
    /**
     * 
     */
    'sort_type'?: string;
}
export interface GetApiCatalogProductsAttributesRequest {
    /**
     * 
     */
    'id'?: number;
}
export interface GetApiCatalogProductsRequest {
    /**
     * 
     */
    'id'?: number;
    /**
     * 
     */
    'list'?: number;
    /**
     * 
     */
    'name'?: string | null;
    /**
     * 
     */
    'sku'?: string | null;
    /**
     * 
     */
    'brand'?: number | null;
    /**
     * 
     */
    'category'?: number | null;
    /**
     * 
     */
    'active'?: string | null;
    /**
     * 
     */
    'price_from'?: number | null;
    /**
     * 
     */
    'price_to'?: number | null;
}
export interface GetApiCatalogStoreIdRequest {
    /**
     * 
     */
    'id'?: number;
    /**
     * 
     */
    'list'?: number;
}
export interface GetApiCatalogStoresRequest {
    /**
     * 
     */
    'id'?: number;
    /**
     * 
     */
    'list'?: number;
}
export interface GetApiCatalogTagIdRequest {
    /**
     * 
     */
    'id'?: number;
    /**
     * 
     */
    'list'?: number;
}
export interface GetApiCatalogTagsRequest {
    /**
     * 
     */
    'id'?: number;
    /**
     * 
     */
    'list'?: number;
}
export interface GetApiContentPageIdRequest {
    /**
     * 
     */
    'id'?: number;
}
export interface GetApiContentPagesRequest {
    /**
     * 
     */
    'id'?: number;
}
export interface GetApiInvoicesSettingsIdRequest {
    /**
     * 
     */
    'id'?: number | null;
}
export interface GetApiInvoicesSettingsRequest {
    /**
     * 
     */
    'id'?: number | null;
}
export interface GetApiMediaFilesIdRequest {
    /**
     * 
     */
    'id'?: number;
}
export interface GetApiMediaSearchRequest {
    /**
     * 
     */
    'name'?: string;
    /**
     * 
     */
    'type'?: string;
    /**
     * Must be a valid date.
     */
    'date'?: string;
    /**
     * 
     */
    'folder'?: string;
}
export interface GetApiOrdersExportRequest {
    /**
     * 
     */
    'id'?: number | null;
    /**
     * 
     */
    'status'?: number;
    /**
     * 
     */
    'search'?: string;
    /**
     * 
     */
    'payment_mode'?: string;
    /**
     * 
     */
    'amount_from'?: number;
    /**
     * 
     */
    'amount_to'?: number;
    /**
     * 
     */
    'sort_column'?: string;
    /**
     * 
     */
    'sort_type'?: string;
}
export interface GetApiOrdersOrderIdRequest {
    /**
     * 
     */
    'id'?: number | null;
    /**
     * 
     */
    'status'?: number;
    /**
     * 
     */
    'search'?: string;
    /**
     * 
     */
    'payment_mode'?: string;
    /**
     * 
     */
    'amount_from'?: number;
    /**
     * 
     */
    'amount_to'?: number;
    /**
     * 
     */
    'sort_column'?: string;
    /**
     * 
     */
    'sort_type'?: string;
}
export interface GetApiOrdersOrdersRequest {
    /**
     * 
     */
    'id'?: number | null;
    /**
     * 
     */
    'status'?: number;
    /**
     * 
     */
    'search'?: string;
    /**
     * 
     */
    'payment_mode'?: string;
    /**
     * 
     */
    'amount_from'?: number;
    /**
     * 
     */
    'amount_to'?: number;
    /**
     * 
     */
    'sort_column'?: string;
    /**
     * 
     */
    'sort_type'?: string;
}
export interface GetApiPath404Response {
    'status'?: string;
    'message'?: string;
}
export interface GetApiPromotionsCodeIdRequest {
    /**
     * 
     */
    'id'?: number | null;
}
export interface GetApiPromotionsCodesRequest {
    /**
     * 
     */
    'id'?: number | null;
}
export interface GetApiPromotionsOfferIdRequest {
    /**
     * 
     */
    'id'?: number | null;
    /**
     * 
     */
    'title'?: string;
    /**
     * 
     */
    'active'?: boolean;
    /**
     * 
     */
    'price_from'?: number;
    /**
     * 
     */
    'price_to'?: number;
    /**
     * 
     */
    'id_from'?: number;
    /**
     * 
     */
    'id_to'?: number;
    /**
     * 
     */
    'sort_column'?: string;
    /**
     * 
     */
    'sort_type'?: GetApiPromotionsOfferIdRequestSortTypeEnum;
}

export const GetApiPromotionsOfferIdRequestSortTypeEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type GetApiPromotionsOfferIdRequestSortTypeEnum = typeof GetApiPromotionsOfferIdRequestSortTypeEnum[keyof typeof GetApiPromotionsOfferIdRequestSortTypeEnum];

export interface GetApiPromotionsOffersRequest {
    /**
     * 
     */
    'id'?: number | null;
    /**
     * 
     */
    'title'?: string;
    /**
     * 
     */
    'active'?: boolean;
    /**
     * 
     */
    'price_from'?: number;
    /**
     * 
     */
    'price_to'?: number;
    /**
     * 
     */
    'id_from'?: number;
    /**
     * 
     */
    'id_to'?: number;
    /**
     * 
     */
    'sort_column'?: string;
    /**
     * 
     */
    'sort_type'?: GetApiPromotionsOffersRequestSortTypeEnum;
}

export const GetApiPromotionsOffersRequestSortTypeEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type GetApiPromotionsOffersRequestSortTypeEnum = typeof GetApiPromotionsOffersRequestSortTypeEnum[keyof typeof GetApiPromotionsOffersRequestSortTypeEnum];

export interface GetApiSettingsCurrenciesRequest {
    /**
     * 
     */
    'id'?: number;
}
export interface GetApiSettingsCurrencyIdRequest {
    /**
     * 
     */
    'id'?: number;
}
export interface GetApiSettingsPaymentModeIdRequest {
    /**
     * 
     */
    'id'?: number;
    /**
     * 
     */
    'active'?: boolean;
}
export interface GetApiSettingsPaymentModesRequest {
    /**
     * 
     */
    'id'?: number;
    /**
     * 
     */
    'active'?: boolean;
}
export interface GetApiShippingFlatRateIdRequest {
    /**
     * 
     */
    'id'?: number;
    /**
     * 
     */
    'active'?: boolean;
}
export interface GetApiShippingFlatRatesRequest {
    /**
     * 
     */
    'id'?: number;
    /**
     * 
     */
    'active'?: boolean;
}
export interface GetApiShippingShippingDetailUsernameRequest {
    /**
     * 
     */
    'username'?: string;
}
export interface GetApiShippingShippingDetailsRequest {
    /**
     * 
     */
    'username'?: string;
}
export interface GetApiShippingShippingServiceIdRequest {
    /**
     * 
     */
    'id'?: number;
    /**
     * 
     */
    'active'?: boolean;
}
export interface GetApiShippingShippingServicesRequest {
    /**
     * 
     */
    'id'?: number;
    /**
     * 
     */
    'active'?: boolean;
}
export interface GetApiUserPermissionsRequest {
    /**
     * Must not be greater than 100 characters.
     */
    'role'?: string | null;
    /**
     * 
     */
    'type'?: GetApiUserPermissionsRequestTypeEnum;
}

export const GetApiUserPermissionsRequestTypeEnum = {
    Cms: 'cms',
    Client: 'client'
} as const;

export type GetApiUserPermissionsRequestTypeEnum = typeof GetApiUserPermissionsRequestTypeEnum[keyof typeof GetApiUserPermissionsRequestTypeEnum];

export interface GetApiUserPermissionsRoleRequest {
    /**
     * Must not be greater than 100 characters.
     */
    'role'?: string | null;
    /**
     * 
     */
    'type'?: GetApiUserPermissionsRoleRequestTypeEnum;
}

export const GetApiUserPermissionsRoleRequestTypeEnum = {
    Cms: 'cms',
    Client: 'client'
} as const;

export type GetApiUserPermissionsRoleRequestTypeEnum = typeof GetApiUserPermissionsRoleRequestTypeEnum[keyof typeof GetApiUserPermissionsRoleRequestTypeEnum];

export interface GetBillingDetailsRequest {
    /**
     * 
     */
    'username'?: string;
}
export interface GetBillingDetailsRequest1 {
    /**
     * 
     */
    'username'?: string;
}
export interface GetFrontBannerIdRequest {
    /**
     * 
     */
    'id'?: number;
    /**
     * 
     */
    'list'?: number;
}
export interface GetFrontBanners200Response {
    'status'?: string;
    'type'?: string;
    'code'?: number;
    'messages'?: Array<string>;
    'data'?: Array<GetFrontBanners200ResponseDataInner>;
}
export interface GetFrontBanners200ResponseDataInner {
    'id'?: number;
    'type'?: string;
    'title'?: string;
    'subtitle'?: string;
    'status'?: number;
    'url'?: string;
    'short_description'?: string;
    'created_at'?: string;
    'updated_at'?: string;
    'images'?: Array<string>;
}
export interface GetFrontBannersRequest {
    /**
     * 
     */
    'id'?: number;
    /**
     * 
     */
    'list'?: number;
}
export interface GetFrontBrandId422Response {
    'message'?: string;
    'errors'?: GetFrontBrandId422ResponseErrors;
}
export interface GetFrontBrandId422ResponseErrors {
    'id'?: Array<string>;
}
export interface GetFrontBrandIdRequest {
    /**
     * 
     */
    'id'?: number | null;
    /**
     * 
     */
    'list'?: number;
}
export interface GetFrontBrands200Response {
    'status'?: string;
    'type'?: string;
    'code'?: number;
    'messages'?: Array<string>;
    'data'?: Array<GetFrontBrands200ResponseDataInner>;
}
export interface GetFrontBrands200ResponseDataInner {
    'id'?: number;
    'name'?: string;
}
export interface GetFrontBrandsRequest {
    /**
     * 
     */
    'id'?: number | null;
    /**
     * 
     */
    'list'?: number;
}
export interface GetFrontCategories200Response {
    'status'?: string;
    'type'?: string;
    'code'?: number;
    'messages'?: Array<string>;
    'data'?: Array<GetFrontCategories200ResponseDataInner>;
}
export interface GetFrontCategories200ResponseDataInner {
    'id'?: number;
    'name'?: string;
}
export interface GetFrontCategoriesRequest {
    /**
     * 
     */
    'id'?: number | null;
    /**
     * 
     */
    'list'?: number;
}
export interface GetFrontCategoryIdRequest {
    /**
     * 
     */
    'id'?: number | null;
    /**
     * 
     */
    'list'?: number;
}
export interface GetFrontFooterIdRequest {
    /**
     * 
     */
    'id'?: number;
    /**
     * 
     */
    'list'?: number;
}
export interface GetFrontFootersRequest {
    /**
     * 
     */
    'id'?: number;
    /**
     * 
     */
    'list'?: number;
}
export interface GetFrontMenuIdRequest {
    /**
     * 
     */
    'id'?: number;
    /**
     * 
     */
    'list'?: number;
}
export interface GetFrontMenusRequest {
    /**
     * 
     */
    'id'?: number;
    /**
     * 
     */
    'list'?: number;
}
export interface GetFrontProductIdRequest {
    /**
     * 
     */
    'id'?: number | null;
    /**
     * 
     */
    'name'?: string;
    /**
     * 
     */
    'brand'?: string;
    /**
     * 
     */
    'trending'?: boolean;
    /**
     * 
     */
    'price_from'?: number;
    /**
     * 
     */
    'price_to'?: number;
    /**
     * 
     */
    'list'?: number;
}
export interface GetFrontProducts200Response {
    'status'?: string;
    'type'?: string;
    'code'?: number;
    'messages'?: Array<string>;
    'data'?: Array<GetFrontProducts200ResponseDataInner>;
}
export interface GetFrontProducts200ResponseDataInner {
    'id'?: number;
    'name'?: string;
}
export interface GetFrontProductsRequest {
    /**
     * 
     */
    'id'?: number | null;
    /**
     * 
     */
    'name'?: string;
    /**
     * 
     */
    'brand'?: string;
    /**
     * 
     */
    'trending'?: boolean;
    /**
     * 
     */
    'price_from'?: number;
    /**
     * 
     */
    'price_to'?: number;
    /**
     * 
     */
    'list'?: number;
}
export interface GetFrontSeoIdRequest {
    /**
     * 
     */
    'id'?: number;
    /**
     * 
     */
    'list'?: number;
}
export interface GetFrontThemeActive500Response {
    'message'?: string;
    'exception'?: string;
    'file'?: string;
    'line'?: number;
    'trace'?: Array<GetFrontThemeActive500ResponseTraceInner>;
}
export interface GetFrontThemeActive500ResponseTraceInner {
    'file'?: string;
    'line'?: number;
    'function'?: string;
    'class'?: string;
    'type'?: string;
}
export interface GetUsers401Response {
    'message'?: string;
}
export interface GetUsersRequest {
    /**
     * 
     */
    'id'?: number | null;
}
export interface GetUsersRequest1 {
    /**
     * 
     */
    'id'?: number | null;
}
export interface GetV1BannersRequest {
    /**
     * 
     */
    'id'?: number;
    /**
     * 
     */
    'list'?: number;
}
export interface GetV1CountriesCountries200Response {
    'status'?: string;
    'type'?: string;
    'code'?: number;
    'messages'?: Array<string>;
    'data'?: Array<string>;
}
export interface GetV1CountriesCountryId422Response {
    'status'?: string;
    'type'?: string;
    'code'?: number;
    'messages'?: string;
    'data'?: Array<string>;
}
export interface GetV1FooterIdRequest {
    /**
     * 
     */
    'id'?: number;
    /**
     * 
     */
    'list'?: number;
}
export interface GetV1FootersRequest {
    /**
     * 
     */
    'id'?: number;
    /**
     * 
     */
    'list'?: number;
}
export interface GetV1MenuIdRequest {
    /**
     * 
     */
    'id'?: number;
    /**
     * 
     */
    'list'?: number;
}
export interface GetV1MenusRequest {
    /**
     * 
     */
    'id'?: number;
    /**
     * 
     */
    'list'?: number;
}
export interface GetV1TestPing200Response {
    'pong'?: number;
}
export interface GetV1VerifyResetPasswordToken400Response {
    'status'?: string;
    'type'?: string;
    'code'?: number;
    'messages'?: string;
    'data'?: Array<string>;
}
export interface PostApiAccountsUserCreateRequest {
    /**
     * Must not be greater than 100 characters.
     */
    'first_name': string;
    /**
     * Must not be greater than 100 characters.
     */
    'last_name': string;
    /**
     * Must not be greater than 100 characters.
     */
    'username': string;
    /**
     * 
     */
    'role': object;
    /**
     * Must be a valid email address.
     */
    'email': string;
    /**
     * 
     */
    'image_id'?: number;
    /**
     * 
     */
    'user_group'?: number;
    /**
     * 
     */
    'active'?: boolean;
}
export interface PostApiAccountsUserDeleteRequest {
    /**
     * 
     */
    'id': number;
}
export interface PostApiAccountsUserUpdateIdRequest {
    /**
     * 
     */
    'id': number;
    /**
     * Must not be greater than 100 characters.
     */
    'first_name'?: string;
    /**
     * Must not be greater than 100 characters.
     */
    'last_name'?: string;
    /**
     * 
     */
    'role'?: object;
    /**
     * Must be a valid email address.
     */
    'email'?: string;
    /**
     * 
     */
    'image_id'?: string | null;
    /**
     * 
     */
    'user_group'?: number;
    /**
     * 
     */
    'active'?: boolean;
}
export interface PostApiAmazonSettingsUpdateRequest {
    /**
     * 
     */
    'amazon_marketplace_seller_id'?: string | null;
    /**
     * 
     */
    'amazon_marketplace_mws_auth_token'?: string | null;
}
export interface PostApiAramexSettingsUpdateRequest {
    /**
     * 
     */
    'aramex_username'?: string | null;
    /**
     * 
     */
    'aramex_password'?: string | null;
    /**
     * 
     */
    'aramex_pin'?: string | null;
    /**
     * 
     */
    'aramex_account_number'?: string | null;
    /**
     * 
     */
    'aramex_account_pin'?: string | null;
    /**
     * 
     */
    'aramex_account_entity'?: string | null;
    /**
     * 
     */
    'aramex_account_country_code'?: string | null;
}
export interface PostApiAttributesSeoCreateRequest {
    /**
     * Must be a valid URL.
     */
    'url': string;
    /**
     * 
     */
    'meta_title': string;
    /**
     * 
     */
    'meta_keyword': string;
    /**
     * 
     */
    'meta_description': string;
}
export interface PostApiAttributesSeoUpdateIdRequest {
    /**
     * Must be a valid URL.
     */
    'url': string;
    /**
     * 
     */
    'meta_title': string;
    /**
     * 
     */
    'meta_keyword': string;
    /**
     * 
     */
    'meta_description': string;
}
export interface PostApiBillingBillingDetailsCreateRequest {
    /**
     * Must not be greater than 100 characters.
     */
    'name': string;
    /**
     * Must not be greater than 100 characters.
     */
    'company'?: string;
    /**
     * Must not be greater than 150 characters.
     */
    'address_1': string;
    /**
     * Must not be greater than 150 characters.
     */
    'address_2'?: string;
    /**
     * Must not be greater than 50 characters.
     */
    'city': string;
    /**
     * Must not be greater than 50.
     */
    'uae_id': number;
    /**
     * Must not be greater than 50 characters.
     */
    'post_code': string;
    /**
     * 
     */
    'save'?: boolean;
}
export interface PostApiBillingBillingDetailsDeleteRequest {
    /**
     * 
     */
    'id': number;
}
export interface PostApiBillingBillingDetailsUpdateRequest {
    /**
     * 
     */
    'id': number;
    /**
     * Must not be greater than 100 characters.
     */
    'name'?: string;
    /**
     * Must not be greater than 100 characters.
     */
    'company'?: string;
    /**
     * Must not be greater than 150 characters.
     */
    'address_1'?: string;
    /**
     * Must not be greater than 150 characters.
     */
    'address_2'?: string;
    /**
     * Must not be greater than 50 characters.
     */
    'city'?: string;
    /**
     * Must not be greater than 50.
     */
    'uae_id'?: number;
    /**
     * Must not be greater than 50 characters.
     */
    'post_code'?: string;
    /**
     * 
     */
    'save'?: boolean;
}
export interface PostApiBillingCreditCreateRequest {
    /**
     * 
     */
    'amount': number;
    /**
     * 
     */
    'active'?: boolean;
    /**
     * Must be a valid date.
     */
    'expiration_data'?: string;
}
export interface PostApiBillingCreditDeleteRequest {
    /**
     * 
     */
    'id': number;
}
export interface PostApiBillingCreditUpdateRequest {
    /**
     * 
     */
    'id': number;
    /**
     * 
     */
    'user_id'?: number;
    /**
     * 
     */
    'amount'?: number;
    /**
     * 
     */
    'active'?: boolean;
    /**
     * Must be a valid date.
     */
    'expiration_data'?: string;
}
export interface PostApiCartAddRequest {
    /**
     * The <code>id</code> of an existing record in the products table.
     */
    'product_id'?: Array<number>;
    /**
     * Must be at least 1. Must not be greater than 100.
     */
    'quantity'?: number;
    /**
     * 
     */
    'attributes'?: object;
    /**
     * 
     */
    'update_mode'?: PostApiCartAddRequestUpdateModeEnum;
}

export const PostApiCartAddRequestUpdateModeEnum = {
    Increment: 'increment',
    Replace: 'replace',
    Max: 'max'
} as const;

export type PostApiCartAddRequestUpdateModeEnum = typeof PostApiCartAddRequestUpdateModeEnum[keyof typeof PostApiCartAddRequestUpdateModeEnum];

export interface PostApiCatalogAttributeCreateRequest {
    /**
     * Must not be greater than 50 characters.
     */
    'name': string;
    /**
     * Must not be greater than 50 characters.
     */
    'code': string;
    /**
     * 
     */
    'type': PostApiCatalogAttributeCreateRequestTypeEnum;
    /**
     * 
     */
    'is_filterable'?: boolean;
    /**
     * 
     */
    'is_searchable'?: boolean;
    /**
     * 
     */
    'active'?: boolean;
}

export const PostApiCatalogAttributeCreateRequestTypeEnum = {
    Text: 'text',
    Textarea: 'textarea',
    Price: 'price',
    Boolean: 'boolean',
    Select: 'select',
    Date: 'date'
} as const;

export type PostApiCatalogAttributeCreateRequestTypeEnum = typeof PostApiCatalogAttributeCreateRequestTypeEnum[keyof typeof PostApiCatalogAttributeCreateRequestTypeEnum];

export interface PostApiCatalogAttributeUpdateRequest {
    /**
     * 
     */
    'id': number;
    /**
     * Must not be greater than 50 characters.
     */
    'name'?: string;
    /**
     * Must not be greater than 50 characters.
     */
    'code'?: string;
    /**
     * 
     */
    'type'?: PostApiCatalogAttributeUpdateRequestTypeEnum;
    /**
     * 
     */
    'is_filterable'?: boolean;
    /**
     * 
     */
    'is_searchable'?: boolean;
    /**
     * 
     */
    'active'?: boolean;
}

export const PostApiCatalogAttributeUpdateRequestTypeEnum = {
    Text: 'text',
    Textarea: 'textarea',
    Price: 'price',
    Boolean: 'boolean',
    Select: 'select',
    Date: 'date'
} as const;

export type PostApiCatalogAttributeUpdateRequestTypeEnum = typeof PostApiCatalogAttributeUpdateRequestTypeEnum[keyof typeof PostApiCatalogAttributeUpdateRequestTypeEnum];

export interface PostApiCatalogAttributeDeleteRequest {
    /**
     * 
     */
    'id': number;
}

export interface PostApiCatalogAttributeValueCreateRequest {
    /**
     * Must not be greater than 50 characters.
     */
    'name': string;
    /**
     * The <code>id</code> of an existing record in the attributes table.
     */
    'attribute_id': number;
}
export interface PostApiCatalogAttributeValueDeleteRequest {
    /**
     * 
     */
    'id': number;
}
export interface PostApiCatalogAttributeValueUpdateRequest {
    /**
     * 
     */
    'id': number;
    /**
     * Must not be greater than 50 characters.
     */
    'name'?: string;
    /**
     * 
     */
    'attribute_id': number;
}
export interface PostApiCatalogBrandCreateRequest {
    /**
     * Must not be greater than 50 characters.
     */
    'name': string;
    /**
     * 
     */
    'description'?: string;
    /**
     * 
     */
    'top'?: boolean;
    /**
     * 
     */
    'image_id'?: number;
    /**
     * 
     */
    'sort'?: number;
    /**
     * 
     */
    'active'?: boolean;
    /**
     * 
     */
    'show_home'?: boolean;
    /**
     * Must not be greater than 100 characters.
     */
    'slug'?: string | null;
}
export interface PostApiCatalogBrandUpdateRequest {
    /**
     * 
     */
    'id': number;
    /**
     * Must not be greater than 50 characters.
     */
    'name'?: string;
    /**
     * 
     */
    'description'?: string;
    /**
     * 
     */
    'top'?: boolean;
    /**
     * 
     */
    'image_id'?: number;
    /**
     * 
     */
    'sort'?: number;
    /**
     * 
     */
    'active'?: boolean;
    /**
     * 
     */
    'show_home'?: boolean;
    /**
     * Must not be greater than 100 characters.
     */
    'slug'?: string;
}

export interface PostApiCatalogBrandDeleteRequest {
    /**
     * 
     */
    'id': number;
}

export interface PostApiCatalogCategoryCreateRequest {
    /**
     * 
     */
    'name'?: string | null;
    /**
     * 
     */
    'label'?: string | null;
    /**
     * 
     */
    'parent_id'?: number | null;
    /**
     * 
     */
    'description'?: string | null;
    /**
     * 
     */
    'top'?: boolean | null;
    /**
     * The <code>id</code> of an existing record in the files table.
     */
    'image_id'?: number | null;
    /**
     * 
     */
    'sort'?: number | null;
    /**
     * 
     */
    'active'?: boolean | null;
    /**
     * Must not be greater than 100 characters.
     */
    'slug'?: string | null;
    /**
     * The <code>id</code> of an existing record in the seo table.
     */
    'seo_id'?: number | null;
}
export interface PostApiCatalogCategoryDeleteRequest {
    /**
     * 
     */
    'id': number;
}
export interface PostApiCatalogCategoryUpdateRequest {
    /**
     * 
     */
    'id': number;
    /**
     * 
     */
    'name'?: string | null;
    /**
     * 
     */
    'label'?: string | null;
    /**
     * 
     */
    'parent_id'?: number | null;
    /**
     * 
     */
    'description'?: string | null;
    /**
     * 
     */
    'top'?: boolean | null;
    /**
     * The <code>id</code> of an existing record in the files table.
     */
    'image_id'?: number | null;
    /**
     * 
     */
    'sort'?: number | null;
    /**
     * 
     */
    'active'?: boolean | null;
    /**
     * Must not be greater than 100 characters.
     */
    'slug'?: string | null;
    /**
     * The <code>id</code> of an existing record in the seo table.
     */
    'seo_id'?: string | null;
}
export interface PostApiCatalogProductAttributesCreateRequest {
    /**
     * 
     */
    'attribute_values': object;
    /**
     * The <code>id</code> of an existing record in the products table.
     */
    'product_id': number;
    /**
     * 
     */
    'qty': number;
    /**
     * 
     */
    'price': number;
}
export interface PostApiCatalogProductAttributesDeleteRequest {
    /**
     * 
     */
    'id': number;
    /**
     * The <code>id</code> of an existing record in the products table.
     */
    'product_id': number;
}
export interface PostApiCatalogProductAttributesUpdateRequest {
    /**
     * 
     */
    'id': number;
    /**
     * 
     */
    'attribute_values': object;
    /**
     * The <code>id</code> of an existing record in the products table.
     */
    'product_id': number;
    /**
     * 
     */
    'qty': number;
    /**
     * 
     */
    'price': number;
}
export interface PostApiCatalogProductCreateRequest {
    /**
     * This field is required when <code>qty</code> is not present.
     */
    'quantity'?: number;
    /**
     * 
     */
    'qty'?: number | null;
    /**
     * 
     */
    'product_type': PostApiCatalogProductCreateRequestProductTypeEnum;
    /**
     * 
     */
    'brand_id': number;
    /**
     * 
     */
    'categories_id': object;
    /**
     * 
     */
    'name': string;
    /**
     * 
     */
    'rate'?: boolean;
    /**
     * 
     */
    'trending'?: boolean;
    /**
     * 
     */
    'price': number;
    /**
     * 
     */
    'active'?: boolean;
    /**
     * 
     */
    'store_id'?: object;
    /**
     * 
     */
    'tags_id'?: object;
    /**
     * 
     */
    'description'?: string;
    /**
     * 
     */
    'images'?: object | null;
    /**
     * Must not be greater than 100 characters.
     */
    'voucher_code'?: string;
    /**
     * Must be a valid date.
     */
    'voucher_validity'?: string;
    /**
     * 
     */
    'related_products'?: object | null;
    /**
     * 
     */
    'recommended_products'?: object | null;
    /**
     * Must not be greater than 100 characters.
     */
    'slug'?: string | null;
    /**
     * The <code>id</code> of an existing record in the seo table.
     */
    'seo_id'?: number;
    /**
     * 
     */
    'sku': string;
    /**
     * 
     */
    'model_no'?: string | null;
    /**
     * 
     */
    'item_weight'?: number | null;
    /**
     * 
     */
    'length'?: string | null;
    /**
     * 
     */
    'height'?: string | null;
    /**
     * 
     */
    'width'?: string | null;
    /**
     * 
     */
    'short_description'?: string | null;
    /**
     * 
     */
    'main_description'?: string | null;
    /**
     * 
     */
    'overview_title'?: string | null;
    /**
     * 
     */
    'overview_sub'?: string | null;
    /**
     * 
     */
    'overview_desc'?: string | null;
    /**
     * 
     */
    'highlights'?: string | null;
    /**
     * 
     */
    'support'?: string | null;
    /**
     * Must be a valid URL.
     */
    'video_url'?: string | null;
    /**
     * 
     */
    'video_image_url'?: string | null;
    /**
     * 
     */
    'youtube_code'?: string | null;
    /**
     * Must be a valid URL.
     */
    'youtube_url'?: string | null;
    /**
     * 
     */
    '360_view'?: string | null;
    /**
     * 
     */
    'no_days'?: number | null;
    /**
     * 
     */
    'offer'?: string | null;
    /**
     * 
     */
    'offer_price'?: number | null;
    /**
     * 
     */
    'credit_price'?: number | null;
    /**
     * 
     */
    'voucher_price'?: number | null;
    /**
     * 
     */
    'offer_desc'?: string | null;
    /**
     * Must be a valid date.
     */
    'from_date'?: string | null;
    /**
     * Must be a valid date.
     */
    'to_date'?: string | null;
    /**
     * 
     */
    'new'?: boolean | null;
    /**
     * 
     */
    'new_text'?: string | null;
    /**
     * 
     */
    'sort'?: number | null;
    /**
     * 
     */
    'offer_sort'?: number | null;
    /**
     * 
     */
    'cod_status'?: number | null;
    /**
     * 
     */
    'is_installation'?: boolean | null;
    /**
     * 
     */
    'installation_price'?: number | null;
    /**
     * 
     */
    'courier_price'?: number | null;
    /**
     * 
     */
    'best_buy'?: boolean | null;
    /**
     * 
     */
    'unit'?: number | null;
    /**
     * 
     */
    'base_check'?: number | null;
    /**
     * 
     */
    'base_prodid'?: number | null;
    /**
     * 
     */
    'peices'?: number | null;
    /**
     * 
     */
    'is_indexed'?: boolean | null;
    /**
     * 
     */
    'object_id'?: string | null;
    /**
     * 
     */
    'add_info'?: string | null;
    /**
     * 
     */
    'alt_name'?: string | null;
    /**
     * 
     */
    'item_code'?: string | null;
    /**
     * 
     */
    'delete_status'?: boolean | null;
    /**
     * 
     */
    'shipping'?: boolean | null;
    /**
     * 
     */
    'special_price'?: number | null;
    /**
     * Must be a valid date.
     */
    'special_price_start_date'?: string | null;
    /**
     * Must be a valid date.
     */
    'special_price_end_date'?: string | null;
    /**
     * 
     */
    'special_price_flag'?: boolean | null;
}

export const PostApiCatalogProductCreateRequestProductTypeEnum = {
    Configurable: 'configurable',
    Simple: 'simple'
} as const;

export type PostApiCatalogProductCreateRequestProductTypeEnum = typeof PostApiCatalogProductCreateRequestProductTypeEnum[keyof typeof PostApiCatalogProductCreateRequestProductTypeEnum];

export interface PostApiCatalogProductDeleteRequest {
    /**
     * 
     */
    'id': number;
}
export interface PostApiCatalogProductUpdateRequest {
    /**
     * 
     */
    'id': number;
    /**
     * This field is required when <code>qty</code> is not present.
     */
    'quantity'?: number;
    /**
     * 
     */
    'qty'?: number | null;
    /**
     * 
     */
    'brand_id': number;
    /**
     * 
     */
    'categories_id': object;
    /**
     * 
     */
    'name': string;
    /**
     * 
     */
    'rate'?: boolean;
    /**
     * 
     */
    'trending'?: boolean;
    /**
     * 
     */
    'price': number;
    /**
     * 
     */
    'active'?: boolean;
    /**
     * 
     */
    'store_id'?: object;
    /**
     * 
     */
    'tags_id'?: object;
    /**
     * 
     */
    'description'?: string;
    /**
     * 
     */
    'images'?: object | null;
    /**
     * Must not be greater than 100 characters.
     */
    'voucher_code'?: string;
    /**
     * Must be a valid date.
     */
    'voucher_validity'?: string;
    /**
     * 
     */
    'related_products'?: object | null;
    /**
     * 
     */
    'recommended_products'?: object | null;
    /**
     * Must not be greater than 100 characters.
     */
    'slug'?: string | null;
    /**
     * The <code>id</code> of an existing record in the seo table.
     */
    'seo_id'?: number;
    /**
     * 
     */
    'sku': string;
    /**
     * 
     */
    'product_type': PostApiCatalogProductUpdateRequestProductTypeEnum;
    /**
     * 
     */
    'model_no'?: string | null;
    /**
     * 
     */
    'item_weight'?: number | null;
    /**
     * 
     */
    'length'?: string | null;
    /**
     * 
     */
    'height'?: string | null;
    /**
     * 
     */
    'width'?: string | null;
    /**
     * 
     */
    'short_description'?: string | null;
    /**
     * 
     */
    'main_description'?: string | null;
    /**
     * 
     */
    'overview_title'?: string | null;
    /**
     * 
     */
    'overview_sub'?: string | null;
    /**
     * 
     */
    'overview_desc'?: string | null;
    /**
     * 
     */
    'highlights'?: string | null;
    /**
     * 
     */
    'support'?: string | null;
    /**
     * Must be a valid URL.
     */
    'video_url'?: string | null;
    /**
     * 
     */
    'video_image_url'?: string | null;
    /**
     * 
     */
    'youtube_code'?: string | null;
    /**
     * Must be a valid URL.
     */
    'youtube_url'?: string | null;
    /**
     * 
     */
    '360_view'?: string | null;
    /**
     * 
     */
    'no_days'?: number | null;
    /**
     * 
     */
    'offer'?: string | null;
    /**
     * 
     */
    'offer_price'?: number | null;
    /**
     * 
     */
    'credit_price'?: number | null;
    /**
     * 
     */
    'voucher_price'?: number | null;
    /**
     * 
     */
    'offer_desc'?: string | null;
    /**
     * Must be a valid date.
     */
    'from_date'?: string | null;
    /**
     * Must be a valid date.
     */
    'to_date'?: string | null;
    /**
     * 
     */
    'new'?: boolean | null;
    /**
     * 
     */
    'new_text'?: string | null;
    /**
     * 
     */
    'sort'?: number | null;
    /**
     * 
     */
    'offer_sort'?: number | null;
    /**
     * 
     */
    'cod_status'?: number | null;
    /**
     * 
     */
    'is_installation'?: boolean | null;
    /**
     * 
     */
    'installation_price'?: number | null;
    /**
     * 
     */
    'courier_price'?: number | null;
    /**
     * 
     */
    'best_buy'?: boolean | null;
    /**
     * 
     */
    'unit'?: number | null;
    /**
     * 
     */
    'base_check'?: number | null;
    /**
     * 
     */
    'base_prodid'?: number | null;
    /**
     * 
     */
    'peices'?: number | null;
    /**
     * 
     */
    'is_indexed'?: boolean | null;
    /**
     * 
     */
    'object_id'?: string | null;
    /**
     * 
     */
    'add_info'?: string | null;
    /**
     * 
     */
    'alt_name'?: string | null;
    /**
     * 
     */
    'item_code'?: string | null;
    /**
     * 
     */
    'delete_status'?: boolean | null;
    /**
     * 
     */
    'shipping'?: boolean | null;
    /**
     * 
     */
    'special_price'?: number | null;
    /**
     * Must be a valid date.
     */
    'special_price_start_date'?: string | null;
    /**
     * Must be a valid date.
     */
    'special_price_end_date'?: string | null;
    /**
     * 
     */
    'special_price_flag'?: boolean | null;
}

export const PostApiCatalogProductUpdateRequestProductTypeEnum = {
    Simple: 'simple',
    Configurable: 'configurable'
} as const;

export type PostApiCatalogProductUpdateRequestProductTypeEnum = typeof PostApiCatalogProductUpdateRequestProductTypeEnum[keyof typeof PostApiCatalogProductUpdateRequestProductTypeEnum];

export interface PostApiCatalogStoreCreateRequest {
    /**
     * 
     */
    'name': string;
    /**
     * 
     */
    'description'?: string;
    /**
     * 
     */
    'address'?: string;
    /**
     * Must be a valid JSON string.
     */
    'coordinates'?: string;
    /**
     * 
     */
    'sort'?: boolean;
    /**
     * 
     */
    'active'?: boolean;
    /**
     * 
     */
    'show_home'?: boolean;
    /**
     * Must not be greater than 100 characters.
     */
    'slug'?: string | null;
}
export interface PostApiCatalogStoreDeleteRequest {
    /**
     * 
     */
    'id': number;
}
export interface PostApiCatalogStoreUpdateRequest {
    /**
     * 
     */
    'id': number;
    /**
     * 
     */
    'name'?: string;
    /**
     * 
     */
    'description'?: string;
    /**
     * 
     */
    'address'?: string;
    /**
     * Must be a valid JSON string.
     */
    'coordinates'?: string;
    /**
     * 
     */
    'sort'?: number;
    /**
     * 
     */
    'active'?: boolean;
    /**
     * 
     */
    'show_home'?: boolean;
    /**
     * Must not be greater than 100 characters.
     */
    'slug'?: string;
}
export interface PostApiCatalogTagCreateRequest {
    /**
     * 
     */
    'name': string;
    /**
     * 
     */
    'active'?: boolean;
    /**
     * 
     */
    'sort'?: number;
}
export interface PostApiCatalogTagDeleteRequest {
    /**
     * 
     */
    'id': number;
}
export interface PostApiCatalogTagUpdateRequest {
    /**
     * 
     */
    'id': number;
    /**
     * 
     */
    'name'?: string;
    /**
     * 
     */
    'active'?: boolean;
    /**
     * 
     */
    'sort'?: number;
}
export interface PostApiCommunicationsNewsletterCreateRequest {
    /**
     * 
     */
    'name': string;
    /**
     * Must not be greater than 100 characters.
     */
    'title'?: string;
    /**
     * 
     */
    'content'?: string;
    /**
     * 
     */
    'image_id'?: object;
}
export interface PostApiCommunicationsNewsletterDeleteRequest {
    /**
     * 
     */
    'id': number;
}
export interface PostApiCommunicationsNewsletterUpdateRequest {
    /**
     * 
     */
    'id': number;
    /**
     * 
     */
    'name'?: string;
    /**
     * Must not be greater than 100 characters.
     */
    'title'?: string;
    /**
     * 
     */
    'content'?: string;
    /**
     * 
     */
    'image_id'?: object;
}
export interface PostApiCommunicationsSubscriberCreateRequest {
    /**
     * Must be a valid email address.
     */
    'email': string;
    /**
     * 
     */
    'active'?: boolean;
}
export interface PostApiCommunicationsSubscriberUpdateRequest {
    /**
     * 
     */
    'id': number;
    /**
     * 
     */
    'active'?: boolean;
    /**
     * Must be a valid email address.
     */
    'email': string;
}
export interface PostApiContentPageCreateRequest {
    /**
     * 
     */
    'name': string;
    /**
     * 
     */
    'slug'?: string;
    /**
     * Must not be greater than 100 characters.
     */
    'title'?: string;
    /**
     * 
     */
    'content'?: string;
    /**
     * 
     */
    'is_published'?: boolean;
    /**
     * 
     */
    'image_id'?: object;
}
export interface PostApiContentPageDeleteRequest {
    /**
     * 
     */
    'id': number;
}
export interface PostApiContentPageUpdateRequest {
    /**
     * 
     */
    'id': number;
    /**
     * 
     */
    'name'?: string;
    /**
     * 
     */
    'slug'?: string;
    /**
     * Must not be greater than 100 characters.
     */
    'title'?: string;
    /**
     * 
     */
    'content'?: string;
    /**
     * 
     */
    'is_published'?: boolean;
    /**
     * 
     */
    'image_id'?: object;
}
export interface PostApiInstashopSettingsUpdateRequest {
    /**
     * 
     */
    'instashop_api_key'?: string | null;
    /**
     * 
     */
    'instashop_secret_key'?: string | null;
}
export interface PostApiInvoicesSettingsCreateRequest {
    /**
     * Must not be greater than 50 characters.
     */
    'name': string;
    /**
     * Must not be greater than 5 characters.
     */
    'currency_code'?: string;
    /**
     * Must not be greater than 3 characters.
     */
    'currency_symbol'?: string;
    /**
     * Must not be greater than 50 characters.
     */
    'currency_format'?: string;
    /**
     * Must not be greater than 255 characters.
     */
    'notes'?: string;
    /**
     * 
     */
    'active'?: boolean;
    /**
     * 
     */
    'image_id'?: number;
}
export interface PostApiInvoicesSettingsDeleteRequest {
    /**
     * 
     */
    'id': number;
}
export interface PostApiInvoicesSettingsUpdateRequest {
    /**
     * 
     */
    'id': number;
    /**
     * Must not be greater than 50 characters.
     */
    'name'?: string;
    /**
     * Must not be greater than 5 characters.
     */
    'currency_code'?: string;
    /**
     * Must not be greater than 3 characters.
     */
    'currency_symbol'?: string;
    /**
     * Must not be greater than 50 characters.
     */
    'currency_format'?: string;
    /**
     * Must not be greater than 255 characters.
     */
    'notes'?: string;
    /**
     * 
     */
    'active'?: boolean;
    /**
     * 
     */
    'image_id'?: number;
}
export interface PostApiMediaFileDeleteRequest {
    /**
     * 
     */
    'id': number;
}
export interface PostApiMediaFileUpdateIdRequest {
    /**
     * Must not be greater than 50 characters.
     */
    'title'?: string;
    /**
     * Must not be greater than 255 characters.
     */
    'description'?: string;
}
export interface PostApiMediaFileUploadRequest {
    /**
     * Must not be greater than 100000 characters.
     */
    'file': string;
    /**
     * Must not be greater than 50 characters.
     */
    'folder': PostApiMediaFileUploadRequestFolderEnum;
}

export const PostApiMediaFileUploadRequestFolderEnum = {
    Pages: 'pages',
    Products: 'products',
    Brands: 'brands',
    Categories: 'categories',
    Banners: 'banners',
    Footers: 'footers',
    Users: 'users'
} as const;

export type PostApiMediaFileUploadRequestFolderEnum = typeof PostApiMediaFileUploadRequestFolderEnum[keyof typeof PostApiMediaFileUploadRequestFolderEnum];

export interface PostApiNoonSettingsUpdateRequest {
    /**
     * 
     */
    'noon_marketplace_partner_code'?: string | null;
    /**
     * 
     */
    'noon_marketplace_bearer_token'?: string | null;
}
export interface PostApiOrdersOrderCreateRequest {
    /**
     * 
     */
    'user_id': number;
    /**
     * 
     */
    'status_id': number;
    /**
     * 
     */
    'payment_mode_id': number;
    /**
     * Must be a valid email address.
     */
    'email': string;
    /**
     * Must not be greater than 50 characters.
     */
    'mobile_number': string;
    /**
     * Must not be greater than 50 characters.
     */
    'landline_number'?: string | null;
    /**
     * Must not be greater than 50 characters.
     */
    'comments'?: string | null;
    /**
     * 
     */
    'billing': object;
    /**
     * 
     */
    'shipping_mode_id': number;
    /**
     * 
     */
    'shipping'?: object | null;
    /**
     * 
     */
    'product_id': object;
    /**
     * 
     */
    'product_quantity': object;
    /**
     * 
     */
    'discount_amount'?: number;
    /**
     * 
     */
    'transaction'?: string;
}

export interface PostApiOrdersOrderDeleteRequest {
    /**
     * 
     */
    'id': number;
}

export interface PostApiOrdersOrderUpdateIdRequest {
    /**
     * 
     */
    'id': number;
    /**
     * 
     */
    'user_id'?: number;
    /**
     * 
     */
    'status_id'?: number;
    /**
     * 
     */
    'payment_mode_id'?: number;
    /**
     * Must be a valid email address.
     */
    'email'?: string;
    /**
     * Must not be greater than 50 characters.
     */
    'mobile_number'?: string | null;
    /**
     * Must not be greater than 50 characters.
     */
    'landline_number'?: string | null;
    /**
     * Must not be greater than 255 characters.
     */
    'comments'?: string | null;
    /**
     * 
     */
    'billing'?: object;
    /**
     * 
     */
    'shipping_mode_id'?: number;
    /**
     * 
     */
    'shipping'?: object | null;
    /**
     * 
     */
    'product_id'?: object;
    /**
     * 
     */
    'product_quantity'?: object;
    /**
     * 
     */
    'discount_amount'?: number;
    /**
     * 
     */
    'transaction'?: string;
}
export interface PostApiOrdersStatusCreateRequest {
    /**
     * Must not be greater than 255 characters.
     */
    'name': string;
    /**
     * 
     */
    'description': string;
}
export interface PostApiOrdersStatusDeleteRequest {
    /**
     * The <code>id</code> of an existing record in the order_statuses table.
     */
    'id': number;
}
export interface PostApiOrdersStatusUpdateRequest {
    /**
     * The <code>id</code> of an existing record in the orders_status table.
     */
    'id': string;
    /**
     * Must not be greater than 255 characters.
     */
    'name': string;
}
export interface PostApiPaymentInitiateRequest {
    /**
     * Must be at least 0.01.
     */
    'amount': number;
    /**
     * 
     */
    'payment_method'?: string | null;
}
export interface PostApiPromotionsCodeCreateRequest {
    /**
     * 
     */
    'code': string;
    /**
     * 
     */
    'description'?: string;
    /**
     * 
     */
    'amount'?: number;
    /**
     * 
     */
    'percentage'?: number;
    /**
     * 
     */
    'total'?: number;
    /**
     * 
     */
    'qty'?: number;
    /**
     * 
     */
    'active'?: boolean;
    /**
     * Must be a valid date.
     */
    'expiration_data'?: string;
}
export interface PostApiPromotionsCodeDeleteRequest {
    /**
     * 
     */
    'id': number;
}
export interface PostApiPromotionsCodeUpdateIdRequest {
    /**
     * 
     */
    'id': number;
    /**
     * 
     */
    'code'?: string;
    /**
     * 
     */
    'description'?: string;
    /**
     * 
     */
    'amount'?: number;
    /**
     * 
     */
    'percentage'?: number;
    /**
     * 
     */
    'total'?: number;
    /**
     * 
     */
    'qty'?: number;
    /**
     * 
     */
    'active'?: boolean;
    /**
     * Must be a valid date.
     */
    'expiration_data'?: string;
}
export interface PostApiPromotionsOfferCreateRequest {
    /**
     * 
     */
    'code'?: string;
    /**
     * 
     */
    'title': string;
    /**
     * 
     */
    'description'?: string;
    /**
     * 
     */
    'products'?: object;
    /**
     * 
     */
    'price': number;
    /**
     * 
     */
    'percentage_off'?: number;
    /**
     * 
     */
    'total_off'?: number;
    /**
     * 
     */
    'qty'?: number;
    /**
     * 
     */
    'active'?: boolean;
    /**
     * Must be a valid date.
     */
    'expiration_data'?: string;
    /**
     * 
     */
    'image_id'?: number;
    /**
     * 
     */
    'tags'?: object;
    /**
     * 
     */
    'slug'?: string;
}
export interface PostApiPromotionsOfferUpdateIdRequest {
    /**
     * 
     */
    'id': number;
    /**
     * 
     */
    'code'?: string;
    /**
     * 
     */
    'title'?: string;
    /**
     * 
     */
    'description'?: string;
    /**
     * 
     */
    'products'?: object;
    /**
     * 
     */
    'price'?: number;
    /**
     * 
     */
    'percentage_off'?: number;
    /**
     * 
     */
    'total_off'?: number;
    /**
     * 
     */
    'qty'?: number;
    /**
     * 
     */
    'active'?: boolean;
    /**
     * Must be a valid date.
     */
    'expiration_data'?: string;
    /**
     * 
     */
    'image_id'?: number;
    /**
     * 
     */
    'tags'?: object;
    /**
     * 
     */
    'slug'?: string;
}
export interface PostApiSettingsCcavenueSettingsUpdateRequest {
    /**
     * 
     */
    'sandbox_mode': boolean;
    /**
     * 
     */
    'merchant_id': string;
    /**
     * 
     */
    'access_code': string;
    /**
     * 
     */
    'working_key': string;
}
export interface PostApiSettingsCurrencyCreateRequest {
    /**
     * Must not be greater than 50 characters.
     */
    'name': string;
    /**
     * Must not be greater than 10 characters.
     */
    'symbol'?: string;
    /**
     * 
     */
    'active'?: boolean | null;
}
export interface PostApiSettingsCurrencyUpdateRequest {
    /**
     * 
     */
    'id': number;
    /**
     * Must not be greater than 50 characters.
     */
    'name'?: string;
    /**
     * Must not be greater than 10 characters.
     */
    'symbol'?: string;
    /**
     * 
     */
    'active'?: boolean;
}
export interface PostApiSettingsNetworkSettingsUpdateRequest {
    /**
     * 
     */
    'sandbox_mode': boolean;
    /**
     * 
     */
    'api_key': string;
    /**
     * 
     */
    'outlet_id': string;
    /**
     * 
     */
    'realm': string;
}
export interface PostApiSettingsOnlinePaymentGatewayActivateIdRequest {
    /**
     * 
     */
    'active': boolean;
}
export interface PostApiSettingsPayfortSettingsUpdateRequest {
    /**
     * 
     */
    'sandbox': boolean;
    /**
     * 
     */
    'merchant_identifier': string;
    /**
     * 
     */
    'access_code': string;
    /**
     * 
     */
    'sha_request_phrase': string;
    /**
     * 
     */
    'sha_response_phrase': string;
    /**
     * 
     */
    'return_url': string;
}
export interface PostApiSettingsPaymentModeCreateRequest {
    /**
     * Must not be greater than 50 characters.
     */
    'name': string;
    /**
     * Must not be greater than 50 characters.
     */
    'label'?: string;
    /**
     * 
     */
    'description'?: string;
    /**
     * 
     */
    'image_id'?: number;
    /**
     * Must not be greater than 100 characters.
     */
    'slug'?: string | null;
    /**
     * 
     */
    'active'?: boolean | null;
}
export interface PostApiSettingsPaymentModeUpdateRequest {
    /**
     * 
     */
    'id': number;
    /**
     * Must not be greater than 50 characters.
     */
    'name'?: string;
    /**
     * Must not be greater than 50 characters.
     */
    'label'?: string;
    /**
     * 
     */
    'description'?: string;
    /**
     * 
     */
    'image_id'?: number;
    /**
     * Must not be greater than 100 characters.
     */
    'slug'?: string;
    /**
     * 
     */
    'active'?: boolean;
}

export interface PostApiSettingsPaymentModeDeleteRequest {
    /**
     * 
     */
    'id': number;
}

export interface PostApiSettingsPaypalSettingsUpdateRequest {
    /**
     * This field is required when <code>paypal_sandbox_client_secret</code> is present.
     */
    'paypal_sandbox_client_id'?: string | null;
    /**
     * This field is required when <code>paypal_sandbox_client_id</code> is present.
     */
    'paypal_sandbox_client_secret'?: string | null;
    /**
     * This field is required when <code>paypal_live_client_secret</code> is present.
     */
    'paypal_live_client_id'?: string | null;
    /**
     * This field is required when <code>paypal_live_client_id</code> is present.
     */
    'paypal_live_client_secret'?: string | null;
    /**
     * 
     */
    'paypal_sandbox_mode': string;
}
export interface PostApiSettingsStripeSettingsUpdateRequest {
    /**
     * This field is required when <code>stripe_sk_test</code> is present.
     */
    'stripe_pk_test'?: string | null;
    /**
     * This field is required when <code>stripe_pk_test</code> is present.
     */
    'stripe_sk_test'?: string | null;
    /**
     * This field is required when <code>stripe_sk_live</code> is present.
     */
    'stripe_pk_live'?: string | null;
    /**
     * This field is required when <code>stripe_pk_live</code> is present.
     */
    'stripe_sk_live'?: string | null;
    /**
     * 
     */
    'stripe_sandbox_mode'?: boolean;
    /**
     * 
     */
    'return_url'?: string;
}
export interface PostApiSettingsTabbySettingsUpdateRequest {
    /**
     * 
     */
    'sandbox_mode': boolean;
    /**
     * 
     */
    'public_key': string;
    /**
     * 
     */
    'secret_key': string;
    /**
     * 
     */
    'merchant_code': string;
}
export interface PostApiSettingsTamaraSettingsUpdateRequest {
    /**
     * 
     */
    'sandbox_mode': boolean;
    /**
     * 
     */
    'api_token': string;
    /**
     * 
     */
    'notification_token': string;
}
export interface PostApiShippingCostCalculatorRequest {
    /**
     * 
     */
    'products': object;
    /**
     * 
     */
    'country_id': number;
}
export interface PostApiShippingFlatRateCreateRequest {
    /**
     * 
     */
    'rate'?: number | null;
    /**
     * 
     */
    'min_weight'?: number | null;
    /**
     * 
     */
    'max_weight'?: number | null;
    /**
     * 
     */
    'min_value'?: number | null;
    /**
     * 
     */
    'max_value': number;
    /**
     * 
     */
    'countries'?: object;
    /**
     * 
     */
    'active'?: boolean | null;
}
export interface PostApiShippingFlatRateUpdateRequest {
    /**
     * 
     */
    'id': number;
    /**
     * 
     */
    'rate'?: number | null;
    /**
     * 
     */
    'min_weight'?: number | null;
    /**
     * 
     */
    'max_weight'?: number | null;
    /**
     * 
     */
    'min_value'?: number | null;
    /**
     * 
     */
    'max_value'?: number | null;
    /**
     * 
     */
    'countries'?: object;
    /**
     * 
     */
    'active'?: boolean | null;
}
export interface PostApiShippingShippingDetailsCreateRequest {
    /**
     * Must not be greater than 100 characters.
     */
    'authorized_person': string;
    /**
     * Must not be greater than 100 characters.
     */
    'company'?: string;
    /**
     * Must not be greater than 150 characters.
     */
    'address_1': string;
    /**
     * Must not be greater than 150 characters.
     */
    'address_2'?: string;
    /**
     * Must not be greater than 50 characters.
     */
    'city': string;
    /**
     * Must not be greater than 50.
     */
    'uae_id': number;
    /**
     * Must not be greater than 50 characters.
     */
    'post_code': string;
    /**
     * 
     */
    'save'?: boolean;
}
export interface PostApiShippingShippingDetailsDeleteRequest {
    /**
     * 
     */
    'id': number;
}
export interface PostApiShippingShippingDetailsUpdateRequest {
    /**
     * 
     */
    'id': number;
    /**
     * Must not be greater than 100 characters.
     */
    'authorized_person'?: string;
    /**
     * Must not be greater than 100 characters.
     */
    'company'?: string;
    /**
     * Must not be greater than 150 characters.
     */
    'address_1'?: string;
    /**
     * Must not be greater than 150 characters.
     */
    'address_2'?: string;
    /**
     * Must not be greater than 50 characters.
     */
    'city'?: string;
    /**
     * Must not be greater than 50.
     */
    'uae_id'?: number;
    /**
     * Must not be greater than 50 characters.
     */
    'post_code'?: string;
    /**
     * 
     */
    'save'?: boolean;
}
export interface PostApiShippingShippingServiceCreateRequest {
    /**
     * Must not be greater than 50 characters.
     */
    'name': string;
    /**
     * Must not be greater than 100 characters.
     */
    'slug'?: string | null;
    /**
     * 
     */
    'active'?: boolean | null;
    /**
     * Must not be greater than 50 characters.
     */
    'label'?: string | null;
    /**
     * Must not be greater than 255 characters.
     */
    'description'?: string | null;
}
export interface PostApiShippingShippingServiceDeleteRequest {
    /**
     * 
     */
    'id': number;
}
export interface PostApiShippingShippingServiceUpdateRequest {
    /**
     * 
     */
    'id': number;
    /**
     * Must not be greater than 50 characters.
     */
    'name': string;
    /**
     * Must not be greater than 100 characters.
     */
    'slug'?: string | null;
    /**
     * 
     */
    'active'?: boolean | null;
    /**
     * Must not be greater than 50 characters.
     */
    'label'?: string | null;
    /**
     * Must not be greater than 255 characters.
     */
    'description'?: string | null;
}

export interface PostApiThemeCreateRequest {
    name: string;
    path?: string;
    settings: string;
    is_active?: boolean;
}

export interface PostApiThemeColorUpdateIdRequest {
    'colors': { [key: string]: string; };
    'typography': { [key: string]: string; };
    'layout': { [key: string]: string; };
}

export interface EndpointsApiDeleteApiThemeColorIdRequest {
    readonly id: number
}

export interface PostApiThemeSettingsUpdateIdRequest {
    'logo'?: PostApiThemeSettingsUpdateIdRequestLogo;
    'preloader'?: PostApiThemeSettingsUpdateIdRequestPreloader;
    'typography'?: PostApiThemeSettingsUpdateIdRequestTypography;
    'custom_code'?: PostApiThemeSettingsUpdateIdRequestCustomCode;
}
/**
 * 
 */
export interface PostApiThemeSettingsUpdateIdRequestCustomCode {
    /**
     * 
     */
    'custom_css'?: string | null;
    /**
     * 
     */
    'custom_js'?: string | null;
}
/**
 * 
 */
export interface PostApiThemeSettingsUpdateIdRequestLogo {
    /**
     * 
     */
    'file_id'?: number;
    /**
     * 
     */
    'size'?: string;
}
/**
 * 
 */
export interface PostApiThemeSettingsUpdateIdRequestPreloader {
    /**
     * 
     */
    'enabled': boolean;
    /**
     * 
     */
    'background'?: string;
    /**
     * 
     */
    'file_id'?: number;
}
/**
 * 
 */
export interface PostApiThemeSettingsUpdateIdRequestTypography {
    /**
     * 
     */
    'primary_color'?: string;
    /**
     * 
     */
    'secondary_color'?: string;
    'body_font'?: PostApiThemeSettingsUpdateIdRequestTypographyBodyFont;
    'heading_font'?: PostApiThemeSettingsUpdateIdRequestTypographyHeadingFont;
}
/**
 * 
 */
export interface PostApiThemeSettingsUpdateIdRequestTypographyBodyFont {
    /**
     * 
     */
    'font_family'?: string;
    /**
     * 
     */
    'font_style'?: string;
    /**
     * 
     */
    'font_size'?: string;
    /**
     * 
     */
    'font_color'?: string;
    /**
     * 
     */
    'line_height'?: number;
    /**
     * 
     */
    'letter_spacing'?: string | null;
}
/**
 * 
 */
export interface PostApiThemeSettingsUpdateIdRequestTypographyHeadingFont {
    /**
     * 
     */
    'font_family'?: string;
    /**
     * 
     */
    'font_style'?: string;
    /**
     * 
     */
    'font_size'?: string;
    /**
     * 
     */
    'font_color'?: string;
    /**
     * Must be at least 1.
     */
    'line_height'?: number;
    /**
     * 
     */
    'letter_spacing'?: string | null;
}
export interface PostApiUserPermissionsUpdateRequest {
    /**
     * 
     */
    'user_id': number;
    /**
     * Must not be greater than 100 characters.
     */
    'role': string;
}
export interface PostApiUserRoleCreateRequest {
    /**
     * Must not be greater than 100 characters.
     */
    'role'?: string;
    /**
     * 
     */
    'permissions'?: object;
    /**
     * 
     */
    'type': PostApiUserRoleCreateRequestTypeEnum;
}

export const PostApiUserRoleCreateRequestTypeEnum = {
    Cms: 'cms',
    Client: 'client'
} as const;

export type PostApiUserRoleCreateRequestTypeEnum = typeof PostApiUserRoleCreateRequestTypeEnum[keyof typeof PostApiUserRoleCreateRequestTypeEnum];

export interface PostApiUserRoleDeleteRequest {
    /**
     * Must not be one of <code>admin</code>.
     */
    'role': string;
    /**
     * 
     */
    'type': PostApiUserRoleDeleteRequestTypeEnum;
}

export const PostApiUserRoleDeleteRequestTypeEnum = {
    Cms: 'cms',
    Client: 'client'
} as const;

export type PostApiUserRoleDeleteRequestTypeEnum = typeof PostApiUserRoleDeleteRequestTypeEnum[keyof typeof PostApiUserRoleDeleteRequestTypeEnum];

export interface PostApiUserRoleUpdateRoleRequest {
    /**
     * Must not be greater than 100 characters.
     */
    'role': string;
    /**
     * 
     */
    'permissions': object;
    /**
     * 
     */
    'type': PostApiUserRoleUpdateRoleRequestTypeEnum;
}

export const PostApiUserRoleUpdateRoleRequestTypeEnum = {
    Cms: 'cms',
    Client: 'client'
} as const;

export type PostApiUserRoleUpdateRoleRequestTypeEnum = typeof PostApiUserRoleUpdateRoleRequestTypeEnum[keyof typeof PostApiUserRoleUpdateRoleRequestTypeEnum];

export interface PostFrontProductRateIdRequest {
    /**
     * 
     */
    'id'?: number | null;
    /**
     * 
     */
    'rate'?: PostFrontProductRateIdRequestRateEnum;
}

export const PostFrontProductRateIdRequestRateEnum = {
    _1: '1',
    _15: '1.5',
    _2: '2',
    _25: '2.5',
    _3: '3',
    _35: '3.5',
    _4: '4',
    _45: '4.5',
    _5: '5'
} as const;

export type PostFrontProductRateIdRequestRateEnum = typeof PostFrontProductRateIdRequestRateEnum[keyof typeof PostFrontProductRateIdRequestRateEnum];

export interface PostV1BannerCreateRequest {
    /**
     * 
     */
    'type': PostV1BannerCreateRequestTypeEnum;
    /**
     * Must not be greater than 255 characters.
     */
    'title': string;
    /**
     * 
     */
    'subtitle'?: string | null;
    /**
     * 
     */
    'status'?: boolean;
    /**
     * Must be a valid URL.
     */
    'url'?: string | null;
    /**
     * 
     */
    'short_description'?: string | null;
    /**
     * 
     */
    'images'?: object;
}

export const PostV1BannerCreateRequestTypeEnum = {
    MainSlider: 'Main Slider',
    FirstGroupOfBanners: 'First Group of banners',
    PromotionBanner: 'Promotion banner'
} as const;

export type PostV1BannerCreateRequestTypeEnum = typeof PostV1BannerCreateRequestTypeEnum[keyof typeof PostV1BannerCreateRequestTypeEnum];

export interface PostV1BannerDeleteRequest {
    /**
     * 
     */
    'id'?: number;
}
export interface PostV1BannerUpdateRequest {
    /**
     * 
     */
    'id': number;
    /**
     * 
     */
    'type': PostV1BannerUpdateRequestTypeEnum;
    /**
     * Must not be greater than 255 characters.
     */
    'title': string;
    /**
     * 
     */
    'subtitle'?: string | null;
    /**
     * 
     */
    'status'?: boolean;
    /**
     * Must be a valid URL.
     */
    'url'?: string | null;
    /**
     * 
     */
    'short_description'?: string | null;
    /**
     * 
     */
    'images'?: object;
}

export const PostV1BannerUpdateRequestTypeEnum = {
    MainSlider: 'Main Slider',
    FirstGroupOfBanners: 'First Group of banners',
    PromotionBanner: 'Promotion banner'
} as const;

export type PostV1BannerUpdateRequestTypeEnum = typeof PostV1BannerUpdateRequestTypeEnum[keyof typeof PostV1BannerUpdateRequestTypeEnum];

export interface PostV1FooterCreateRequest {
    /**
     * 
     */
    'content': string;
    /**
     * 
     */
    'information'?: Array<PostV1FooterCreateRequestInformationInner>;
    /**
     * 
     */
    'customer_service'?: Array<PostV1FooterCreateRequestCustomerServiceInner>;
    /**
     * 
     */
    'my_account'?: Array<PostV1FooterCreateRequestMyAccountInner>;
    /**
     * 
     */
    'social_media'?: Array<PostV1FooterCreateRequestSocialMediaInner>;
    /**
     * 
     */
    'active'?: boolean | null;
    /**
     * 
     */
    'images'?: object | null;
}
export interface PostV1FooterCreateRequestCustomerServiceInner {
    /**
     * 
     */
    'title': string;
    /**
     * Must be a valid URL.
     */
    'url': string;
}
export interface PostV1FooterCreateRequestInformationInner {
    /**
     * 
     */
    'title': string;
    /**
     * Must be a valid URL.
     */
    'url': string;
}
export interface PostV1FooterCreateRequestMyAccountInner {
    /**
     * 
     */
    'title': string;
    /**
     * Must be a valid URL.
     */
    'url': string;
}
export interface PostV1FooterCreateRequestSocialMediaInner {
    /**
     * 
     */
    'title': string;
    /**
     * Must be a valid URL.
     */
    'url': string;
}
export interface PostV1FooterDeleteRequest {
    /**
     * 
     */
    'id'?: number;
}
export interface PostV1FooterUpdateRequest {
    /**
     * 
     */
    'id': number;
    /**
     * 
     */
    'content': string;
    /**
     * 
     */
    'information'?: Array<PostV1FooterUpdateRequestInformationInner>;
    /**
     * 
     */
    'customer_service'?: Array<PostV1FooterUpdateRequestCustomerServiceInner>;
    /**
     * 
     */
    'my_account'?: Array<PostV1FooterUpdateRequestMyAccountInner>;
    /**
     * 
     */
    'social_media'?: Array<PostV1FooterUpdateRequestSocialMediaInner>;
    /**
     * 
     */
    'active'?: boolean | null;
    /**
     * 
     */
    'images'?: object | null;
}
export interface PostV1FooterUpdateRequestCustomerServiceInner {
    /**
     * 
     */
    'title': string;
    /**
     * Must be a valid URL.
     */
    'url': string;
}
export interface PostV1FooterUpdateRequestInformationInner {
    /**
     * 
     */
    'title': string;
    /**
     * Must be a valid URL.
     */
    'url': string;
}
export interface PostV1FooterUpdateRequestMyAccountInner {
    /**
     * 
     */
    'title': string;
    /**
     * Must be a valid URL.
     */
    'url': string;
}
export interface PostV1FooterUpdateRequestSocialMediaInner {
    /**
     * 
     */
    'title': string;
    /**
     * Must be a valid URL.
     */
    'url': string;
}
export interface PostV1MenuCreateRequest {
    /**
     * 
     */
    'name': string;
    /**
     * Must be a valid URL.
     */
    'url': string;
    /**
     * 
     */
    'slug': string;
    /**
     * 
     */
    'active': boolean;
    /**
     * 
     */
    'sort': boolean;
    /**
     * The <code>id</code> of an existing record in the menus table.
     */
    'parent_id'?: number | null;
}
export interface PostV1MenuDeleteRequest {
    /**
     * 
     */
    'id'?: number;
}
export interface PostV1MenuUpdateIdRequest {
    /**
     * 
     */
    'id': number;
    /**
     * 
     */
    'name': string;
    /**
     * Must be a valid URL.
     */
    'url': string;
    /**
     * 
     */
    'slug': string;
    /**
     * 
     */
    'active': boolean;
    /**
     * 
     */
    'sort': boolean;
    /**
     * The <code>id</code> of an existing record in the menus table.
     */
    'parent_id'?: number | null;
}
export interface PostV1NavbarModeUpdateRequest {
    /**
     * 
     */
    'navbar_mode': PostV1NavbarModeUpdateRequestNavbarModeEnum;
}

export const PostV1NavbarModeUpdateRequestNavbarModeEnum = {
    Categories: 'categories',
    Menus: 'menus'
} as const;

export type PostV1NavbarModeUpdateRequestNavbarModeEnum = typeof PostV1NavbarModeUpdateRequestNavbarModeEnum[keyof typeof PostV1NavbarModeUpdateRequestNavbarModeEnum];

export interface PutApiCartItemsCartItemIdRequest {
    /**
     * The <code>id</code> of an existing record in the cart_items table.
     */
    'cart_item_id': number;
    /**
     * Must be at least 1. Must not be greater than 100.
     */
    'quantity': number;
    /**
     * 
     */
    'update_mode'?: PutApiCartItemsCartItemIdRequestUpdateModeEnum;
    /**
     * 
     */
    'attributes'?: Array<Array<string>>;
}

export const PutApiCartItemsCartItemIdRequestUpdateModeEnum = {
    Increment: 'increment',
    Replace: 'replace',
    Max: 'max'
} as const;

export type PutApiCartItemsCartItemIdRequestUpdateModeEnum = typeof PutApiCartItemsCartItemIdRequestUpdateModeEnum[keyof typeof PutApiCartItemsCartItemIdRequestUpdateModeEnum];


/**
 * AccountsApi - axios parameter creator
 */
export const AccountsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve a list of users (CMS and Clients) or a specific user by ID.
         * @summary Get Users
         * @param {GetUsersRequest} [getUsersRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers: async (getUsersRequest?: GetUsersRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/accounts/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getUsersRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a list of users (CMS and Clients) or a specific user by ID.
         * @summary Get Users
         * @param {string} id The ID of the user.
         * @param {GetUsersRequest1} [getUsersRequest1] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers_1: async (id: string, getUsersRequest1?: GetUsersRequest1, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getUsers_1', 'id', id)
            const localVarPath = `/api/accounts/user/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getUsersRequest1, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountsApi - functional programming interface
 */
export const AccountsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccountsApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve a list of users (CMS and Clients) or a specific user by ID.
         * @summary Get Users
         * @param {GetUsersRequest} [getUsersRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsers(getUsersRequest?: GetUsersRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsers(getUsersRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountsApi.getUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a list of users (CMS and Clients) or a specific user by ID.
         * @summary Get Users
         * @param {string} id The ID of the user.
         * @param {GetUsersRequest1} [getUsersRequest1] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsers_1(id: string, getUsersRequest1?: GetUsersRequest1, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsers_1(id, getUsersRequest1, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountsApi.getUsers_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AccountsApi - factory interface
 */
export const AccountsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccountsApiFp(configuration)
    return {
        /**
         * Retrieve a list of users (CMS and Clients) or a specific user by ID.
         * @summary Get Users
         * @param {AccountsApiGetUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers(requestParameters: AccountsApiGetUsersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getUsers(requestParameters.getUsersRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a list of users (CMS and Clients) or a specific user by ID.
         * @summary Get Users
         * @param {AccountsApiGetUsers0Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers_1(requestParameters: AccountsApiGetUsers0Request, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getUsers_1(requestParameters.id, requestParameters.getUsersRequest1, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getUsers operation in AccountsApi.
 */
export interface AccountsApiGetUsersRequest {
    readonly getUsersRequest?: GetUsersRequest
}

/**
 * Request parameters for getUsers_1 operation in AccountsApi.
 */
export interface AccountsApiGetUsers0Request {
    /**
     * The ID of the user.
     */
    readonly id: string

    readonly getUsersRequest1?: GetUsersRequest1
}

/**
 * AccountsApi - object-oriented interface
 */
export class AccountsApi extends BaseAPI {
    /**
     * Retrieve a list of users (CMS and Clients) or a specific user by ID.
     * @summary Get Users
     * @param {AccountsApiGetUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUsers(requestParameters: AccountsApiGetUsersRequest = {}, options?: RawAxiosRequestConfig) {
        return AccountsApiFp(this.configuration).getUsers(requestParameters.getUsersRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a list of users (CMS and Clients) or a specific user by ID.
     * @summary Get Users
     * @param {AccountsApiGetUsers0Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUsers_1(requestParameters: AccountsApiGetUsers0Request, options?: RawAxiosRequestConfig) {
        return AccountsApiFp(this.configuration).getUsers_1(requestParameters.id, requestParameters.getUsersRequest1, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BillingApi - axios parameter creator
 */
export const BillingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve billing details for the authenticated user.
         * @summary Get Billing Details
         * @param {GetBillingDetailsRequest} [getBillingDetailsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillingDetails: async (getBillingDetailsRequest?: GetBillingDetailsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/billing/billing-details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getBillingDetailsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve billing details for the authenticated user.
         * @summary Get Billing Details
         * @param {string} username 
         * @param {GetBillingDetailsRequest1} [getBillingDetailsRequest1] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillingDetails_1: async (username: string, getBillingDetailsRequest1?: GetBillingDetailsRequest1, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('getBillingDetails_1', 'username', username)
            const localVarPath = `/api/billing/billing-detail/{username}`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getBillingDetailsRequest1, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BillingApi - functional programming interface
 */
export const BillingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BillingApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve billing details for the authenticated user.
         * @summary Get Billing Details
         * @param {GetBillingDetailsRequest} [getBillingDetailsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBillingDetails(getBillingDetailsRequest?: GetBillingDetailsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBillingDetails(getBillingDetailsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingApi.getBillingDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve billing details for the authenticated user.
         * @summary Get Billing Details
         * @param {string} username 
         * @param {GetBillingDetailsRequest1} [getBillingDetailsRequest1] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBillingDetails_1(username: string, getBillingDetailsRequest1?: GetBillingDetailsRequest1, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBillingDetails_1(username, getBillingDetailsRequest1, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingApi.getBillingDetails_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BillingApi - factory interface
 */
export const BillingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BillingApiFp(configuration)
    return {
        /**
         * Retrieve billing details for the authenticated user.
         * @summary Get Billing Details
         * @param {BillingApiGetBillingDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillingDetails(requestParameters: BillingApiGetBillingDetailsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getBillingDetails(requestParameters.getBillingDetailsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve billing details for the authenticated user.
         * @summary Get Billing Details
         * @param {BillingApiGetBillingDetails0Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillingDetails_1(requestParameters: BillingApiGetBillingDetails0Request, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getBillingDetails_1(requestParameters.username, requestParameters.getBillingDetailsRequest1, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getBillingDetails operation in BillingApi.
 */
export interface BillingApiGetBillingDetailsRequest {
    readonly getBillingDetailsRequest?: GetBillingDetailsRequest
}

/**
 * Request parameters for getBillingDetails_1 operation in BillingApi.
 */
export interface BillingApiGetBillingDetails0Request {
    /**
     * 
     */
    readonly username: string

    readonly getBillingDetailsRequest1?: GetBillingDetailsRequest1
}

/**
 * BillingApi - object-oriented interface
 */
export class BillingApi extends BaseAPI {
    /**
     * Retrieve billing details for the authenticated user.
     * @summary Get Billing Details
     * @param {BillingApiGetBillingDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getBillingDetails(requestParameters: BillingApiGetBillingDetailsRequest = {}, options?: RawAxiosRequestConfig) {
        return BillingApiFp(this.configuration).getBillingDetails(requestParameters.getBillingDetailsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve billing details for the authenticated user.
     * @summary Get Billing Details
     * @param {BillingApiGetBillingDetails0Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getBillingDetails_1(requestParameters: BillingApiGetBillingDetails0Request, options?: RawAxiosRequestConfig) {
        return BillingApiFp(this.configuration).getBillingDetails_1(requestParameters.username, requestParameters.getBillingDetailsRequest1, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EndpointsApi - axios parameter creator
 */
export const EndpointsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApiCartClear: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/cart/clear`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} cartItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApiCartItemsCartItemId: async (cartItemId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cartItemId' is not null or undefined
            assertParamExists('deleteApiCartItemsCartItemId', 'cartItemId', cartItemId)
            const localVarPath = `/api/cart/items/{cartItemId}`
                .replace(`{${"cartItemId"}}`, encodeURIComponent(String(cartItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Execute the job.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeTheJob: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/settings/stripe-settings/webhook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiAccountsDebugAuth: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/accounts/debug-auth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {GetApiAdminCartsRequest} [getApiAdminCartsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiAdminCarts: async (getApiAdminCartsRequest?: GetApiAdminCartsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/carts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getApiAdminCartsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiAmazonSettings: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/amazon-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiAramexSettings: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/aramex-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the seo.
         * @param {GetApiAttributesSeoIdRequest} [getApiAttributesSeoIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiAttributesSeoId: async (id: string, getApiAttributesSeoIdRequest?: GetApiAttributesSeoIdRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getApiAttributesSeoId', 'id', id)
            const localVarPath = `/api/attributes/seo/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getApiAttributesSeoIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {GetApiAttributesSeosRequest} [getApiAttributesSeosRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiAttributesSeos: async (getApiAttributesSeosRequest?: GetApiAttributesSeosRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/attributes/seos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getApiAttributesSeosRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the credit.
         * @param {GetApiBillingCreditIdRequest} [getApiBillingCreditIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiBillingCreditId: async (id: string, getApiBillingCreditIdRequest?: GetApiBillingCreditIdRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getApiBillingCreditId', 'id', id)
            const localVarPath = `/api/billing/credit/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getApiBillingCreditIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {GetApiBillingCreditsRequest} [getApiBillingCreditsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiBillingCredits: async (getApiBillingCreditsRequest?: GetApiBillingCreditsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/billing/credits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getApiBillingCreditsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiCart: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/cart`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiCartDetails: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/cart/details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the attribute.
         * @param {GetApiCatalogAttributeIdRequest} [getApiCatalogAttributeIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiCatalogAttributeId: async (id: string, getApiCatalogAttributeIdRequest?: GetApiCatalogAttributeIdRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getApiCatalogAttributeId', 'id', id)
            const localVarPath = `/api/catalog/attribute/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getApiCatalogAttributeIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the attribute value.
         * @param {PostV1FooterDeleteRequest} [postV1FooterDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiCatalogAttributeValueId: async (id: string, postV1FooterDeleteRequest?: PostV1FooterDeleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getApiCatalogAttributeValueId', 'id', id)
            const localVarPath = `/api/catalog/attribute-value/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postV1FooterDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {GetApiContentPageIdRequest} [getApiContentPageIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiCatalogAttributes: async (getApiContentPageIdRequest?: GetApiContentPageIdRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/catalog/attributes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getApiContentPageIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {GetApiCatalogAttributesValuesRequest} [getApiCatalogAttributesValuesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiCatalogAttributesValues: async (getApiCatalogAttributesValuesRequest?: GetApiCatalogAttributesValuesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/catalog/attributes-values`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getApiCatalogAttributesValuesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the brand.
         * @param {GetApiCatalogBrandIdRequest} [getApiCatalogBrandIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiCatalogBrandId: async (id: string, getApiCatalogBrandIdRequest?: GetApiCatalogBrandIdRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getApiCatalogBrandId', 'id', id)
            const localVarPath = `/api/catalog/brand/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getApiCatalogBrandIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {GetApiCatalogBrandsRequest} [getApiCatalogBrandsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiCatalogBrands: async (getApiCatalogBrandsRequest?: GetApiCatalogBrandsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/catalog/brands`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getApiCatalogBrandsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {GetApiCatalogCategoriesRequest} [getApiCatalogCategoriesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiCatalogCategories: async (getApiCatalogCategoriesRequest?: GetApiCatalogCategoriesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/catalog/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getApiCatalogCategoriesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the category.
         * @param {GetApiCatalogCategoryIdRequest} [getApiCatalogCategoryIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiCatalogCategoryId: async (id: string, getApiCatalogCategoryIdRequest?: GetApiCatalogCategoryIdRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getApiCatalogCategoryId', 'id', id)
            const localVarPath = `/api/catalog/category/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getApiCatalogCategoryIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the product attribute.
         * @param {GetApiCatalogAttributesValuesRequest} [getApiCatalogAttributesValuesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiCatalogProductAttributesId: async (id: string, getApiCatalogAttributesValuesRequest?: GetApiCatalogAttributesValuesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getApiCatalogProductAttributesId', 'id', id)
            const localVarPath = `/api/catalog/product-attributes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getApiCatalogAttributesValuesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the product.
         * @param {GetApiCatalogProductIdRequest} [getApiCatalogProductIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiCatalogProductId: async (id: string, getApiCatalogProductIdRequest?: GetApiCatalogProductIdRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getApiCatalogProductId', 'id', id)
            const localVarPath = `/api/catalog/product/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getApiCatalogProductIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {GetApiCatalogProductSearchRequest} [getApiCatalogProductSearchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiCatalogProductSearch: async (getApiCatalogProductSearchRequest?: GetApiCatalogProductSearchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/catalog/product/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getApiCatalogProductSearchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {GetApiCatalogProductsRequest} [getApiCatalogProductsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiCatalogProducts: async (getApiCatalogProductsRequest?: GetApiCatalogProductsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/catalog/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getApiCatalogProductsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {GetApiCatalogProductsAttributesRequest} [getApiCatalogProductsAttributesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiCatalogProductsAttributes: async (getApiCatalogProductsAttributesRequest?: GetApiCatalogProductsAttributesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/catalog/products-attributes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getApiCatalogProductsAttributesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiCatalogProductsExport: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/catalog/products/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the store.
         * @param {GetApiCatalogStoreIdRequest} [getApiCatalogStoreIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiCatalogStoreId: async (id: string, getApiCatalogStoreIdRequest?: GetApiCatalogStoreIdRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getApiCatalogStoreId', 'id', id)
            const localVarPath = `/api/catalog/store/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getApiCatalogStoreIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {GetApiCatalogStoresRequest} [getApiCatalogStoresRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiCatalogStores: async (getApiCatalogStoresRequest?: GetApiCatalogStoresRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/catalog/stores`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getApiCatalogStoresRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the tag.
         * @param {GetApiCatalogTagIdRequest} [getApiCatalogTagIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiCatalogTagId: async (id: string, getApiCatalogTagIdRequest?: GetApiCatalogTagIdRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getApiCatalogTagId', 'id', id)
            const localVarPath = `/api/catalog/tag/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getApiCatalogTagIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {GetApiCatalogTagsRequest} [getApiCatalogTagsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiCatalogTags: async (getApiCatalogTagsRequest?: GetApiCatalogTagsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/catalog/tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getApiCatalogTagsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the user.
         * @param {GetUsersRequest1} [getUsersRequest1] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiClientUserId: async (id: string, getUsersRequest1?: GetUsersRequest1, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getApiClientUserId', 'id', id)
            const localVarPath = `/api/client/user/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getUsersRequest1, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the newsletter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiCommunicationsNewsletterId: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getApiCommunicationsNewsletterId', 'id', id)
            const localVarPath = `/api/communications/newsletter/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiCommunicationsNewsletters: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/communications/newsletters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the subscriber.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiCommunicationsSubscriberId: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getApiCommunicationsSubscriberId', 'id', id)
            const localVarPath = `/api/communications/subscriber/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiCommunicationsSubscribers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/communications/subscribers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the page.
         * @param {GetApiContentPageIdRequest} [getApiContentPageIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiContentPageId: async (id: string, getApiContentPageIdRequest?: GetApiContentPageIdRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getApiContentPageId', 'id', id)
            const localVarPath = `/api/content/page/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getApiContentPageIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {GetApiContentPagesRequest} [getApiContentPagesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiContentPages: async (getApiContentPagesRequest?: GetApiContentPagesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/content/pages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getApiContentPagesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiDashStats: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dash-stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiInstashopSettings: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/instashop-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {GetApiInvoicesSettingsRequest} [getApiInvoicesSettingsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiInvoicesSettings: async (getApiInvoicesSettingsRequest?: GetApiInvoicesSettingsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/invoices/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getApiInvoicesSettingsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the setting.
         * @param {GetApiInvoicesSettingsIdRequest} [getApiInvoicesSettingsIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiInvoicesSettingsId: async (id: string, getApiInvoicesSettingsIdRequest?: GetApiInvoicesSettingsIdRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getApiInvoicesSettingsId', 'id', id)
            const localVarPath = `/api/invoices/settings/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getApiInvoicesSettingsIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {GetApiContentPagesRequest} [getApiContentPagesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiMediaFiles: async (getApiContentPagesRequest?: GetApiContentPagesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/media/files`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getApiContentPagesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the file.
         * @param {GetApiMediaFilesIdRequest} [getApiMediaFilesIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiMediaFilesId: async (id: string, getApiMediaFilesIdRequest?: GetApiMediaFilesIdRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getApiMediaFilesId', 'id', id)
            const localVarPath = `/api/media/files/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getApiMediaFilesIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {GetApiMediaSearchRequest} [getApiMediaSearchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiMediaSearch: async (getApiMediaSearchRequest?: GetApiMediaSearchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/media/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getApiMediaSearchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiMediaSettingsSizes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/media/settings/sizes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiMediaThumbThumbs: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/media/thumb/thumbs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiNoonSettings: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/noon-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {GetApiOrdersExportRequest} [getApiOrdersExportRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiOrdersExport: async (getApiOrdersExportRequest?: GetApiOrdersExportRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/orders/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getApiOrdersExportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the order.
         * @param {GetApiOrdersOrderIdRequest} [getApiOrdersOrderIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiOrdersOrderId: async (id: string, getApiOrdersOrderIdRequest?: GetApiOrdersOrderIdRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getApiOrdersOrderId', 'id', id)
            const localVarPath = `/api/orders/order/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getApiOrdersOrderIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {GetApiOrdersOrdersRequest} [getApiOrdersOrdersRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiOrdersOrders: async (getApiOrdersOrdersRequest?: GetApiOrdersOrdersRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/orders/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getApiOrdersOrdersRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiOrdersStatus: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/orders/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the status.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiOrdersStatusId: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getApiOrdersStatusId', 'id', id)
            const localVarPath = `/api/orders/status/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} path 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiPath: async (path: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'path' is not null or undefined
            assertParamExists('getApiPath', 'path', path)
            const localVarPath = `/api/{path}`
                .replace(`{${"path"}}`, encodeURIComponent(String(path)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the code.
         * @param {GetApiPromotionsCodeIdRequest} [getApiPromotionsCodeIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiPromotionsCodeId: async (id: string, getApiPromotionsCodeIdRequest?: GetApiPromotionsCodeIdRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getApiPromotionsCodeId', 'id', id)
            const localVarPath = `/api/promotions/code/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getApiPromotionsCodeIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {GetApiPromotionsCodesRequest} [getApiPromotionsCodesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiPromotionsCodes: async (getApiPromotionsCodesRequest?: GetApiPromotionsCodesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/promotions/codes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getApiPromotionsCodesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the offer.
         * @param {GetApiPromotionsOfferIdRequest} [getApiPromotionsOfferIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiPromotionsOfferId: async (id: string, getApiPromotionsOfferIdRequest?: GetApiPromotionsOfferIdRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getApiPromotionsOfferId', 'id', id)
            const localVarPath = `/api/promotions/offer/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getApiPromotionsOfferIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {GetApiPromotionsOffersRequest} [getApiPromotionsOffersRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiPromotionsOffers: async (getApiPromotionsOffersRequest?: GetApiPromotionsOffersRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/promotions/offers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getApiPromotionsOffersRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiSalesPingg: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sales/pingg`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiSettingsCcavenueSettings: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/settings/ccavenue-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {GetApiSettingsCurrenciesRequest} [getApiSettingsCurrenciesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiSettingsCurrencies: async (getApiSettingsCurrenciesRequest?: GetApiSettingsCurrenciesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/settings/currencies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getApiSettingsCurrenciesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the currency.
         * @param {GetApiSettingsCurrencyIdRequest} [getApiSettingsCurrencyIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiSettingsCurrencyId: async (id: string, getApiSettingsCurrencyIdRequest?: GetApiSettingsCurrencyIdRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getApiSettingsCurrencyId', 'id', id)
            const localVarPath = `/api/settings/currency/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getApiSettingsCurrencyIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiSettingsNetworkSettings: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/settings/network-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiSettingsOnlinePaymentCardMethods: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/settings/online-payment/card-methods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiSettingsOnlinePaymentGateways: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/settings/online-payment/gateways`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiSettingsPayfortSettings: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/settings/payfort-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the payment mode.
         * @param {GetApiSettingsPaymentModeIdRequest} [getApiSettingsPaymentModeIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiSettingsPaymentModeId: async (id: string, getApiSettingsPaymentModeIdRequest?: GetApiSettingsPaymentModeIdRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getApiSettingsPaymentModeId', 'id', id)
            const localVarPath = `/api/settings/payment-mode/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getApiSettingsPaymentModeIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {GetApiSettingsPaymentModesRequest} [getApiSettingsPaymentModesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiSettingsPaymentModes: async (getApiSettingsPaymentModesRequest?: GetApiSettingsPaymentModesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/settings/payment-modes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getApiSettingsPaymentModesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiSettingsPaypalSettings: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/settings/paypal-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiSettingsStripeSettings: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/settings/stripe-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiSettingsTabbySettings: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/settings/tabby-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiSettingsTamaraSettings: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/settings/tamara-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the flat rate.
         * @param {GetApiShippingFlatRateIdRequest} [getApiShippingFlatRateIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiShippingFlatRateId: async (id: string, getApiShippingFlatRateIdRequest?: GetApiShippingFlatRateIdRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getApiShippingFlatRateId', 'id', id)
            const localVarPath = `/api/shipping/flat-rate/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getApiShippingFlatRateIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {GetApiShippingFlatRatesRequest} [getApiShippingFlatRatesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiShippingFlatRates: async (getApiShippingFlatRatesRequest?: GetApiShippingFlatRatesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shipping/flat-rates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getApiShippingFlatRatesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} username 
         * @param {GetApiShippingShippingDetailUsernameRequest} [getApiShippingShippingDetailUsernameRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiShippingShippingDetailUsername: async (username: string, getApiShippingShippingDetailUsernameRequest?: GetApiShippingShippingDetailUsernameRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('getApiShippingShippingDetailUsername', 'username', username)
            const localVarPath = `/api/shipping/shipping-detail/{username}`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getApiShippingShippingDetailUsernameRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {GetApiShippingShippingDetailsRequest} [getApiShippingShippingDetailsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiShippingShippingDetails: async (getApiShippingShippingDetailsRequest?: GetApiShippingShippingDetailsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shipping/shipping-details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getApiShippingShippingDetailsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the shipping service.
         * @param {GetApiShippingShippingServiceIdRequest} [getApiShippingShippingServiceIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiShippingShippingServiceId: async (id: string, getApiShippingShippingServiceIdRequest?: GetApiShippingShippingServiceIdRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getApiShippingShippingServiceId', 'id', id)
            const localVarPath = `/api/shipping/shipping-service/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getApiShippingShippingServiceIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {GetApiShippingShippingServicesRequest} [getApiShippingShippingServicesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiShippingShippingServices: async (getApiShippingShippingServicesRequest?: GetApiShippingShippingServicesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shipping/shipping-services`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getApiShippingShippingServicesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiThemeActive: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/theme/active`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiThemes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/themes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {GetApiUserPermissionsRequest} [getApiUserPermissionsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiUserPermissions: async (getApiUserPermissionsRequest?: GetApiUserPermissionsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/permissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getApiUserPermissionsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} role 
         * @param {GetApiUserPermissionsRoleRequest} [getApiUserPermissionsRoleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiUserPermissionsRole: async (role: string, getApiUserPermissionsRoleRequest?: GetApiUserPermissionsRoleRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'role' is not null or undefined
            assertParamExists('getApiUserPermissionsRole', 'role', role)
            const localVarPath = `/api/user/permissions/{role}`
                .replace(`{${"role"}}`, encodeURIComponent(String(role)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getApiUserPermissionsRoleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the banner.
         * @param {GetFrontBannerIdRequest} [getFrontBannerIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrontBannerId: async (id: string, getFrontBannerIdRequest?: GetFrontBannerIdRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getFrontBannerId', 'id', id)
            const localVarPath = `/front/banner/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getFrontBannerIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {GetFrontBannersRequest} [getFrontBannersRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrontBanners: async (getFrontBannersRequest?: GetFrontBannersRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/front/banners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getFrontBannersRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the brand.
         * @param {GetFrontBrandIdRequest} [getFrontBrandIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrontBrandId: async (id: string, getFrontBrandIdRequest?: GetFrontBrandIdRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getFrontBrandId', 'id', id)
            const localVarPath = `/front/brand/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getFrontBrandIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {GetFrontBrandsRequest} [getFrontBrandsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrontBrands: async (getFrontBrandsRequest?: GetFrontBrandsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/front/brands`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getFrontBrandsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {GetFrontCategoriesRequest} [getFrontCategoriesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrontCategories: async (getFrontCategoriesRequest?: GetFrontCategoriesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/front/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getFrontCategoriesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the category.
         * @param {GetFrontCategoryIdRequest} [getFrontCategoryIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrontCategoryId: async (id: string, getFrontCategoryIdRequest?: GetFrontCategoryIdRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getFrontCategoryId', 'id', id)
            const localVarPath = `/front/category/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getFrontCategoryIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the footer.
         * @param {GetFrontFooterIdRequest} [getFrontFooterIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrontFooterId: async (id: string, getFrontFooterIdRequest?: GetFrontFooterIdRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getFrontFooterId', 'id', id)
            const localVarPath = `/front/footer/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getFrontFooterIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {GetFrontFootersRequest} [getFrontFootersRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrontFooters: async (getFrontFootersRequest?: GetFrontFootersRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/front/footers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getFrontFootersRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrontLogout: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/front/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the menu.
         * @param {GetFrontMenuIdRequest} [getFrontMenuIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrontMenuId: async (id: string, getFrontMenuIdRequest?: GetFrontMenuIdRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getFrontMenuId', 'id', id)
            const localVarPath = `/front/menu/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getFrontMenuIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {GetFrontMenusRequest} [getFrontMenusRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrontMenus: async (getFrontMenusRequest?: GetFrontMenusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/front/menus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getFrontMenusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrontNavbarMode: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/front/navbar-mode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the product.
         * @param {GetFrontProductIdRequest} [getFrontProductIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrontProductId: async (id: string, getFrontProductIdRequest?: GetFrontProductIdRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getFrontProductId', 'id', id)
            const localVarPath = `/front/product/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getFrontProductIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {GetFrontProductsRequest} [getFrontProductsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrontProducts: async (getFrontProductsRequest?: GetFrontProductsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/front/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getFrontProductsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the seo.
         * @param {GetFrontSeoIdRequest} [getFrontSeoIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrontSeoId: async (id: string, getFrontSeoIdRequest?: GetFrontSeoIdRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getFrontSeoId', 'id', id)
            const localVarPath = `/front/seo/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getFrontSeoIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {GetFrontMenuIdRequest} [getFrontMenuIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrontSeos: async (getFrontMenuIdRequest?: GetFrontMenuIdRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/front/seos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getFrontMenuIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrontTestPing: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/front/test/ping`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrontThemeActive: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/front/theme/active`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrontVerifyResetPasswordToken: async (token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('getFrontVerifyResetPasswordToken', 'token', token)
            const localVarPath = `/front/verify-reset-password/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrontVerifyToken: async (token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('getFrontVerifyToken', 'token', token)
            const localVarPath = `/front/verify/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the banner.
         * @param {GetV1BannersRequest} [getV1BannersRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1BannerId: async (id: string, getV1BannersRequest?: GetV1BannersRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getV1BannerId', 'id', id)
            const localVarPath = `/v1/banner/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getV1BannersRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {GetV1BannersRequest} [getV1BannersRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1Banners: async (getV1BannersRequest?: GetV1BannersRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/banners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getV1BannersRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1ClearAllCache: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/clear-all-cache`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1CountriesCountries: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/countries/countries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the country.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1CountriesCountryId: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getV1CountriesCountryId', 'id', id)
            const localVarPath = `/v1/countries/country/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the footer.
         * @param {GetV1FooterIdRequest} [getV1FooterIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1FooterId: async (id: string, getV1FooterIdRequest?: GetV1FooterIdRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getV1FooterId', 'id', id)
            const localVarPath = `/v1/footer/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getV1FooterIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {GetV1FootersRequest} [getV1FootersRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1Footers: async (getV1FootersRequest?: GetV1FootersRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/footers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getV1FootersRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1Logout: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the menu.
         * @param {GetV1MenuIdRequest} [getV1MenuIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1MenuId: async (id: string, getV1MenuIdRequest?: GetV1MenuIdRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getV1MenuId', 'id', id)
            const localVarPath = `/v1/menu/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getV1MenuIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {GetV1MenusRequest} [getV1MenusRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1Menus: async (getV1MenusRequest?: GetV1MenusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/menus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getV1MenusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1TestPing: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/test/ping`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1VerifyResetPasswordToken: async (token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('getV1VerifyResetPasswordToken', 'token', token)
            const localVarPath = `/v1/verify-reset-password/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1VerifyToken: async (token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('getV1VerifyToken', 'token', token)
            const localVarPath = `/v1/verify/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the shipping service.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchApiShippingShippingServiceIdActivate: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchApiShippingShippingServiceIdActivate', 'id', id)
            const localVarPath = `/api/shipping/shipping-service/{id}/activate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiAccountsUserCreateRequest} postApiAccountsUserCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiAccountsUserCreate: async (postApiAccountsUserCreateRequest: PostApiAccountsUserCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiAccountsUserCreateRequest' is not null or undefined
            assertParamExists('postApiAccountsUserCreate', 'postApiAccountsUserCreateRequest', postApiAccountsUserCreateRequest)
            const localVarPath = `/api/accounts/user/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiAccountsUserCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiAccountsUserDeleteRequest} postApiAccountsUserDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiAccountsUserDelete: async (postApiAccountsUserDeleteRequest: PostApiAccountsUserDeleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiAccountsUserDeleteRequest' is not null or undefined
            assertParamExists('postApiAccountsUserDelete', 'postApiAccountsUserDeleteRequest', postApiAccountsUserDeleteRequest)
            const localVarPath = `/api/accounts/user/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiAccountsUserDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the update.
         * @param {PostApiAccountsUserUpdateIdRequest} postApiAccountsUserUpdateIdRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiAccountsUserUpdateId: async (id: string, postApiAccountsUserUpdateIdRequest: PostApiAccountsUserUpdateIdRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('postApiAccountsUserUpdateId', 'id', id)
            // verify required parameter 'postApiAccountsUserUpdateIdRequest' is not null or undefined
            assertParamExists('postApiAccountsUserUpdateId', 'postApiAccountsUserUpdateIdRequest', postApiAccountsUserUpdateIdRequest)
            const localVarPath = `/api/accounts/user/update/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiAccountsUserUpdateIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiAmazonSettingsUpdateRequest} [postApiAmazonSettingsUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiAmazonSettingsUpdate: async (postApiAmazonSettingsUpdateRequest?: PostApiAmazonSettingsUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/amazon-settings/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiAmazonSettingsUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiAramexSettingsUpdateRequest} [postApiAramexSettingsUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiAramexSettingsUpdate: async (postApiAramexSettingsUpdateRequest?: PostApiAramexSettingsUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/aramex-settings/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiAramexSettingsUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiAttributesSeoCreateRequest} postApiAttributesSeoCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiAttributesSeoCreate: async (postApiAttributesSeoCreateRequest: PostApiAttributesSeoCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiAttributesSeoCreateRequest' is not null or undefined
            assertParamExists('postApiAttributesSeoCreate', 'postApiAttributesSeoCreateRequest', postApiAttributesSeoCreateRequest)
            const localVarPath = `/api/attributes/seo/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiAttributesSeoCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostV1FooterDeleteRequest} [postV1FooterDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiAttributesSeoDelete: async (postV1FooterDeleteRequest?: PostV1FooterDeleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/attributes/seo/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postV1FooterDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the update.
         * @param {PostApiAttributesSeoUpdateIdRequest} postApiAttributesSeoUpdateIdRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiAttributesSeoUpdateId: async (id: string, postApiAttributesSeoUpdateIdRequest: PostApiAttributesSeoUpdateIdRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('postApiAttributesSeoUpdateId', 'id', id)
            // verify required parameter 'postApiAttributesSeoUpdateIdRequest' is not null or undefined
            assertParamExists('postApiAttributesSeoUpdateId', 'postApiAttributesSeoUpdateIdRequest', postApiAttributesSeoUpdateIdRequest)
            const localVarPath = `/api/attributes/seo/update/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiAttributesSeoUpdateIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiBillingBillingDetailsCreateRequest} postApiBillingBillingDetailsCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiBillingBillingDetailsCreate: async (postApiBillingBillingDetailsCreateRequest: PostApiBillingBillingDetailsCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiBillingBillingDetailsCreateRequest' is not null or undefined
            assertParamExists('postApiBillingBillingDetailsCreate', 'postApiBillingBillingDetailsCreateRequest', postApiBillingBillingDetailsCreateRequest)
            const localVarPath = `/api/billing/billing-details/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiBillingBillingDetailsCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiBillingBillingDetailsDeleteRequest} postApiBillingBillingDetailsDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiBillingBillingDetailsDelete: async (postApiBillingBillingDetailsDeleteRequest: PostApiBillingBillingDetailsDeleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiBillingBillingDetailsDeleteRequest' is not null or undefined
            assertParamExists('postApiBillingBillingDetailsDelete', 'postApiBillingBillingDetailsDeleteRequest', postApiBillingBillingDetailsDeleteRequest)
            const localVarPath = `/api/billing/billing-details/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiBillingBillingDetailsDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiBillingBillingDetailsUpdateRequest} postApiBillingBillingDetailsUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiBillingBillingDetailsUpdate: async (postApiBillingBillingDetailsUpdateRequest: PostApiBillingBillingDetailsUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiBillingBillingDetailsUpdateRequest' is not null or undefined
            assertParamExists('postApiBillingBillingDetailsUpdate', 'postApiBillingBillingDetailsUpdateRequest', postApiBillingBillingDetailsUpdateRequest)
            const localVarPath = `/api/billing/billing-details/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiBillingBillingDetailsUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiBillingCreditCreateRequest} postApiBillingCreditCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiBillingCreditCreate: async (postApiBillingCreditCreateRequest: PostApiBillingCreditCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiBillingCreditCreateRequest' is not null or undefined
            assertParamExists('postApiBillingCreditCreate', 'postApiBillingCreditCreateRequest', postApiBillingCreditCreateRequest)
            const localVarPath = `/api/billing/credit/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiBillingCreditCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiBillingCreditDeleteRequest} postApiBillingCreditDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiBillingCreditDelete: async (postApiBillingCreditDeleteRequest: PostApiBillingCreditDeleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiBillingCreditDeleteRequest' is not null or undefined
            assertParamExists('postApiBillingCreditDelete', 'postApiBillingCreditDeleteRequest', postApiBillingCreditDeleteRequest)
            const localVarPath = `/api/billing/credit/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiBillingCreditDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiBillingCreditUpdateRequest} postApiBillingCreditUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiBillingCreditUpdate: async (postApiBillingCreditUpdateRequest: PostApiBillingCreditUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiBillingCreditUpdateRequest' is not null or undefined
            assertParamExists('postApiBillingCreditUpdate', 'postApiBillingCreditUpdateRequest', postApiBillingCreditUpdateRequest)
            const localVarPath = `/api/billing/credit/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiBillingCreditUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiCartAddRequest} [postApiCartAddRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCartAdd: async (postApiCartAddRequest?: PostApiCartAddRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/cart/add`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiCartAddRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiCatalogAttributeCreateRequest} postApiCatalogAttributeCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCatalogAttributeCreate: async (postApiCatalogAttributeCreateRequest: PostApiCatalogAttributeCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiCatalogAttributeCreateRequest' is not null or undefined
            assertParamExists('postApiCatalogAttributeCreate', 'postApiCatalogAttributeCreateRequest', postApiCatalogAttributeCreateRequest)
            const localVarPath = `/api/catalog/attribute/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiCatalogAttributeCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiCatalogStoreDeleteRequest} postApiCatalogStoreDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCatalogAttributeDelete: async (postApiCatalogStoreDeleteRequest: PostApiCatalogStoreDeleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiCatalogStoreDeleteRequest' is not null or undefined
            assertParamExists('postApiCatalogAttributeDelete', 'postApiCatalogStoreDeleteRequest', postApiCatalogStoreDeleteRequest)
            const localVarPath = `/api/catalog/attribute/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiCatalogStoreDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiCatalogAttributeUpdateRequest} postApiCatalogAttributeUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCatalogAttributeUpdate: async (postApiCatalogAttributeUpdateRequest: PostApiCatalogAttributeUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiCatalogAttributeUpdateRequest' is not null or undefined
            assertParamExists('postApiCatalogAttributeUpdate', 'postApiCatalogAttributeUpdateRequest', postApiCatalogAttributeUpdateRequest)
            const localVarPath = `/api/catalog/attribute/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiCatalogAttributeUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiCatalogAttributeValueCreateRequest} postApiCatalogAttributeValueCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCatalogAttributeValueCreate: async (postApiCatalogAttributeValueCreateRequest: PostApiCatalogAttributeValueCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiCatalogAttributeValueCreateRequest' is not null or undefined
            assertParamExists('postApiCatalogAttributeValueCreate', 'postApiCatalogAttributeValueCreateRequest', postApiCatalogAttributeValueCreateRequest)
            const localVarPath = `/api/catalog/attribute-value/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiCatalogAttributeValueCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiCatalogAttributeValueDeleteRequest} postApiCatalogAttributeValueDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCatalogAttributeValueDelete: async (postApiCatalogAttributeValueDeleteRequest: PostApiCatalogAttributeValueDeleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiCatalogAttributeValueDeleteRequest' is not null or undefined
            assertParamExists('postApiCatalogAttributeValueDelete', 'postApiCatalogAttributeValueDeleteRequest', postApiCatalogAttributeValueDeleteRequest)
            const localVarPath = `/api/catalog/attribute-value/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiCatalogAttributeValueDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiCatalogAttributeValueUpdateRequest} postApiCatalogAttributeValueUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCatalogAttributeValueUpdate: async (postApiCatalogAttributeValueUpdateRequest: PostApiCatalogAttributeValueUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiCatalogAttributeValueUpdateRequest' is not null or undefined
            assertParamExists('postApiCatalogAttributeValueUpdate', 'postApiCatalogAttributeValueUpdateRequest', postApiCatalogAttributeValueUpdateRequest)
            const localVarPath = `/api/catalog/attribute-value/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiCatalogAttributeValueUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiCatalogBrandCreateRequest} postApiCatalogBrandCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCatalogBrandCreate: async (postApiCatalogBrandCreateRequest: PostApiCatalogBrandCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiCatalogBrandCreateRequest' is not null or undefined
            assertParamExists('postApiCatalogBrandCreate', 'postApiCatalogBrandCreateRequest', postApiCatalogBrandCreateRequest)
            const localVarPath = `/api/catalog/brand/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiCatalogBrandCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiCommunicationsNewsletterDeleteRequest} postApiCommunicationsNewsletterDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCatalogBrandDelete: async (postApiCommunicationsNewsletterDeleteRequest: PostApiCommunicationsNewsletterDeleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiCommunicationsNewsletterDeleteRequest' is not null or undefined
            assertParamExists('postApiCatalogBrandDelete', 'postApiCommunicationsNewsletterDeleteRequest', postApiCommunicationsNewsletterDeleteRequest)
            const localVarPath = `/api/catalog/brand/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiCommunicationsNewsletterDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiCatalogBrandUpdateRequest} postApiCatalogBrandUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCatalogBrandUpdate: async (postApiCatalogBrandUpdateRequest: PostApiCatalogBrandUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiCatalogBrandUpdateRequest' is not null or undefined
            assertParamExists('postApiCatalogBrandUpdate', 'postApiCatalogBrandUpdateRequest', postApiCatalogBrandUpdateRequest)
            const localVarPath = `/api/catalog/brand/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiCatalogBrandUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiCatalogCategoryCreateRequest} [postApiCatalogCategoryCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCatalogCategoryCreate: async (postApiCatalogCategoryCreateRequest?: PostApiCatalogCategoryCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/catalog/category/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiCatalogCategoryCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiCatalogCategoryDeleteRequest} postApiCatalogCategoryDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCatalogCategoryDelete: async (postApiCatalogCategoryDeleteRequest: PostApiCatalogCategoryDeleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiCatalogCategoryDeleteRequest' is not null or undefined
            assertParamExists('postApiCatalogCategoryDelete', 'postApiCatalogCategoryDeleteRequest', postApiCatalogCategoryDeleteRequest)
            const localVarPath = `/api/catalog/category/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiCatalogCategoryDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiCatalogCategoryUpdateRequest} postApiCatalogCategoryUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCatalogCategoryUpdate: async (postApiCatalogCategoryUpdateRequest: PostApiCatalogCategoryUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiCatalogCategoryUpdateRequest' is not null or undefined
            assertParamExists('postApiCatalogCategoryUpdate', 'postApiCatalogCategoryUpdateRequest', postApiCatalogCategoryUpdateRequest)
            const localVarPath = `/api/catalog/category/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiCatalogCategoryUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiCatalogProductAttributesCreateRequest} postApiCatalogProductAttributesCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCatalogProductAttributesCreate: async (postApiCatalogProductAttributesCreateRequest: PostApiCatalogProductAttributesCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiCatalogProductAttributesCreateRequest' is not null or undefined
            assertParamExists('postApiCatalogProductAttributesCreate', 'postApiCatalogProductAttributesCreateRequest', postApiCatalogProductAttributesCreateRequest)
            const localVarPath = `/api/catalog/product-attributes/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiCatalogProductAttributesCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiCatalogProductAttributesDeleteRequest} postApiCatalogProductAttributesDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCatalogProductAttributesDelete: async (postApiCatalogProductAttributesDeleteRequest: PostApiCatalogProductAttributesDeleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiCatalogProductAttributesDeleteRequest' is not null or undefined
            assertParamExists('postApiCatalogProductAttributesDelete', 'postApiCatalogProductAttributesDeleteRequest', postApiCatalogProductAttributesDeleteRequest)
            const localVarPath = `/api/catalog/product-attributes/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiCatalogProductAttributesDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiCatalogProductAttributesUpdateRequest} postApiCatalogProductAttributesUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCatalogProductAttributesUpdate: async (postApiCatalogProductAttributesUpdateRequest: PostApiCatalogProductAttributesUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiCatalogProductAttributesUpdateRequest' is not null or undefined
            assertParamExists('postApiCatalogProductAttributesUpdate', 'postApiCatalogProductAttributesUpdateRequest', postApiCatalogProductAttributesUpdateRequest)
            const localVarPath = `/api/catalog/product-attributes/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiCatalogProductAttributesUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiCatalogProductCreateRequest} postApiCatalogProductCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCatalogProductCreate: async (postApiCatalogProductCreateRequest: PostApiCatalogProductCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiCatalogProductCreateRequest' is not null or undefined
            assertParamExists('postApiCatalogProductCreate', 'postApiCatalogProductCreateRequest', postApiCatalogProductCreateRequest)
            const localVarPath = `/api/catalog/product/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiCatalogProductCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiCatalogProductDeleteRequest} postApiCatalogProductDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCatalogProductDelete: async (postApiCatalogProductDeleteRequest: PostApiCatalogProductDeleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiCatalogProductDeleteRequest' is not null or undefined
            assertParamExists('postApiCatalogProductDelete', 'postApiCatalogProductDeleteRequest', postApiCatalogProductDeleteRequest)
            const localVarPath = `/api/catalog/product/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiCatalogProductDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiCatalogProductUpdateRequest} postApiCatalogProductUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCatalogProductUpdate: async (postApiCatalogProductUpdateRequest: PostApiCatalogProductUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiCatalogProductUpdateRequest' is not null or undefined
            assertParamExists('postApiCatalogProductUpdate', 'postApiCatalogProductUpdateRequest', postApiCatalogProductUpdateRequest)
            const localVarPath = `/api/catalog/product/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiCatalogProductUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiCatalogStoreCreateRequest} postApiCatalogStoreCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCatalogStoreCreate: async (postApiCatalogStoreCreateRequest: PostApiCatalogStoreCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiCatalogStoreCreateRequest' is not null or undefined
            assertParamExists('postApiCatalogStoreCreate', 'postApiCatalogStoreCreateRequest', postApiCatalogStoreCreateRequest)
            const localVarPath = `/api/catalog/store/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiCatalogStoreCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiCatalogStoreDeleteRequest} postApiCatalogStoreDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCatalogStoreDelete: async (postApiCatalogStoreDeleteRequest: PostApiCatalogStoreDeleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiCatalogStoreDeleteRequest' is not null or undefined
            assertParamExists('postApiCatalogStoreDelete', 'postApiCatalogStoreDeleteRequest', postApiCatalogStoreDeleteRequest)
            const localVarPath = `/api/catalog/store/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiCatalogStoreDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiCatalogStoreUpdateRequest} postApiCatalogStoreUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCatalogStoreUpdate: async (postApiCatalogStoreUpdateRequest: PostApiCatalogStoreUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiCatalogStoreUpdateRequest' is not null or undefined
            assertParamExists('postApiCatalogStoreUpdate', 'postApiCatalogStoreUpdateRequest', postApiCatalogStoreUpdateRequest)
            const localVarPath = `/api/catalog/store/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiCatalogStoreUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiCatalogTagCreateRequest} postApiCatalogTagCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCatalogTagCreate: async (postApiCatalogTagCreateRequest: PostApiCatalogTagCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiCatalogTagCreateRequest' is not null or undefined
            assertParamExists('postApiCatalogTagCreate', 'postApiCatalogTagCreateRequest', postApiCatalogTagCreateRequest)
            const localVarPath = `/api/catalog/tag/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiCatalogTagCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiCatalogTagDeleteRequest} postApiCatalogTagDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCatalogTagDelete: async (postApiCatalogTagDeleteRequest: PostApiCatalogTagDeleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiCatalogTagDeleteRequest' is not null or undefined
            assertParamExists('postApiCatalogTagDelete', 'postApiCatalogTagDeleteRequest', postApiCatalogTagDeleteRequest)
            const localVarPath = `/api/catalog/tag/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiCatalogTagDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiCatalogTagUpdateRequest} postApiCatalogTagUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCatalogTagUpdate: async (postApiCatalogTagUpdateRequest: PostApiCatalogTagUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiCatalogTagUpdateRequest' is not null or undefined
            assertParamExists('postApiCatalogTagUpdate', 'postApiCatalogTagUpdateRequest', postApiCatalogTagUpdateRequest)
            const localVarPath = `/api/catalog/tag/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiCatalogTagUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiCommunicationsNewsletterCreateRequest} postApiCommunicationsNewsletterCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCommunicationsNewsletterCreate: async (postApiCommunicationsNewsletterCreateRequest: PostApiCommunicationsNewsletterCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiCommunicationsNewsletterCreateRequest' is not null or undefined
            assertParamExists('postApiCommunicationsNewsletterCreate', 'postApiCommunicationsNewsletterCreateRequest', postApiCommunicationsNewsletterCreateRequest)
            const localVarPath = `/api/communications/newsletter/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiCommunicationsNewsletterCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiCommunicationsNewsletterDeleteRequest} postApiCommunicationsNewsletterDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCommunicationsNewsletterDelete: async (postApiCommunicationsNewsletterDeleteRequest: PostApiCommunicationsNewsletterDeleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiCommunicationsNewsletterDeleteRequest' is not null or undefined
            assertParamExists('postApiCommunicationsNewsletterDelete', 'postApiCommunicationsNewsletterDeleteRequest', postApiCommunicationsNewsletterDeleteRequest)
            const localVarPath = `/api/communications/newsletter/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiCommunicationsNewsletterDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiCommunicationsNewsletterUpdateRequest} postApiCommunicationsNewsletterUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCommunicationsNewsletterUpdate: async (postApiCommunicationsNewsletterUpdateRequest: PostApiCommunicationsNewsletterUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiCommunicationsNewsletterUpdateRequest' is not null or undefined
            assertParamExists('postApiCommunicationsNewsletterUpdate', 'postApiCommunicationsNewsletterUpdateRequest', postApiCommunicationsNewsletterUpdateRequest)
            const localVarPath = `/api/communications/newsletter/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiCommunicationsNewsletterUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiCommunicationsSubscriberCreateRequest} postApiCommunicationsSubscriberCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCommunicationsSubscriberCreate: async (postApiCommunicationsSubscriberCreateRequest: PostApiCommunicationsSubscriberCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiCommunicationsSubscriberCreateRequest' is not null or undefined
            assertParamExists('postApiCommunicationsSubscriberCreate', 'postApiCommunicationsSubscriberCreateRequest', postApiCommunicationsSubscriberCreateRequest)
            const localVarPath = `/api/communications/subscriber/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiCommunicationsSubscriberCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiAccountsUserDeleteRequest} postApiAccountsUserDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCommunicationsSubscriberDelete: async (postApiAccountsUserDeleteRequest: PostApiAccountsUserDeleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiAccountsUserDeleteRequest' is not null or undefined
            assertParamExists('postApiCommunicationsSubscriberDelete', 'postApiAccountsUserDeleteRequest', postApiAccountsUserDeleteRequest)
            const localVarPath = `/api/communications/subscriber/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiAccountsUserDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiCommunicationsSubscriberUpdateRequest} postApiCommunicationsSubscriberUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCommunicationsSubscriberUpdate: async (postApiCommunicationsSubscriberUpdateRequest: PostApiCommunicationsSubscriberUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiCommunicationsSubscriberUpdateRequest' is not null or undefined
            assertParamExists('postApiCommunicationsSubscriberUpdate', 'postApiCommunicationsSubscriberUpdateRequest', postApiCommunicationsSubscriberUpdateRequest)
            const localVarPath = `/api/communications/subscriber/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiCommunicationsSubscriberUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiContentPageCreateRequest} postApiContentPageCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiContentPageCreate: async (postApiContentPageCreateRequest: PostApiContentPageCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiContentPageCreateRequest' is not null or undefined
            assertParamExists('postApiContentPageCreate', 'postApiContentPageCreateRequest', postApiContentPageCreateRequest)
            const localVarPath = `/api/content/page/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiContentPageCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiContentPageDeleteRequest} postApiContentPageDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiContentPageDelete: async (postApiContentPageDeleteRequest: PostApiContentPageDeleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiContentPageDeleteRequest' is not null or undefined
            assertParamExists('postApiContentPageDelete', 'postApiContentPageDeleteRequest', postApiContentPageDeleteRequest)
            const localVarPath = `/api/content/page/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiContentPageDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiContentPageUpdateRequest} postApiContentPageUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiContentPageUpdate: async (postApiContentPageUpdateRequest: PostApiContentPageUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiContentPageUpdateRequest' is not null or undefined
            assertParamExists('postApiContentPageUpdate', 'postApiContentPageUpdateRequest', postApiContentPageUpdateRequest)
            const localVarPath = `/api/content/page/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiContentPageUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiInstashopSettingsUpdateRequest} [postApiInstashopSettingsUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiInstashopSettingsUpdate: async (postApiInstashopSettingsUpdateRequest?: PostApiInstashopSettingsUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/instashop-settings/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiInstashopSettingsUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiInvoicesSettingsCreateRequest} postApiInvoicesSettingsCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiInvoicesSettingsCreate: async (postApiInvoicesSettingsCreateRequest: PostApiInvoicesSettingsCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiInvoicesSettingsCreateRequest' is not null or undefined
            assertParamExists('postApiInvoicesSettingsCreate', 'postApiInvoicesSettingsCreateRequest', postApiInvoicesSettingsCreateRequest)
            const localVarPath = `/api/invoices/settings/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiInvoicesSettingsCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiInvoicesSettingsDeleteRequest} postApiInvoicesSettingsDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiInvoicesSettingsDelete: async (postApiInvoicesSettingsDeleteRequest: PostApiInvoicesSettingsDeleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiInvoicesSettingsDeleteRequest' is not null or undefined
            assertParamExists('postApiInvoicesSettingsDelete', 'postApiInvoicesSettingsDeleteRequest', postApiInvoicesSettingsDeleteRequest)
            const localVarPath = `/api/invoices/settings/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiInvoicesSettingsDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiInvoicesSettingsUpdateRequest} postApiInvoicesSettingsUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiInvoicesSettingsUpdate: async (postApiInvoicesSettingsUpdateRequest: PostApiInvoicesSettingsUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiInvoicesSettingsUpdateRequest' is not null or undefined
            assertParamExists('postApiInvoicesSettingsUpdate', 'postApiInvoicesSettingsUpdateRequest', postApiInvoicesSettingsUpdateRequest)
            const localVarPath = `/api/invoices/settings/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiInvoicesSettingsUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiMediaFileDeleteRequest} postApiMediaFileDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiMediaFileDelete: async (postApiMediaFileDeleteRequest: PostApiMediaFileDeleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiMediaFileDeleteRequest' is not null or undefined
            assertParamExists('postApiMediaFileDelete', 'postApiMediaFileDeleteRequest', postApiMediaFileDeleteRequest)
            const localVarPath = `/api/media/file/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiMediaFileDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the update.
         * @param {PostApiMediaFileUpdateIdRequest} [postApiMediaFileUpdateIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiMediaFileUpdateId: async (id: string, postApiMediaFileUpdateIdRequest?: PostApiMediaFileUpdateIdRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('postApiMediaFileUpdateId', 'id', id)
            const localVarPath = `/api/media/file/update/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiMediaFileUpdateIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiMediaFileUploadRequest} postApiMediaFileUploadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiMediaFileUpload: async (postApiMediaFileUploadRequest: PostApiMediaFileUploadRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiMediaFileUploadRequest' is not null or undefined
            assertParamExists('postApiMediaFileUpload', 'postApiMediaFileUploadRequest', postApiMediaFileUploadRequest)
            const localVarPath = `/api/media/file/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiMediaFileUploadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the update.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiMediaSettingsSizeUpdateId: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('postApiMediaSettingsSizeUpdateId', 'id', id)
            const localVarPath = `/api/media/settings/size/update/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiMediaThumbUpdateAudio: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/media/thumb/update/audio`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiMediaThumbUpdateDocument: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/media/thumb/update/document`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiMediaThumbUpdateVideo: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/media/thumb/update/video`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiNoonSettingsUpdateRequest} [postApiNoonSettingsUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiNoonSettingsUpdate: async (postApiNoonSettingsUpdateRequest?: PostApiNoonSettingsUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/noon-settings/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiNoonSettingsUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiOrdersOrderCreateRequest} postApiOrdersOrderCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiOrdersOrderCreate: async (postApiOrdersOrderCreateRequest: PostApiOrdersOrderCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiOrdersOrderCreateRequest' is not null or undefined
            assertParamExists('postApiOrdersOrderCreate', 'postApiOrdersOrderCreateRequest', postApiOrdersOrderCreateRequest)
            const localVarPath = `/api/orders/order/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiOrdersOrderCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiCatalogCategoryDeleteRequest} postApiCatalogCategoryDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiOrdersOrderDelete: async (postApiCatalogCategoryDeleteRequest: PostApiCatalogCategoryDeleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiCatalogCategoryDeleteRequest' is not null or undefined
            assertParamExists('postApiOrdersOrderDelete', 'postApiCatalogCategoryDeleteRequest', postApiCatalogCategoryDeleteRequest)
            const localVarPath = `/api/orders/order/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiCatalogCategoryDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the update.
         * @param {PostApiOrdersOrderUpdateIdRequest} postApiOrdersOrderUpdateIdRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiOrdersOrderUpdateId: async (id: string, postApiOrdersOrderUpdateIdRequest: PostApiOrdersOrderUpdateIdRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('postApiOrdersOrderUpdateId', 'id', id)
            // verify required parameter 'postApiOrdersOrderUpdateIdRequest' is not null or undefined
            assertParamExists('postApiOrdersOrderUpdateId', 'postApiOrdersOrderUpdateIdRequest', postApiOrdersOrderUpdateIdRequest)
            const localVarPath = `/api/orders/order/update/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiOrdersOrderUpdateIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiOrdersStatusCreateRequest} postApiOrdersStatusCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiOrdersStatusCreate: async (postApiOrdersStatusCreateRequest: PostApiOrdersStatusCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiOrdersStatusCreateRequest' is not null or undefined
            assertParamExists('postApiOrdersStatusCreate', 'postApiOrdersStatusCreateRequest', postApiOrdersStatusCreateRequest)
            const localVarPath = `/api/orders/status/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiOrdersStatusCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiOrdersStatusDeleteRequest} postApiOrdersStatusDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiOrdersStatusDelete: async (postApiOrdersStatusDeleteRequest: PostApiOrdersStatusDeleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiOrdersStatusDeleteRequest' is not null or undefined
            assertParamExists('postApiOrdersStatusDelete', 'postApiOrdersStatusDeleteRequest', postApiOrdersStatusDeleteRequest)
            const localVarPath = `/api/orders/status/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiOrdersStatusDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiOrdersStatusUpdateRequest} postApiOrdersStatusUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiOrdersStatusUpdate: async (postApiOrdersStatusUpdateRequest: PostApiOrdersStatusUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiOrdersStatusUpdateRequest' is not null or undefined
            assertParamExists('postApiOrdersStatusUpdate', 'postApiOrdersStatusUpdateRequest', postApiOrdersStatusUpdateRequest)
            const localVarPath = `/api/orders/status/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiOrdersStatusUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiPaymentInitiateRequest} postApiPaymentInitiateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiPaymentInitiate: async (postApiPaymentInitiateRequest: PostApiPaymentInitiateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiPaymentInitiateRequest' is not null or undefined
            assertParamExists('postApiPaymentInitiate', 'postApiPaymentInitiateRequest', postApiPaymentInitiateRequest)
            const localVarPath = `/api/payment/initiate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiPaymentInitiateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiPromotionsCodeCreateRequest} postApiPromotionsCodeCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiPromotionsCodeCreate: async (postApiPromotionsCodeCreateRequest: PostApiPromotionsCodeCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiPromotionsCodeCreateRequest' is not null or undefined
            assertParamExists('postApiPromotionsCodeCreate', 'postApiPromotionsCodeCreateRequest', postApiPromotionsCodeCreateRequest)
            const localVarPath = `/api/promotions/code/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiPromotionsCodeCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiPromotionsCodeDeleteRequest} postApiPromotionsCodeDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiPromotionsCodeDelete: async (postApiPromotionsCodeDeleteRequest: PostApiPromotionsCodeDeleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiPromotionsCodeDeleteRequest' is not null or undefined
            assertParamExists('postApiPromotionsCodeDelete', 'postApiPromotionsCodeDeleteRequest', postApiPromotionsCodeDeleteRequest)
            const localVarPath = `/api/promotions/code/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiPromotionsCodeDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the update.
         * @param {PostApiPromotionsCodeUpdateIdRequest} postApiPromotionsCodeUpdateIdRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiPromotionsCodeUpdateId: async (id: string, postApiPromotionsCodeUpdateIdRequest: PostApiPromotionsCodeUpdateIdRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('postApiPromotionsCodeUpdateId', 'id', id)
            // verify required parameter 'postApiPromotionsCodeUpdateIdRequest' is not null or undefined
            assertParamExists('postApiPromotionsCodeUpdateId', 'postApiPromotionsCodeUpdateIdRequest', postApiPromotionsCodeUpdateIdRequest)
            const localVarPath = `/api/promotions/code/update/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiPromotionsCodeUpdateIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiPromotionsOfferCreateRequest} postApiPromotionsOfferCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiPromotionsOfferCreate: async (postApiPromotionsOfferCreateRequest: PostApiPromotionsOfferCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiPromotionsOfferCreateRequest' is not null or undefined
            assertParamExists('postApiPromotionsOfferCreate', 'postApiPromotionsOfferCreateRequest', postApiPromotionsOfferCreateRequest)
            const localVarPath = `/api/promotions/offer/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiPromotionsOfferCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiCatalogProductDeleteRequest} postApiCatalogProductDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiPromotionsOfferDelete: async (postApiCatalogProductDeleteRequest: PostApiCatalogProductDeleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiCatalogProductDeleteRequest' is not null or undefined
            assertParamExists('postApiPromotionsOfferDelete', 'postApiCatalogProductDeleteRequest', postApiCatalogProductDeleteRequest)
            const localVarPath = `/api/promotions/offer/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiCatalogProductDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the update.
         * @param {PostApiPromotionsOfferUpdateIdRequest} postApiPromotionsOfferUpdateIdRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiPromotionsOfferUpdateId: async (id: string, postApiPromotionsOfferUpdateIdRequest: PostApiPromotionsOfferUpdateIdRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('postApiPromotionsOfferUpdateId', 'id', id)
            // verify required parameter 'postApiPromotionsOfferUpdateIdRequest' is not null or undefined
            assertParamExists('postApiPromotionsOfferUpdateId', 'postApiPromotionsOfferUpdateIdRequest', postApiPromotionsOfferUpdateIdRequest)
            const localVarPath = `/api/promotions/offer/update/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiPromotionsOfferUpdateIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiSettingsCcavenueSettingsUpdateRequest} postApiSettingsCcavenueSettingsUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiSettingsCcavenueSettingsUpdate: async (postApiSettingsCcavenueSettingsUpdateRequest: PostApiSettingsCcavenueSettingsUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiSettingsCcavenueSettingsUpdateRequest' is not null or undefined
            assertParamExists('postApiSettingsCcavenueSettingsUpdate', 'postApiSettingsCcavenueSettingsUpdateRequest', postApiSettingsCcavenueSettingsUpdateRequest)
            const localVarPath = `/api/settings/ccavenue-settings/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiSettingsCcavenueSettingsUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiSettingsCurrencyCreateRequest} postApiSettingsCurrencyCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiSettingsCurrencyCreate: async (postApiSettingsCurrencyCreateRequest: PostApiSettingsCurrencyCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiSettingsCurrencyCreateRequest' is not null or undefined
            assertParamExists('postApiSettingsCurrencyCreate', 'postApiSettingsCurrencyCreateRequest', postApiSettingsCurrencyCreateRequest)
            const localVarPath = `/api/settings/currency/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiSettingsCurrencyCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiCatalogTagDeleteRequest} postApiCatalogTagDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiSettingsCurrencyDelete: async (postApiCatalogTagDeleteRequest: PostApiCatalogTagDeleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiCatalogTagDeleteRequest' is not null or undefined
            assertParamExists('postApiSettingsCurrencyDelete', 'postApiCatalogTagDeleteRequest', postApiCatalogTagDeleteRequest)
            const localVarPath = `/api/settings/currency/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiCatalogTagDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiSettingsCurrencyUpdateRequest} postApiSettingsCurrencyUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiSettingsCurrencyUpdate: async (postApiSettingsCurrencyUpdateRequest: PostApiSettingsCurrencyUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiSettingsCurrencyUpdateRequest' is not null or undefined
            assertParamExists('postApiSettingsCurrencyUpdate', 'postApiSettingsCurrencyUpdateRequest', postApiSettingsCurrencyUpdateRequest)
            const localVarPath = `/api/settings/currency/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiSettingsCurrencyUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiSettingsNetworkSettingsUpdateRequest} postApiSettingsNetworkSettingsUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiSettingsNetworkSettingsUpdate: async (postApiSettingsNetworkSettingsUpdateRequest: PostApiSettingsNetworkSettingsUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiSettingsNetworkSettingsUpdateRequest' is not null or undefined
            assertParamExists('postApiSettingsNetworkSettingsUpdate', 'postApiSettingsNetworkSettingsUpdateRequest', postApiSettingsNetworkSettingsUpdateRequest)
            const localVarPath = `/api/settings/network-settings/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiSettingsNetworkSettingsUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the activate.
         * @param {PostApiSettingsOnlinePaymentGatewayActivateIdRequest} postApiSettingsOnlinePaymentGatewayActivateIdRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiSettingsOnlinePaymentCardMethodActivateId: async (id: string, postApiSettingsOnlinePaymentGatewayActivateIdRequest: PostApiSettingsOnlinePaymentGatewayActivateIdRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('postApiSettingsOnlinePaymentCardMethodActivateId', 'id', id)
            // verify required parameter 'postApiSettingsOnlinePaymentGatewayActivateIdRequest' is not null or undefined
            assertParamExists('postApiSettingsOnlinePaymentCardMethodActivateId', 'postApiSettingsOnlinePaymentGatewayActivateIdRequest', postApiSettingsOnlinePaymentGatewayActivateIdRequest)
            const localVarPath = `/api/settings/online-payment/card-method/activate/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiSettingsOnlinePaymentGatewayActivateIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the activate.
         * @param {PostApiSettingsOnlinePaymentGatewayActivateIdRequest} postApiSettingsOnlinePaymentGatewayActivateIdRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiSettingsOnlinePaymentGatewayActivateId: async (id: string, postApiSettingsOnlinePaymentGatewayActivateIdRequest: PostApiSettingsOnlinePaymentGatewayActivateIdRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('postApiSettingsOnlinePaymentGatewayActivateId', 'id', id)
            // verify required parameter 'postApiSettingsOnlinePaymentGatewayActivateIdRequest' is not null or undefined
            assertParamExists('postApiSettingsOnlinePaymentGatewayActivateId', 'postApiSettingsOnlinePaymentGatewayActivateIdRequest', postApiSettingsOnlinePaymentGatewayActivateIdRequest)
            const localVarPath = `/api/settings/online-payment/gateway/activate/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiSettingsOnlinePaymentGatewayActivateIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiSettingsPayfortSettingsUpdateRequest} postApiSettingsPayfortSettingsUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiSettingsPayfortSettingsUpdate: async (postApiSettingsPayfortSettingsUpdateRequest: PostApiSettingsPayfortSettingsUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiSettingsPayfortSettingsUpdateRequest' is not null or undefined
            assertParamExists('postApiSettingsPayfortSettingsUpdate', 'postApiSettingsPayfortSettingsUpdateRequest', postApiSettingsPayfortSettingsUpdateRequest)
            const localVarPath = `/api/settings/payfort-settings/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiSettingsPayfortSettingsUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiSettingsPaymentModeCreateRequest} postApiSettingsPaymentModeCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiSettingsPaymentModeCreate: async (postApiSettingsPaymentModeCreateRequest: PostApiSettingsPaymentModeCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiSettingsPaymentModeCreateRequest' is not null or undefined
            assertParamExists('postApiSettingsPaymentModeCreate', 'postApiSettingsPaymentModeCreateRequest', postApiSettingsPaymentModeCreateRequest)
            const localVarPath = `/api/settings/payment-mode/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiSettingsPaymentModeCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiContentPageDeleteRequest} postApiContentPageDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiSettingsPaymentModeDelete: async (postApiContentPageDeleteRequest: PostApiContentPageDeleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiContentPageDeleteRequest' is not null or undefined
            assertParamExists('postApiSettingsPaymentModeDelete', 'postApiContentPageDeleteRequest', postApiContentPageDeleteRequest)
            const localVarPath = `/api/settings/payment-mode/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiContentPageDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiSettingsPaymentModeUpdateRequest} postApiSettingsPaymentModeUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiSettingsPaymentModeUpdate: async (postApiSettingsPaymentModeUpdateRequest: PostApiSettingsPaymentModeUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiSettingsPaymentModeUpdateRequest' is not null or undefined
            assertParamExists('postApiSettingsPaymentModeUpdate', 'postApiSettingsPaymentModeUpdateRequest', postApiSettingsPaymentModeUpdateRequest)
            const localVarPath = `/api/settings/payment-mode/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiSettingsPaymentModeUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiSettingsPaypalSettingsUpdateRequest} postApiSettingsPaypalSettingsUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiSettingsPaypalSettingsUpdate: async (postApiSettingsPaypalSettingsUpdateRequest: PostApiSettingsPaypalSettingsUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiSettingsPaypalSettingsUpdateRequest' is not null or undefined
            assertParamExists('postApiSettingsPaypalSettingsUpdate', 'postApiSettingsPaypalSettingsUpdateRequest', postApiSettingsPaypalSettingsUpdateRequest)
            const localVarPath = `/api/settings/paypal-settings/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiSettingsPaypalSettingsUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiSettingsStripeSettingsUpdateRequest} [postApiSettingsStripeSettingsUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiSettingsStripeSettingsUpdate: async (postApiSettingsStripeSettingsUpdateRequest?: PostApiSettingsStripeSettingsUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/settings/stripe-settings/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiSettingsStripeSettingsUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiSettingsTabbySettingsUpdateRequest} postApiSettingsTabbySettingsUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiSettingsTabbySettingsUpdate: async (postApiSettingsTabbySettingsUpdateRequest: PostApiSettingsTabbySettingsUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiSettingsTabbySettingsUpdateRequest' is not null or undefined
            assertParamExists('postApiSettingsTabbySettingsUpdate', 'postApiSettingsTabbySettingsUpdateRequest', postApiSettingsTabbySettingsUpdateRequest)
            const localVarPath = `/api/settings/tabby-settings/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiSettingsTabbySettingsUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiSettingsTamaraSettingsUpdateRequest} postApiSettingsTamaraSettingsUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiSettingsTamaraSettingsUpdate: async (postApiSettingsTamaraSettingsUpdateRequest: PostApiSettingsTamaraSettingsUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiSettingsTamaraSettingsUpdateRequest' is not null or undefined
            assertParamExists('postApiSettingsTamaraSettingsUpdate', 'postApiSettingsTamaraSettingsUpdateRequest', postApiSettingsTamaraSettingsUpdateRequest)
            const localVarPath = `/api/settings/tamara-settings/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiSettingsTamaraSettingsUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiShippingCostCalculatorRequest} postApiShippingCostCalculatorRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiShippingCostCalculator: async (postApiShippingCostCalculatorRequest: PostApiShippingCostCalculatorRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiShippingCostCalculatorRequest' is not null or undefined
            assertParamExists('postApiShippingCostCalculator', 'postApiShippingCostCalculatorRequest', postApiShippingCostCalculatorRequest)
            const localVarPath = `/api/shipping/cost-calculator`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiShippingCostCalculatorRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiShippingFlatRateCreateRequest} postApiShippingFlatRateCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiShippingFlatRateCreate: async (postApiShippingFlatRateCreateRequest: PostApiShippingFlatRateCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiShippingFlatRateCreateRequest' is not null or undefined
            assertParamExists('postApiShippingFlatRateCreate', 'postApiShippingFlatRateCreateRequest', postApiShippingFlatRateCreateRequest)
            const localVarPath = `/api/shipping/flat-rate/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiShippingFlatRateCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiCatalogCategoryDeleteRequest} postApiCatalogCategoryDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiShippingFlatRateDelete: async (postApiCatalogCategoryDeleteRequest: PostApiCatalogCategoryDeleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiCatalogCategoryDeleteRequest' is not null or undefined
            assertParamExists('postApiShippingFlatRateDelete', 'postApiCatalogCategoryDeleteRequest', postApiCatalogCategoryDeleteRequest)
            const localVarPath = `/api/shipping/flat-rate/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiCatalogCategoryDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiShippingFlatRateUpdateRequest} postApiShippingFlatRateUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiShippingFlatRateUpdate: async (postApiShippingFlatRateUpdateRequest: PostApiShippingFlatRateUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiShippingFlatRateUpdateRequest' is not null or undefined
            assertParamExists('postApiShippingFlatRateUpdate', 'postApiShippingFlatRateUpdateRequest', postApiShippingFlatRateUpdateRequest)
            const localVarPath = `/api/shipping/flat-rate/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiShippingFlatRateUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiShippingShippingDetailsCreateRequest} postApiShippingShippingDetailsCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiShippingShippingDetailsCreate: async (postApiShippingShippingDetailsCreateRequest: PostApiShippingShippingDetailsCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiShippingShippingDetailsCreateRequest' is not null or undefined
            assertParamExists('postApiShippingShippingDetailsCreate', 'postApiShippingShippingDetailsCreateRequest', postApiShippingShippingDetailsCreateRequest)
            const localVarPath = `/api/shipping/shipping-details/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiShippingShippingDetailsCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiShippingShippingDetailsDeleteRequest} postApiShippingShippingDetailsDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiShippingShippingDetailsDelete: async (postApiShippingShippingDetailsDeleteRequest: PostApiShippingShippingDetailsDeleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiShippingShippingDetailsDeleteRequest' is not null or undefined
            assertParamExists('postApiShippingShippingDetailsDelete', 'postApiShippingShippingDetailsDeleteRequest', postApiShippingShippingDetailsDeleteRequest)
            const localVarPath = `/api/shipping/shipping-details/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiShippingShippingDetailsDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiShippingShippingDetailsUpdateRequest} postApiShippingShippingDetailsUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiShippingShippingDetailsUpdate: async (postApiShippingShippingDetailsUpdateRequest: PostApiShippingShippingDetailsUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiShippingShippingDetailsUpdateRequest' is not null or undefined
            assertParamExists('postApiShippingShippingDetailsUpdate', 'postApiShippingShippingDetailsUpdateRequest', postApiShippingShippingDetailsUpdateRequest)
            const localVarPath = `/api/shipping/shipping-details/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiShippingShippingDetailsUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiShippingShippingServiceCreateRequest} postApiShippingShippingServiceCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiShippingShippingServiceCreate: async (postApiShippingShippingServiceCreateRequest: PostApiShippingShippingServiceCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiShippingShippingServiceCreateRequest' is not null or undefined
            assertParamExists('postApiShippingShippingServiceCreate', 'postApiShippingShippingServiceCreateRequest', postApiShippingShippingServiceCreateRequest)
            const localVarPath = `/api/shipping/shipping-service/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiShippingShippingServiceCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiShippingShippingServiceDeleteRequest} postApiShippingShippingServiceDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiShippingShippingServiceDelete: async (postApiShippingShippingServiceDeleteRequest: PostApiShippingShippingServiceDeleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiShippingShippingServiceDeleteRequest' is not null or undefined
            assertParamExists('postApiShippingShippingServiceDelete', 'postApiShippingShippingServiceDeleteRequest', postApiShippingShippingServiceDeleteRequest)
            const localVarPath = `/api/shipping/shipping-service/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiShippingShippingServiceDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiShippingShippingServiceUpdateRequest} postApiShippingShippingServiceUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiShippingShippingServiceUpdate: async (postApiShippingShippingServiceUpdateRequest: PostApiShippingShippingServiceUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiShippingShippingServiceUpdateRequest' is not null or undefined
            assertParamExists('postApiShippingShippingServiceUpdate', 'postApiShippingShippingServiceUpdateRequest', postApiShippingShippingServiceUpdateRequest)
            const localVarPath = `/api/shipping/shipping-service/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiShippingShippingServiceUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the activate.
         * @param {GetApiSettingsCurrencyIdRequest} [getApiSettingsCurrencyIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiThemeActivateId: async (id: string, getApiSettingsCurrencyIdRequest?: GetApiSettingsCurrencyIdRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('postApiThemeActivateId', 'id', id)
            const localVarPath = `/api/theme/activate/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getApiSettingsCurrencyIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new theme
         * @param {PostApiThemeCreateRequest} [postApiThemeCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiThemeCreate: async (postApiThemeCreateRequest?: PostApiThemeCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/theme/create`;
    
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(postApiThemeCreateRequest, localVarRequestOptions, configuration);

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a theme's color palette
         * @param {number} id 
         * @param {PostApiThemeColorUpdateIdRequest} [postApiThemeColorUpdateIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiThemeColorUpdateId: async (id: number, postApiThemeColorUpdateIdRequest?: PostApiThemeColorUpdateIdRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('postApiThemeColorUpdateId', 'id', id)
            const localVarPath = `/api/theme/color/update/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
        
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
        
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
        
            localVarHeaderParameter['Content-Type'] = 'application/json';
        
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(postApiThemeColorUpdateIdRequest, localVarRequestOptions, configuration);
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the update.
         * @param {PostApiThemeSettingsUpdateIdRequest} [postApiThemeSettingsUpdateIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiThemeSettingsUpdateId: async (id: string, postApiThemeSettingsUpdateIdRequest?: PostApiThemeSettingsUpdateIdRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('postApiThemeSettingsUpdateId', 'id', id)
            const localVarPath = `/api/theme/settings/update/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiThemeSettingsUpdateIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a saved color theme
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApiThemeColorId: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteApiThemeColorId', 'id', id)
            const localVarPath = `/api/theme/color/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
        
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
        
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
        
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {File} themeZip Must be a file.
         * @param {string} [name] Must not be greater than 255 characters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiThemeUpload: async (themeZip: File, name?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'themeZip' is not null or undefined
            assertParamExists('postApiThemeUpload', 'themeZip', themeZip)
            const localVarPath = `/api/theme/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (themeZip !== undefined) { 
                localVarFormParams.append('theme_zip', themeZip as any);
            }

            if (name !== undefined) { 
                localVarFormParams.append('name', name as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiUserPermissionsUpdateRequest} postApiUserPermissionsUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiUserPermissionsUpdate: async (postApiUserPermissionsUpdateRequest: PostApiUserPermissionsUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiUserPermissionsUpdateRequest' is not null or undefined
            assertParamExists('postApiUserPermissionsUpdate', 'postApiUserPermissionsUpdateRequest', postApiUserPermissionsUpdateRequest)
            const localVarPath = `/api/user/permissions/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiUserPermissionsUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiUserRoleCreateRequest} postApiUserRoleCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiUserRoleCreate: async (postApiUserRoleCreateRequest: PostApiUserRoleCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiUserRoleCreateRequest' is not null or undefined
            assertParamExists('postApiUserRoleCreate', 'postApiUserRoleCreateRequest', postApiUserRoleCreateRequest)
            const localVarPath = `/api/user/role/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiUserRoleCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostApiUserRoleDeleteRequest} postApiUserRoleDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiUserRoleDelete: async (postApiUserRoleDeleteRequest: PostApiUserRoleDeleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postApiUserRoleDeleteRequest' is not null or undefined
            assertParamExists('postApiUserRoleDelete', 'postApiUserRoleDeleteRequest', postApiUserRoleDeleteRequest)
            const localVarPath = `/api/user/role/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiUserRoleDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} role 
         * @param {PostApiUserRoleUpdateRoleRequest} postApiUserRoleUpdateRoleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiUserRoleUpdateRole: async (role: string, postApiUserRoleUpdateRoleRequest: PostApiUserRoleUpdateRoleRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'role' is not null or undefined
            assertParamExists('postApiUserRoleUpdateRole', 'role', role)
            // verify required parameter 'postApiUserRoleUpdateRoleRequest' is not null or undefined
            assertParamExists('postApiUserRoleUpdateRole', 'postApiUserRoleUpdateRoleRequest', postApiUserRoleUpdateRoleRequest)
            const localVarPath = `/api/user/role/update/{role}`
                .replace(`{${"role"}}`, encodeURIComponent(String(role)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiUserRoleUpdateRoleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFrontLogin: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/front/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the rate.
         * @param {PostFrontProductRateIdRequest} [postFrontProductRateIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFrontProductRateId: async (id: string, postFrontProductRateIdRequest?: PostFrontProductRateIdRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('postFrontProductRateId', 'id', id)
            const localVarPath = `/front/product/rate/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postFrontProductRateIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFrontRegister: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/front/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFrontReset: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/front/reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFrontResetPassword: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/front/reset-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostV1BannerCreateRequest} postV1BannerCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postV1BannerCreate: async (postV1BannerCreateRequest: PostV1BannerCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postV1BannerCreateRequest' is not null or undefined
            assertParamExists('postV1BannerCreate', 'postV1BannerCreateRequest', postV1BannerCreateRequest)
            const localVarPath = `/v1/banner/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postV1BannerCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostV1BannerDeleteRequest} [postV1BannerDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postV1BannerDelete: async (postV1BannerDeleteRequest?: PostV1BannerDeleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/banner/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postV1BannerDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostV1BannerUpdateRequest} postV1BannerUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postV1BannerUpdate: async (postV1BannerUpdateRequest: PostV1BannerUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postV1BannerUpdateRequest' is not null or undefined
            assertParamExists('postV1BannerUpdate', 'postV1BannerUpdateRequest', postV1BannerUpdateRequest)
            const localVarPath = `/v1/banner/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postV1BannerUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostV1FooterCreateRequest} postV1FooterCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postV1FooterCreate: async (postV1FooterCreateRequest: PostV1FooterCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postV1FooterCreateRequest' is not null or undefined
            assertParamExists('postV1FooterCreate', 'postV1FooterCreateRequest', postV1FooterCreateRequest)
            const localVarPath = `/v1/footer/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postV1FooterCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostV1FooterDeleteRequest} [postV1FooterDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postV1FooterDelete: async (postV1FooterDeleteRequest?: PostV1FooterDeleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/footer/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postV1FooterDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostV1FooterUpdateRequest} postV1FooterUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postV1FooterUpdate: async (postV1FooterUpdateRequest: PostV1FooterUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postV1FooterUpdateRequest' is not null or undefined
            assertParamExists('postV1FooterUpdate', 'postV1FooterUpdateRequest', postV1FooterUpdateRequest)
            const localVarPath = `/v1/footer/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postV1FooterUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postV1Login: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostV1MenuCreateRequest} postV1MenuCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postV1MenuCreate: async (postV1MenuCreateRequest: PostV1MenuCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postV1MenuCreateRequest' is not null or undefined
            assertParamExists('postV1MenuCreate', 'postV1MenuCreateRequest', postV1MenuCreateRequest)
            const localVarPath = `/v1/menu/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postV1MenuCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostV1MenuDeleteRequest} [postV1MenuDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postV1MenuDelete: async (postV1MenuDeleteRequest?: PostV1MenuDeleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/menu/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postV1MenuDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the update.
         * @param {PostV1MenuUpdateIdRequest} postV1MenuUpdateIdRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postV1MenuUpdateId: async (id: string, postV1MenuUpdateIdRequest: PostV1MenuUpdateIdRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('postV1MenuUpdateId', 'id', id)
            // verify required parameter 'postV1MenuUpdateIdRequest' is not null or undefined
            assertParamExists('postV1MenuUpdateId', 'postV1MenuUpdateIdRequest', postV1MenuUpdateIdRequest)
            const localVarPath = `/v1/menu/update/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postV1MenuUpdateIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostV1NavbarModeUpdateRequest} postV1NavbarModeUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postV1NavbarModeUpdate: async (postV1NavbarModeUpdateRequest: PostV1NavbarModeUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postV1NavbarModeUpdateRequest' is not null or undefined
            assertParamExists('postV1NavbarModeUpdate', 'postV1NavbarModeUpdateRequest', postV1NavbarModeUpdateRequest)
            const localVarPath = `/v1/navbar-mode/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(postV1NavbarModeUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postV1Register: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postV1Reset: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postV1ResetPassword: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/reset-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} cartItemId 
         * @param {PutApiCartItemsCartItemIdRequest} putApiCartItemsCartItemIdRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putApiCartItemsCartItemId: async (cartItemId: string, putApiCartItemsCartItemIdRequest: PutApiCartItemsCartItemIdRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cartItemId' is not null or undefined
            assertParamExists('putApiCartItemsCartItemId', 'cartItemId', cartItemId)
            // verify required parameter 'putApiCartItemsCartItemIdRequest' is not null or undefined
            assertParamExists('putApiCartItemsCartItemId', 'putApiCartItemsCartItemIdRequest', putApiCartItemsCartItemIdRequest)
            const localVarPath = `/api/cart/items/{cartItemId}`
                .replace(`{${"cartItemId"}}`, encodeURIComponent(String(cartItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putApiCartItemsCartItemIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Serve the generated OpenAPI YAML file.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serveTheGeneratedOpenAPIYAMLFile: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/docs/openapi.yaml`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EndpointsApi - functional programming interface
 */
export const EndpointsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EndpointsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteApiCartClear(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteApiCartClear(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.deleteApiCartClear']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} cartItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteApiCartItemsCartItemId(cartItemId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteApiCartItemsCartItemId(cartItemId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.deleteApiCartItemsCartItemId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Execute the job.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async executeTheJob(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.executeTheJob(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.executeTheJob']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiAccountsDebugAuth(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetApiAccountsDebugAuth200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiAccountsDebugAuth(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiAccountsDebugAuth']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {GetApiAdminCartsRequest} [getApiAdminCartsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiAdminCarts(getApiAdminCartsRequest?: GetApiAdminCartsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiAdminCarts(getApiAdminCartsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiAdminCarts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiAmazonSettings(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiAmazonSettings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiAmazonSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiAramexSettings(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiAramexSettings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiAramexSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the seo.
         * @param {GetApiAttributesSeoIdRequest} [getApiAttributesSeoIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiAttributesSeoId(id: string, getApiAttributesSeoIdRequest?: GetApiAttributesSeoIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiAttributesSeoId(id, getApiAttributesSeoIdRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiAttributesSeoId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {GetApiAttributesSeosRequest} [getApiAttributesSeosRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiAttributesSeos(getApiAttributesSeosRequest?: GetApiAttributesSeosRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiAttributesSeos(getApiAttributesSeosRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiAttributesSeos']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the credit.
         * @param {GetApiBillingCreditIdRequest} [getApiBillingCreditIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiBillingCreditId(id: string, getApiBillingCreditIdRequest?: GetApiBillingCreditIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiBillingCreditId(id, getApiBillingCreditIdRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiBillingCreditId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {GetApiBillingCreditsRequest} [getApiBillingCreditsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiBillingCredits(getApiBillingCreditsRequest?: GetApiBillingCreditsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiBillingCredits(getApiBillingCreditsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiBillingCredits']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiCart(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiCart(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiCart']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiCartDetails(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiCartDetails(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiCartDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the attribute.
         * @param {GetApiCatalogAttributeIdRequest} [getApiCatalogAttributeIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiCatalogAttributeId(id: string, getApiCatalogAttributeIdRequest?: GetApiCatalogAttributeIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiCatalogAttributeId(id, getApiCatalogAttributeIdRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiCatalogAttributeId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the attribute value.
         * @param {PostV1FooterDeleteRequest} [postV1FooterDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiCatalogAttributeValueId(id: string, postV1FooterDeleteRequest?: PostV1FooterDeleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiCatalogAttributeValueId(id, postV1FooterDeleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiCatalogAttributeValueId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {GetApiContentPageIdRequest} [getApiContentPageIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiCatalogAttributes(getApiContentPageIdRequest?: GetApiContentPageIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiCatalogAttributes(getApiContentPageIdRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiCatalogAttributes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {GetApiCatalogAttributesValuesRequest} [getApiCatalogAttributesValuesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiCatalogAttributesValues(getApiCatalogAttributesValuesRequest?: GetApiCatalogAttributesValuesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiCatalogAttributesValues(getApiCatalogAttributesValuesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiCatalogAttributesValues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the brand.
         * @param {GetApiCatalogBrandIdRequest} [getApiCatalogBrandIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiCatalogBrandId(id: string, getApiCatalogBrandIdRequest?: GetApiCatalogBrandIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiCatalogBrandId(id, getApiCatalogBrandIdRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiCatalogBrandId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {GetApiCatalogBrandsRequest} [getApiCatalogBrandsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiCatalogBrands(getApiCatalogBrandsRequest?: GetApiCatalogBrandsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiCatalogBrands(getApiCatalogBrandsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiCatalogBrands']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {GetApiCatalogCategoriesRequest} [getApiCatalogCategoriesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiCatalogCategories(getApiCatalogCategoriesRequest?: GetApiCatalogCategoriesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiCatalogCategories(getApiCatalogCategoriesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiCatalogCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the category.
         * @param {GetApiCatalogCategoryIdRequest} [getApiCatalogCategoryIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiCatalogCategoryId(id: string, getApiCatalogCategoryIdRequest?: GetApiCatalogCategoryIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiCatalogCategoryId(id, getApiCatalogCategoryIdRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiCatalogCategoryId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the product attribute.
         * @param {GetApiCatalogAttributesValuesRequest} [getApiCatalogAttributesValuesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiCatalogProductAttributesId(id: string, getApiCatalogAttributesValuesRequest?: GetApiCatalogAttributesValuesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiCatalogProductAttributesId(id, getApiCatalogAttributesValuesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiCatalogProductAttributesId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the product.
         * @param {GetApiCatalogProductIdRequest} [getApiCatalogProductIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiCatalogProductId(id: string, getApiCatalogProductIdRequest?: GetApiCatalogProductIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiCatalogProductId(id, getApiCatalogProductIdRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiCatalogProductId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {GetApiCatalogProductSearchRequest} [getApiCatalogProductSearchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiCatalogProductSearch(getApiCatalogProductSearchRequest?: GetApiCatalogProductSearchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiCatalogProductSearch(getApiCatalogProductSearchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiCatalogProductSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {GetApiCatalogProductsRequest} [getApiCatalogProductsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiCatalogProducts(getApiCatalogProductsRequest?: GetApiCatalogProductsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiCatalogProducts(getApiCatalogProductsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiCatalogProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {GetApiCatalogProductsAttributesRequest} [getApiCatalogProductsAttributesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiCatalogProductsAttributes(getApiCatalogProductsAttributesRequest?: GetApiCatalogProductsAttributesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiCatalogProductsAttributes(getApiCatalogProductsAttributesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiCatalogProductsAttributes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiCatalogProductsExport(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiCatalogProductsExport(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiCatalogProductsExport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the store.
         * @param {GetApiCatalogStoreIdRequest} [getApiCatalogStoreIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiCatalogStoreId(id: string, getApiCatalogStoreIdRequest?: GetApiCatalogStoreIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiCatalogStoreId(id, getApiCatalogStoreIdRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiCatalogStoreId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {GetApiCatalogStoresRequest} [getApiCatalogStoresRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiCatalogStores(getApiCatalogStoresRequest?: GetApiCatalogStoresRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiCatalogStores(getApiCatalogStoresRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiCatalogStores']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the tag.
         * @param {GetApiCatalogTagIdRequest} [getApiCatalogTagIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiCatalogTagId(id: string, getApiCatalogTagIdRequest?: GetApiCatalogTagIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiCatalogTagId(id, getApiCatalogTagIdRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiCatalogTagId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {GetApiCatalogTagsRequest} [getApiCatalogTagsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiCatalogTags(getApiCatalogTagsRequest?: GetApiCatalogTagsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiCatalogTags(getApiCatalogTagsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiCatalogTags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the user.
         * @param {GetUsersRequest1} [getUsersRequest1] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiClientUserId(id: string, getUsersRequest1?: GetUsersRequest1, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiClientUserId(id, getUsersRequest1, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiClientUserId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the newsletter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiCommunicationsNewsletterId(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiCommunicationsNewsletterId(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiCommunicationsNewsletterId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiCommunicationsNewsletters(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiCommunicationsNewsletters(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiCommunicationsNewsletters']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the subscriber.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiCommunicationsSubscriberId(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiCommunicationsSubscriberId(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiCommunicationsSubscriberId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiCommunicationsSubscribers(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiCommunicationsSubscribers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiCommunicationsSubscribers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the page.
         * @param {GetApiContentPageIdRequest} [getApiContentPageIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiContentPageId(id: string, getApiContentPageIdRequest?: GetApiContentPageIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiContentPageId(id, getApiContentPageIdRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiContentPageId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {GetApiContentPagesRequest} [getApiContentPagesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiContentPages(getApiContentPagesRequest?: GetApiContentPagesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiContentPages(getApiContentPagesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiContentPages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiDashStats(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiDashStats(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiDashStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiInstashopSettings(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiInstashopSettings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiInstashopSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {GetApiInvoicesSettingsRequest} [getApiInvoicesSettingsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiInvoicesSettings(getApiInvoicesSettingsRequest?: GetApiInvoicesSettingsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiInvoicesSettings(getApiInvoicesSettingsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiInvoicesSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the setting.
         * @param {GetApiInvoicesSettingsIdRequest} [getApiInvoicesSettingsIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiInvoicesSettingsId(id: string, getApiInvoicesSettingsIdRequest?: GetApiInvoicesSettingsIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiInvoicesSettingsId(id, getApiInvoicesSettingsIdRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiInvoicesSettingsId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {GetApiContentPagesRequest} [getApiContentPagesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiMediaFiles(getApiContentPagesRequest?: GetApiContentPagesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiMediaFiles(getApiContentPagesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiMediaFiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the file.
         * @param {GetApiMediaFilesIdRequest} [getApiMediaFilesIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiMediaFilesId(id: string, getApiMediaFilesIdRequest?: GetApiMediaFilesIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiMediaFilesId(id, getApiMediaFilesIdRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiMediaFilesId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {GetApiMediaSearchRequest} [getApiMediaSearchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiMediaSearch(getApiMediaSearchRequest?: GetApiMediaSearchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiMediaSearch(getApiMediaSearchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiMediaSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiMediaSettingsSizes(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiMediaSettingsSizes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiMediaSettingsSizes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiMediaThumbThumbs(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiMediaThumbThumbs(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiMediaThumbThumbs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiNoonSettings(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiNoonSettings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiNoonSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {GetApiOrdersExportRequest} [getApiOrdersExportRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiOrdersExport(getApiOrdersExportRequest?: GetApiOrdersExportRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiOrdersExport(getApiOrdersExportRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiOrdersExport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the order.
         * @param {GetApiOrdersOrderIdRequest} [getApiOrdersOrderIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiOrdersOrderId(id: string, getApiOrdersOrderIdRequest?: GetApiOrdersOrderIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiOrdersOrderId(id, getApiOrdersOrderIdRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiOrdersOrderId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {GetApiOrdersOrdersRequest} [getApiOrdersOrdersRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiOrdersOrders(getApiOrdersOrdersRequest?: GetApiOrdersOrdersRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiOrdersOrders(getApiOrdersOrdersRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiOrdersOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiOrdersStatus(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiOrdersStatus(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiOrdersStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the status.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiOrdersStatusId(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiOrdersStatusId(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiOrdersStatusId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} path 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiPath(path: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiPath(path, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiPath']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the code.
         * @param {GetApiPromotionsCodeIdRequest} [getApiPromotionsCodeIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiPromotionsCodeId(id: string, getApiPromotionsCodeIdRequest?: GetApiPromotionsCodeIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiPromotionsCodeId(id, getApiPromotionsCodeIdRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiPromotionsCodeId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {GetApiPromotionsCodesRequest} [getApiPromotionsCodesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiPromotionsCodes(getApiPromotionsCodesRequest?: GetApiPromotionsCodesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiPromotionsCodes(getApiPromotionsCodesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiPromotionsCodes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the offer.
         * @param {GetApiPromotionsOfferIdRequest} [getApiPromotionsOfferIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiPromotionsOfferId(id: string, getApiPromotionsOfferIdRequest?: GetApiPromotionsOfferIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiPromotionsOfferId(id, getApiPromotionsOfferIdRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiPromotionsOfferId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {GetApiPromotionsOffersRequest} [getApiPromotionsOffersRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiPromotionsOffers(getApiPromotionsOffersRequest?: GetApiPromotionsOffersRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiPromotionsOffers(getApiPromotionsOffersRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiPromotionsOffers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiSalesPingg(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetV1TestPing200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiSalesPingg(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiSalesPingg']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiSettingsCcavenueSettings(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiSettingsCcavenueSettings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiSettingsCcavenueSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {GetApiSettingsCurrenciesRequest} [getApiSettingsCurrenciesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiSettingsCurrencies(getApiSettingsCurrenciesRequest?: GetApiSettingsCurrenciesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiSettingsCurrencies(getApiSettingsCurrenciesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiSettingsCurrencies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the currency.
         * @param {GetApiSettingsCurrencyIdRequest} [getApiSettingsCurrencyIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiSettingsCurrencyId(id: string, getApiSettingsCurrencyIdRequest?: GetApiSettingsCurrencyIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiSettingsCurrencyId(id, getApiSettingsCurrencyIdRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiSettingsCurrencyId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiSettingsNetworkSettings(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiSettingsNetworkSettings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiSettingsNetworkSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiSettingsOnlinePaymentCardMethods(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiSettingsOnlinePaymentCardMethods(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiSettingsOnlinePaymentCardMethods']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiSettingsOnlinePaymentGateways(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiSettingsOnlinePaymentGateways(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiSettingsOnlinePaymentGateways']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiSettingsPayfortSettings(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiSettingsPayfortSettings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiSettingsPayfortSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the payment mode.
         * @param {GetApiSettingsPaymentModeIdRequest} [getApiSettingsPaymentModeIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiSettingsPaymentModeId(id: string, getApiSettingsPaymentModeIdRequest?: GetApiSettingsPaymentModeIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiSettingsPaymentModeId(id, getApiSettingsPaymentModeIdRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiSettingsPaymentModeId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {GetApiSettingsPaymentModesRequest} [getApiSettingsPaymentModesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiSettingsPaymentModes(getApiSettingsPaymentModesRequest?: GetApiSettingsPaymentModesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiSettingsPaymentModes(getApiSettingsPaymentModesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiSettingsPaymentModes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiSettingsPaypalSettings(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiSettingsPaypalSettings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiSettingsPaypalSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiSettingsStripeSettings(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiSettingsStripeSettings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiSettingsStripeSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiSettingsTabbySettings(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiSettingsTabbySettings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiSettingsTabbySettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiSettingsTamaraSettings(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiSettingsTamaraSettings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiSettingsTamaraSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the flat rate.
         * @param {GetApiShippingFlatRateIdRequest} [getApiShippingFlatRateIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiShippingFlatRateId(id: string, getApiShippingFlatRateIdRequest?: GetApiShippingFlatRateIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiShippingFlatRateId(id, getApiShippingFlatRateIdRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiShippingFlatRateId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {GetApiShippingFlatRatesRequest} [getApiShippingFlatRatesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiShippingFlatRates(getApiShippingFlatRatesRequest?: GetApiShippingFlatRatesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiShippingFlatRates(getApiShippingFlatRatesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiShippingFlatRates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} username 
         * @param {GetApiShippingShippingDetailUsernameRequest} [getApiShippingShippingDetailUsernameRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiShippingShippingDetailUsername(username: string, getApiShippingShippingDetailUsernameRequest?: GetApiShippingShippingDetailUsernameRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiShippingShippingDetailUsername(username, getApiShippingShippingDetailUsernameRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiShippingShippingDetailUsername']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {GetApiShippingShippingDetailsRequest} [getApiShippingShippingDetailsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiShippingShippingDetails(getApiShippingShippingDetailsRequest?: GetApiShippingShippingDetailsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiShippingShippingDetails(getApiShippingShippingDetailsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiShippingShippingDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the shipping service.
         * @param {GetApiShippingShippingServiceIdRequest} [getApiShippingShippingServiceIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiShippingShippingServiceId(id: string, getApiShippingShippingServiceIdRequest?: GetApiShippingShippingServiceIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiShippingShippingServiceId(id, getApiShippingShippingServiceIdRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiShippingShippingServiceId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {GetApiShippingShippingServicesRequest} [getApiShippingShippingServicesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiShippingShippingServices(getApiShippingShippingServicesRequest?: GetApiShippingShippingServicesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiShippingShippingServices(getApiShippingShippingServicesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiShippingShippingServices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiThemeActive(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiThemeActive(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiThemeActive']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiThemes(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiThemes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiThemes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {GetApiUserPermissionsRequest} [getApiUserPermissionsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiUserPermissions(getApiUserPermissionsRequest?: GetApiUserPermissionsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiUserPermissions(getApiUserPermissionsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiUserPermissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} role 
         * @param {GetApiUserPermissionsRoleRequest} [getApiUserPermissionsRoleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiUserPermissionsRole(role: string, getApiUserPermissionsRoleRequest?: GetApiUserPermissionsRoleRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiUserPermissionsRole(role, getApiUserPermissionsRoleRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getApiUserPermissionsRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the banner.
         * @param {GetFrontBannerIdRequest} [getFrontBannerIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFrontBannerId(id: string, getFrontBannerIdRequest?: GetFrontBannerIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetV1CountriesCountries200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFrontBannerId(id, getFrontBannerIdRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getFrontBannerId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {GetFrontBannersRequest} [getFrontBannersRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFrontBanners(getFrontBannersRequest?: GetFrontBannersRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFrontBanners200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFrontBanners(getFrontBannersRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getFrontBanners']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the brand.
         * @param {GetFrontBrandIdRequest} [getFrontBrandIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFrontBrandId(id: string, getFrontBrandIdRequest?: GetFrontBrandIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFrontBrandId(id, getFrontBrandIdRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getFrontBrandId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {GetFrontBrandsRequest} [getFrontBrandsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFrontBrands(getFrontBrandsRequest?: GetFrontBrandsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFrontBrands200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFrontBrands(getFrontBrandsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getFrontBrands']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {GetFrontCategoriesRequest} [getFrontCategoriesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFrontCategories(getFrontCategoriesRequest?: GetFrontCategoriesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFrontCategories200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFrontCategories(getFrontCategoriesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getFrontCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the category.
         * @param {GetFrontCategoryIdRequest} [getFrontCategoryIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFrontCategoryId(id: string, getFrontCategoryIdRequest?: GetFrontCategoryIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFrontCategoryId(id, getFrontCategoryIdRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getFrontCategoryId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the footer.
         * @param {GetFrontFooterIdRequest} [getFrontFooterIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFrontFooterId(id: string, getFrontFooterIdRequest?: GetFrontFooterIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetV1CountriesCountries200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFrontFooterId(id, getFrontFooterIdRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getFrontFooterId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {GetFrontFootersRequest} [getFrontFootersRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFrontFooters(getFrontFootersRequest?: GetFrontFootersRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetV1CountriesCountries200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFrontFooters(getFrontFootersRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getFrontFooters']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFrontLogout(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFrontLogout(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getFrontLogout']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the menu.
         * @param {GetFrontMenuIdRequest} [getFrontMenuIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFrontMenuId(id: string, getFrontMenuIdRequest?: GetFrontMenuIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetV1CountriesCountries200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFrontMenuId(id, getFrontMenuIdRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getFrontMenuId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {GetFrontMenusRequest} [getFrontMenusRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFrontMenus(getFrontMenusRequest?: GetFrontMenusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetV1CountriesCountries200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFrontMenus(getFrontMenusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getFrontMenus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFrontNavbarMode(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFrontNavbarMode(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getFrontNavbarMode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the product.
         * @param {GetFrontProductIdRequest} [getFrontProductIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFrontProductId(id: string, getFrontProductIdRequest?: GetFrontProductIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFrontProductId(id, getFrontProductIdRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getFrontProductId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {GetFrontProductsRequest} [getFrontProductsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFrontProducts(getFrontProductsRequest?: GetFrontProductsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFrontProducts200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFrontProducts(getFrontProductsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getFrontProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the seo.
         * @param {GetFrontSeoIdRequest} [getFrontSeoIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFrontSeoId(id: string, getFrontSeoIdRequest?: GetFrontSeoIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetV1CountriesCountries200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFrontSeoId(id, getFrontSeoIdRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getFrontSeoId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {GetFrontMenuIdRequest} [getFrontMenuIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFrontSeos(getFrontMenuIdRequest?: GetFrontMenuIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetV1CountriesCountries200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFrontSeos(getFrontMenuIdRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getFrontSeos']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFrontTestPing(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetV1TestPing200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFrontTestPing(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getFrontTestPing']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFrontThemeActive(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFrontThemeActive(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getFrontThemeActive']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFrontVerifyResetPasswordToken(token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFrontVerifyResetPasswordToken(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getFrontVerifyResetPasswordToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFrontVerifyToken(token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFrontVerifyToken(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getFrontVerifyToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the banner.
         * @param {GetV1BannersRequest} [getV1BannersRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getV1BannerId(id: string, getV1BannersRequest?: GetV1BannersRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getV1BannerId(id, getV1BannersRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getV1BannerId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {GetV1BannersRequest} [getV1BannersRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getV1Banners(getV1BannersRequest?: GetV1BannersRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getV1Banners(getV1BannersRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getV1Banners']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getV1ClearAllCache(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getV1ClearAllCache(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getV1ClearAllCache']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getV1CountriesCountries(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetV1CountriesCountries200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getV1CountriesCountries(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getV1CountriesCountries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the country.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getV1CountriesCountryId(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getV1CountriesCountryId(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getV1CountriesCountryId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the footer.
         * @param {GetV1FooterIdRequest} [getV1FooterIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getV1FooterId(id: string, getV1FooterIdRequest?: GetV1FooterIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getV1FooterId(id, getV1FooterIdRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getV1FooterId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {GetV1FootersRequest} [getV1FootersRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getV1Footers(getV1FootersRequest?: GetV1FootersRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getV1Footers(getV1FootersRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getV1Footers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getV1Logout(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getV1Logout(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getV1Logout']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the menu.
         * @param {GetV1MenuIdRequest} [getV1MenuIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getV1MenuId(id: string, getV1MenuIdRequest?: GetV1MenuIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getV1MenuId(id, getV1MenuIdRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getV1MenuId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {GetV1MenusRequest} [getV1MenusRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getV1Menus(getV1MenusRequest?: GetV1MenusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getV1Menus(getV1MenusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getV1Menus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getV1TestPing(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetV1TestPing200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getV1TestPing(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getV1TestPing']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getV1VerifyResetPasswordToken(token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getV1VerifyResetPasswordToken(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getV1VerifyResetPasswordToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getV1VerifyToken(token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getV1VerifyToken(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.getV1VerifyToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the shipping service.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchApiShippingShippingServiceIdActivate(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchApiShippingShippingServiceIdActivate(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.patchApiShippingShippingServiceIdActivate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiAccountsUserCreateRequest} postApiAccountsUserCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiAccountsUserCreate(postApiAccountsUserCreateRequest: PostApiAccountsUserCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiAccountsUserCreate(postApiAccountsUserCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiAccountsUserCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiAccountsUserDeleteRequest} postApiAccountsUserDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiAccountsUserDelete(postApiAccountsUserDeleteRequest: PostApiAccountsUserDeleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiAccountsUserDelete(postApiAccountsUserDeleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiAccountsUserDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the update.
         * @param {PostApiAccountsUserUpdateIdRequest} postApiAccountsUserUpdateIdRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiAccountsUserUpdateId(id: string, postApiAccountsUserUpdateIdRequest: PostApiAccountsUserUpdateIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiAccountsUserUpdateId(id, postApiAccountsUserUpdateIdRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiAccountsUserUpdateId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiAmazonSettingsUpdateRequest} [postApiAmazonSettingsUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiAmazonSettingsUpdate(postApiAmazonSettingsUpdateRequest?: PostApiAmazonSettingsUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiAmazonSettingsUpdate(postApiAmazonSettingsUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiAmazonSettingsUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiAramexSettingsUpdateRequest} [postApiAramexSettingsUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiAramexSettingsUpdate(postApiAramexSettingsUpdateRequest?: PostApiAramexSettingsUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiAramexSettingsUpdate(postApiAramexSettingsUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiAramexSettingsUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiAttributesSeoCreateRequest} postApiAttributesSeoCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiAttributesSeoCreate(postApiAttributesSeoCreateRequest: PostApiAttributesSeoCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiAttributesSeoCreate(postApiAttributesSeoCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiAttributesSeoCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostV1FooterDeleteRequest} [postV1FooterDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiAttributesSeoDelete(postV1FooterDeleteRequest?: PostV1FooterDeleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiAttributesSeoDelete(postV1FooterDeleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiAttributesSeoDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the update.
         * @param {PostApiAttributesSeoUpdateIdRequest} postApiAttributesSeoUpdateIdRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiAttributesSeoUpdateId(id: string, postApiAttributesSeoUpdateIdRequest: PostApiAttributesSeoUpdateIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiAttributesSeoUpdateId(id, postApiAttributesSeoUpdateIdRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiAttributesSeoUpdateId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiBillingBillingDetailsCreateRequest} postApiBillingBillingDetailsCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiBillingBillingDetailsCreate(postApiBillingBillingDetailsCreateRequest: PostApiBillingBillingDetailsCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiBillingBillingDetailsCreate(postApiBillingBillingDetailsCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiBillingBillingDetailsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiBillingBillingDetailsDeleteRequest} postApiBillingBillingDetailsDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiBillingBillingDetailsDelete(postApiBillingBillingDetailsDeleteRequest: PostApiBillingBillingDetailsDeleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiBillingBillingDetailsDelete(postApiBillingBillingDetailsDeleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiBillingBillingDetailsDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiBillingBillingDetailsUpdateRequest} postApiBillingBillingDetailsUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiBillingBillingDetailsUpdate(postApiBillingBillingDetailsUpdateRequest: PostApiBillingBillingDetailsUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiBillingBillingDetailsUpdate(postApiBillingBillingDetailsUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiBillingBillingDetailsUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiBillingCreditCreateRequest} postApiBillingCreditCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiBillingCreditCreate(postApiBillingCreditCreateRequest: PostApiBillingCreditCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiBillingCreditCreate(postApiBillingCreditCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiBillingCreditCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiBillingCreditDeleteRequest} postApiBillingCreditDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiBillingCreditDelete(postApiBillingCreditDeleteRequest: PostApiBillingCreditDeleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiBillingCreditDelete(postApiBillingCreditDeleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiBillingCreditDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiBillingCreditUpdateRequest} postApiBillingCreditUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiBillingCreditUpdate(postApiBillingCreditUpdateRequest: PostApiBillingCreditUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiBillingCreditUpdate(postApiBillingCreditUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiBillingCreditUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiCartAddRequest} [postApiCartAddRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiCartAdd(postApiCartAddRequest?: PostApiCartAddRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiCartAdd(postApiCartAddRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiCartAdd']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiCatalogAttributeCreateRequest} postApiCatalogAttributeCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiCatalogAttributeCreate(postApiCatalogAttributeCreateRequest: PostApiCatalogAttributeCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiCatalogAttributeCreate(postApiCatalogAttributeCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiCatalogAttributeCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiCatalogStoreDeleteRequest} postApiCatalogStoreDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiCatalogAttributeDelete(postApiCatalogStoreDeleteRequest: PostApiCatalogStoreDeleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiCatalogAttributeDelete(postApiCatalogStoreDeleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiCatalogAttributeDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiCatalogAttributeUpdateRequest} postApiCatalogAttributeUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiCatalogAttributeUpdate(postApiCatalogAttributeUpdateRequest: PostApiCatalogAttributeUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiCatalogAttributeUpdate(postApiCatalogAttributeUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiCatalogAttributeUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiCatalogAttributeValueCreateRequest} postApiCatalogAttributeValueCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiCatalogAttributeValueCreate(postApiCatalogAttributeValueCreateRequest: PostApiCatalogAttributeValueCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiCatalogAttributeValueCreate(postApiCatalogAttributeValueCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiCatalogAttributeValueCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiCatalogAttributeValueDeleteRequest} postApiCatalogAttributeValueDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiCatalogAttributeValueDelete(postApiCatalogAttributeValueDeleteRequest: PostApiCatalogAttributeValueDeleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiCatalogAttributeValueDelete(postApiCatalogAttributeValueDeleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiCatalogAttributeValueDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiCatalogAttributeValueUpdateRequest} postApiCatalogAttributeValueUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiCatalogAttributeValueUpdate(postApiCatalogAttributeValueUpdateRequest: PostApiCatalogAttributeValueUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiCatalogAttributeValueUpdate(postApiCatalogAttributeValueUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiCatalogAttributeValueUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiCatalogBrandCreateRequest} postApiCatalogBrandCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiCatalogBrandCreate(postApiCatalogBrandCreateRequest: PostApiCatalogBrandCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiCatalogBrandCreate(postApiCatalogBrandCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiCatalogBrandCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiCommunicationsNewsletterDeleteRequest} postApiCommunicationsNewsletterDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiCatalogBrandDelete(postApiCommunicationsNewsletterDeleteRequest: PostApiCommunicationsNewsletterDeleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiCatalogBrandDelete(postApiCommunicationsNewsletterDeleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiCatalogBrandDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiCatalogBrandUpdateRequest} postApiCatalogBrandUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiCatalogBrandUpdate(postApiCatalogBrandUpdateRequest: PostApiCatalogBrandUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiCatalogBrandUpdate(postApiCatalogBrandUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiCatalogBrandUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiCatalogCategoryCreateRequest} [postApiCatalogCategoryCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiCatalogCategoryCreate(postApiCatalogCategoryCreateRequest?: PostApiCatalogCategoryCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiCatalogCategoryCreate(postApiCatalogCategoryCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiCatalogCategoryCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiCatalogCategoryDeleteRequest} postApiCatalogCategoryDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiCatalogCategoryDelete(postApiCatalogCategoryDeleteRequest: PostApiCatalogCategoryDeleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiCatalogCategoryDelete(postApiCatalogCategoryDeleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiCatalogCategoryDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiCatalogCategoryUpdateRequest} postApiCatalogCategoryUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiCatalogCategoryUpdate(postApiCatalogCategoryUpdateRequest: PostApiCatalogCategoryUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiCatalogCategoryUpdate(postApiCatalogCategoryUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiCatalogCategoryUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiCatalogProductAttributesCreateRequest} postApiCatalogProductAttributesCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiCatalogProductAttributesCreate(postApiCatalogProductAttributesCreateRequest: PostApiCatalogProductAttributesCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiCatalogProductAttributesCreate(postApiCatalogProductAttributesCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiCatalogProductAttributesCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiCatalogProductAttributesDeleteRequest} postApiCatalogProductAttributesDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiCatalogProductAttributesDelete(postApiCatalogProductAttributesDeleteRequest: PostApiCatalogProductAttributesDeleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiCatalogProductAttributesDelete(postApiCatalogProductAttributesDeleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiCatalogProductAttributesDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiCatalogProductAttributesUpdateRequest} postApiCatalogProductAttributesUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiCatalogProductAttributesUpdate(postApiCatalogProductAttributesUpdateRequest: PostApiCatalogProductAttributesUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiCatalogProductAttributesUpdate(postApiCatalogProductAttributesUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiCatalogProductAttributesUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiCatalogProductCreateRequest} postApiCatalogProductCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiCatalogProductCreate(postApiCatalogProductCreateRequest: PostApiCatalogProductCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiCatalogProductCreate(postApiCatalogProductCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiCatalogProductCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiCatalogProductDeleteRequest} postApiCatalogProductDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiCatalogProductDelete(postApiCatalogProductDeleteRequest: PostApiCatalogProductDeleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiCatalogProductDelete(postApiCatalogProductDeleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiCatalogProductDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiCatalogProductUpdateRequest} postApiCatalogProductUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiCatalogProductUpdate(postApiCatalogProductUpdateRequest: PostApiCatalogProductUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiCatalogProductUpdate(postApiCatalogProductUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiCatalogProductUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiCatalogStoreCreateRequest} postApiCatalogStoreCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiCatalogStoreCreate(postApiCatalogStoreCreateRequest: PostApiCatalogStoreCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiCatalogStoreCreate(postApiCatalogStoreCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiCatalogStoreCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiCatalogStoreDeleteRequest} postApiCatalogStoreDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiCatalogStoreDelete(postApiCatalogStoreDeleteRequest: PostApiCatalogStoreDeleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiCatalogStoreDelete(postApiCatalogStoreDeleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiCatalogStoreDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiCatalogStoreUpdateRequest} postApiCatalogStoreUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiCatalogStoreUpdate(postApiCatalogStoreUpdateRequest: PostApiCatalogStoreUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiCatalogStoreUpdate(postApiCatalogStoreUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiCatalogStoreUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiCatalogTagCreateRequest} postApiCatalogTagCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiCatalogTagCreate(postApiCatalogTagCreateRequest: PostApiCatalogTagCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiCatalogTagCreate(postApiCatalogTagCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiCatalogTagCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiCatalogTagDeleteRequest} postApiCatalogTagDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiCatalogTagDelete(postApiCatalogTagDeleteRequest: PostApiCatalogTagDeleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiCatalogTagDelete(postApiCatalogTagDeleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiCatalogTagDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiCatalogTagUpdateRequest} postApiCatalogTagUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiCatalogTagUpdate(postApiCatalogTagUpdateRequest: PostApiCatalogTagUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiCatalogTagUpdate(postApiCatalogTagUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiCatalogTagUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiCommunicationsNewsletterCreateRequest} postApiCommunicationsNewsletterCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiCommunicationsNewsletterCreate(postApiCommunicationsNewsletterCreateRequest: PostApiCommunicationsNewsletterCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiCommunicationsNewsletterCreate(postApiCommunicationsNewsletterCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiCommunicationsNewsletterCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiCommunicationsNewsletterDeleteRequest} postApiCommunicationsNewsletterDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiCommunicationsNewsletterDelete(postApiCommunicationsNewsletterDeleteRequest: PostApiCommunicationsNewsletterDeleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiCommunicationsNewsletterDelete(postApiCommunicationsNewsletterDeleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiCommunicationsNewsletterDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiCommunicationsNewsletterUpdateRequest} postApiCommunicationsNewsletterUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiCommunicationsNewsletterUpdate(postApiCommunicationsNewsletterUpdateRequest: PostApiCommunicationsNewsletterUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiCommunicationsNewsletterUpdate(postApiCommunicationsNewsletterUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiCommunicationsNewsletterUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiCommunicationsSubscriberCreateRequest} postApiCommunicationsSubscriberCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiCommunicationsSubscriberCreate(postApiCommunicationsSubscriberCreateRequest: PostApiCommunicationsSubscriberCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiCommunicationsSubscriberCreate(postApiCommunicationsSubscriberCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiCommunicationsSubscriberCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiAccountsUserDeleteRequest} postApiAccountsUserDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiCommunicationsSubscriberDelete(postApiAccountsUserDeleteRequest: PostApiAccountsUserDeleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiCommunicationsSubscriberDelete(postApiAccountsUserDeleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiCommunicationsSubscriberDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiCommunicationsSubscriberUpdateRequest} postApiCommunicationsSubscriberUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiCommunicationsSubscriberUpdate(postApiCommunicationsSubscriberUpdateRequest: PostApiCommunicationsSubscriberUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiCommunicationsSubscriberUpdate(postApiCommunicationsSubscriberUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiCommunicationsSubscriberUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiContentPageCreateRequest} postApiContentPageCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiContentPageCreate(postApiContentPageCreateRequest: PostApiContentPageCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiContentPageCreate(postApiContentPageCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiContentPageCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiContentPageDeleteRequest} postApiContentPageDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiContentPageDelete(postApiContentPageDeleteRequest: PostApiContentPageDeleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiContentPageDelete(postApiContentPageDeleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiContentPageDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiContentPageUpdateRequest} postApiContentPageUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiContentPageUpdate(postApiContentPageUpdateRequest: PostApiContentPageUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiContentPageUpdate(postApiContentPageUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiContentPageUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiInstashopSettingsUpdateRequest} [postApiInstashopSettingsUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiInstashopSettingsUpdate(postApiInstashopSettingsUpdateRequest?: PostApiInstashopSettingsUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiInstashopSettingsUpdate(postApiInstashopSettingsUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiInstashopSettingsUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiInvoicesSettingsCreateRequest} postApiInvoicesSettingsCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiInvoicesSettingsCreate(postApiInvoicesSettingsCreateRequest: PostApiInvoicesSettingsCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiInvoicesSettingsCreate(postApiInvoicesSettingsCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiInvoicesSettingsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiInvoicesSettingsDeleteRequest} postApiInvoicesSettingsDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiInvoicesSettingsDelete(postApiInvoicesSettingsDeleteRequest: PostApiInvoicesSettingsDeleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiInvoicesSettingsDelete(postApiInvoicesSettingsDeleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiInvoicesSettingsDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiInvoicesSettingsUpdateRequest} postApiInvoicesSettingsUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiInvoicesSettingsUpdate(postApiInvoicesSettingsUpdateRequest: PostApiInvoicesSettingsUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiInvoicesSettingsUpdate(postApiInvoicesSettingsUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiInvoicesSettingsUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiMediaFileDeleteRequest} postApiMediaFileDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiMediaFileDelete(postApiMediaFileDeleteRequest: PostApiMediaFileDeleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiMediaFileDelete(postApiMediaFileDeleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiMediaFileDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the update.
         * @param {PostApiMediaFileUpdateIdRequest} [postApiMediaFileUpdateIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiMediaFileUpdateId(id: string, postApiMediaFileUpdateIdRequest?: PostApiMediaFileUpdateIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiMediaFileUpdateId(id, postApiMediaFileUpdateIdRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiMediaFileUpdateId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiMediaFileUploadRequest} postApiMediaFileUploadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiMediaFileUpload(postApiMediaFileUploadRequest: PostApiMediaFileUploadRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiMediaFileUpload(postApiMediaFileUploadRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiMediaFileUpload']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the update.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiMediaSettingsSizeUpdateId(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiMediaSettingsSizeUpdateId(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiMediaSettingsSizeUpdateId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiMediaThumbUpdateAudio(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiMediaThumbUpdateAudio(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiMediaThumbUpdateAudio']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiMediaThumbUpdateDocument(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiMediaThumbUpdateDocument(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiMediaThumbUpdateDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiMediaThumbUpdateVideo(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiMediaThumbUpdateVideo(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiMediaThumbUpdateVideo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiNoonSettingsUpdateRequest} [postApiNoonSettingsUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiNoonSettingsUpdate(postApiNoonSettingsUpdateRequest?: PostApiNoonSettingsUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiNoonSettingsUpdate(postApiNoonSettingsUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiNoonSettingsUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiOrdersOrderCreateRequest} postApiOrdersOrderCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiOrdersOrderCreate(postApiOrdersOrderCreateRequest: PostApiOrdersOrderCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiOrdersOrderCreate(postApiOrdersOrderCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiOrdersOrderCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiCatalogCategoryDeleteRequest} postApiCatalogCategoryDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiOrdersOrderDelete(postApiCatalogCategoryDeleteRequest: PostApiCatalogCategoryDeleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiOrdersOrderDelete(postApiCatalogCategoryDeleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiOrdersOrderDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the update.
         * @param {PostApiOrdersOrderUpdateIdRequest} postApiOrdersOrderUpdateIdRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiOrdersOrderUpdateId(id: string, postApiOrdersOrderUpdateIdRequest: PostApiOrdersOrderUpdateIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiOrdersOrderUpdateId(id, postApiOrdersOrderUpdateIdRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiOrdersOrderUpdateId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiOrdersStatusCreateRequest} postApiOrdersStatusCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiOrdersStatusCreate(postApiOrdersStatusCreateRequest: PostApiOrdersStatusCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiOrdersStatusCreate(postApiOrdersStatusCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiOrdersStatusCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiOrdersStatusDeleteRequest} postApiOrdersStatusDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiOrdersStatusDelete(postApiOrdersStatusDeleteRequest: PostApiOrdersStatusDeleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiOrdersStatusDelete(postApiOrdersStatusDeleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiOrdersStatusDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiOrdersStatusUpdateRequest} postApiOrdersStatusUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiOrdersStatusUpdate(postApiOrdersStatusUpdateRequest: PostApiOrdersStatusUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiOrdersStatusUpdate(postApiOrdersStatusUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiOrdersStatusUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiPaymentInitiateRequest} postApiPaymentInitiateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiPaymentInitiate(postApiPaymentInitiateRequest: PostApiPaymentInitiateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiPaymentInitiate(postApiPaymentInitiateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiPaymentInitiate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiPromotionsCodeCreateRequest} postApiPromotionsCodeCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiPromotionsCodeCreate(postApiPromotionsCodeCreateRequest: PostApiPromotionsCodeCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiPromotionsCodeCreate(postApiPromotionsCodeCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiPromotionsCodeCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiPromotionsCodeDeleteRequest} postApiPromotionsCodeDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiPromotionsCodeDelete(postApiPromotionsCodeDeleteRequest: PostApiPromotionsCodeDeleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiPromotionsCodeDelete(postApiPromotionsCodeDeleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiPromotionsCodeDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the update.
         * @param {PostApiPromotionsCodeUpdateIdRequest} postApiPromotionsCodeUpdateIdRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiPromotionsCodeUpdateId(id: string, postApiPromotionsCodeUpdateIdRequest: PostApiPromotionsCodeUpdateIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiPromotionsCodeUpdateId(id, postApiPromotionsCodeUpdateIdRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiPromotionsCodeUpdateId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiPromotionsOfferCreateRequest} postApiPromotionsOfferCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiPromotionsOfferCreate(postApiPromotionsOfferCreateRequest: PostApiPromotionsOfferCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiPromotionsOfferCreate(postApiPromotionsOfferCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiPromotionsOfferCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiCatalogProductDeleteRequest} postApiCatalogProductDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiPromotionsOfferDelete(postApiCatalogProductDeleteRequest: PostApiCatalogProductDeleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiPromotionsOfferDelete(postApiCatalogProductDeleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiPromotionsOfferDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the update.
         * @param {PostApiPromotionsOfferUpdateIdRequest} postApiPromotionsOfferUpdateIdRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiPromotionsOfferUpdateId(id: string, postApiPromotionsOfferUpdateIdRequest: PostApiPromotionsOfferUpdateIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiPromotionsOfferUpdateId(id, postApiPromotionsOfferUpdateIdRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiPromotionsOfferUpdateId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiSettingsCcavenueSettingsUpdateRequest} postApiSettingsCcavenueSettingsUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiSettingsCcavenueSettingsUpdate(postApiSettingsCcavenueSettingsUpdateRequest: PostApiSettingsCcavenueSettingsUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiSettingsCcavenueSettingsUpdate(postApiSettingsCcavenueSettingsUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiSettingsCcavenueSettingsUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiSettingsCurrencyCreateRequest} postApiSettingsCurrencyCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiSettingsCurrencyCreate(postApiSettingsCurrencyCreateRequest: PostApiSettingsCurrencyCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiSettingsCurrencyCreate(postApiSettingsCurrencyCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiSettingsCurrencyCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiCatalogTagDeleteRequest} postApiCatalogTagDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiSettingsCurrencyDelete(postApiCatalogTagDeleteRequest: PostApiCatalogTagDeleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiSettingsCurrencyDelete(postApiCatalogTagDeleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiSettingsCurrencyDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiSettingsCurrencyUpdateRequest} postApiSettingsCurrencyUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiSettingsCurrencyUpdate(postApiSettingsCurrencyUpdateRequest: PostApiSettingsCurrencyUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiSettingsCurrencyUpdate(postApiSettingsCurrencyUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiSettingsCurrencyUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiSettingsNetworkSettingsUpdateRequest} postApiSettingsNetworkSettingsUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiSettingsNetworkSettingsUpdate(postApiSettingsNetworkSettingsUpdateRequest: PostApiSettingsNetworkSettingsUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiSettingsNetworkSettingsUpdate(postApiSettingsNetworkSettingsUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiSettingsNetworkSettingsUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the activate.
         * @param {PostApiSettingsOnlinePaymentGatewayActivateIdRequest} postApiSettingsOnlinePaymentGatewayActivateIdRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiSettingsOnlinePaymentCardMethodActivateId(id: string, postApiSettingsOnlinePaymentGatewayActivateIdRequest: PostApiSettingsOnlinePaymentGatewayActivateIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiSettingsOnlinePaymentCardMethodActivateId(id, postApiSettingsOnlinePaymentGatewayActivateIdRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiSettingsOnlinePaymentCardMethodActivateId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the activate.
         * @param {PostApiSettingsOnlinePaymentGatewayActivateIdRequest} postApiSettingsOnlinePaymentGatewayActivateIdRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiSettingsOnlinePaymentGatewayActivateId(id: string, postApiSettingsOnlinePaymentGatewayActivateIdRequest: PostApiSettingsOnlinePaymentGatewayActivateIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiSettingsOnlinePaymentGatewayActivateId(id, postApiSettingsOnlinePaymentGatewayActivateIdRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiSettingsOnlinePaymentGatewayActivateId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiSettingsPayfortSettingsUpdateRequest} postApiSettingsPayfortSettingsUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiSettingsPayfortSettingsUpdate(postApiSettingsPayfortSettingsUpdateRequest: PostApiSettingsPayfortSettingsUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiSettingsPayfortSettingsUpdate(postApiSettingsPayfortSettingsUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiSettingsPayfortSettingsUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiSettingsPaymentModeCreateRequest} postApiSettingsPaymentModeCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiSettingsPaymentModeCreate(postApiSettingsPaymentModeCreateRequest: PostApiSettingsPaymentModeCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiSettingsPaymentModeCreate(postApiSettingsPaymentModeCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiSettingsPaymentModeCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiContentPageDeleteRequest} postApiContentPageDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiSettingsPaymentModeDelete(postApiContentPageDeleteRequest: PostApiContentPageDeleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiSettingsPaymentModeDelete(postApiContentPageDeleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiSettingsPaymentModeDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiSettingsPaymentModeUpdateRequest} postApiSettingsPaymentModeUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiSettingsPaymentModeUpdate(postApiSettingsPaymentModeUpdateRequest: PostApiSettingsPaymentModeUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiSettingsPaymentModeUpdate(postApiSettingsPaymentModeUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiSettingsPaymentModeUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiSettingsPaypalSettingsUpdateRequest} postApiSettingsPaypalSettingsUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiSettingsPaypalSettingsUpdate(postApiSettingsPaypalSettingsUpdateRequest: PostApiSettingsPaypalSettingsUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiSettingsPaypalSettingsUpdate(postApiSettingsPaypalSettingsUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiSettingsPaypalSettingsUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiSettingsStripeSettingsUpdateRequest} [postApiSettingsStripeSettingsUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiSettingsStripeSettingsUpdate(postApiSettingsStripeSettingsUpdateRequest?: PostApiSettingsStripeSettingsUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiSettingsStripeSettingsUpdate(postApiSettingsStripeSettingsUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiSettingsStripeSettingsUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiSettingsTabbySettingsUpdateRequest} postApiSettingsTabbySettingsUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiSettingsTabbySettingsUpdate(postApiSettingsTabbySettingsUpdateRequest: PostApiSettingsTabbySettingsUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiSettingsTabbySettingsUpdate(postApiSettingsTabbySettingsUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiSettingsTabbySettingsUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiSettingsTamaraSettingsUpdateRequest} postApiSettingsTamaraSettingsUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiSettingsTamaraSettingsUpdate(postApiSettingsTamaraSettingsUpdateRequest: PostApiSettingsTamaraSettingsUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiSettingsTamaraSettingsUpdate(postApiSettingsTamaraSettingsUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiSettingsTamaraSettingsUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiShippingCostCalculatorRequest} postApiShippingCostCalculatorRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiShippingCostCalculator(postApiShippingCostCalculatorRequest: PostApiShippingCostCalculatorRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiShippingCostCalculator(postApiShippingCostCalculatorRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiShippingCostCalculator']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiShippingFlatRateCreateRequest} postApiShippingFlatRateCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiShippingFlatRateCreate(postApiShippingFlatRateCreateRequest: PostApiShippingFlatRateCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiShippingFlatRateCreate(postApiShippingFlatRateCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiShippingFlatRateCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiCatalogCategoryDeleteRequest} postApiCatalogCategoryDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiShippingFlatRateDelete(postApiCatalogCategoryDeleteRequest: PostApiCatalogCategoryDeleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiShippingFlatRateDelete(postApiCatalogCategoryDeleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiShippingFlatRateDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiShippingFlatRateUpdateRequest} postApiShippingFlatRateUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiShippingFlatRateUpdate(postApiShippingFlatRateUpdateRequest: PostApiShippingFlatRateUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiShippingFlatRateUpdate(postApiShippingFlatRateUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiShippingFlatRateUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiShippingShippingDetailsCreateRequest} postApiShippingShippingDetailsCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiShippingShippingDetailsCreate(postApiShippingShippingDetailsCreateRequest: PostApiShippingShippingDetailsCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiShippingShippingDetailsCreate(postApiShippingShippingDetailsCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiShippingShippingDetailsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiShippingShippingDetailsDeleteRequest} postApiShippingShippingDetailsDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiShippingShippingDetailsDelete(postApiShippingShippingDetailsDeleteRequest: PostApiShippingShippingDetailsDeleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiShippingShippingDetailsDelete(postApiShippingShippingDetailsDeleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiShippingShippingDetailsDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiShippingShippingDetailsUpdateRequest} postApiShippingShippingDetailsUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiShippingShippingDetailsUpdate(postApiShippingShippingDetailsUpdateRequest: PostApiShippingShippingDetailsUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiShippingShippingDetailsUpdate(postApiShippingShippingDetailsUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiShippingShippingDetailsUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiShippingShippingServiceCreateRequest} postApiShippingShippingServiceCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiShippingShippingServiceCreate(postApiShippingShippingServiceCreateRequest: PostApiShippingShippingServiceCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiShippingShippingServiceCreate(postApiShippingShippingServiceCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiShippingShippingServiceCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiShippingShippingServiceDeleteRequest} postApiShippingShippingServiceDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiShippingShippingServiceDelete(postApiShippingShippingServiceDeleteRequest: PostApiShippingShippingServiceDeleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiShippingShippingServiceDelete(postApiShippingShippingServiceDeleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiShippingShippingServiceDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiShippingShippingServiceUpdateRequest} postApiShippingShippingServiceUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiShippingShippingServiceUpdate(postApiShippingShippingServiceUpdateRequest: PostApiShippingShippingServiceUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiShippingShippingServiceUpdate(postApiShippingShippingServiceUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiShippingShippingServiceUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the activate.
         * @param {GetApiSettingsCurrencyIdRequest} [getApiSettingsCurrencyIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiThemeActivateId(id: string, getApiSettingsCurrencyIdRequest?: GetApiSettingsCurrencyIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiThemeActivateId(id, getApiSettingsCurrencyIdRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiThemeActivateId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new theme
         * @param {PostApiThemeCreateRequest} [postApiThemeCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiThemeCreate(postApiThemeCreateRequest?: PostApiThemeCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiThemeCreate(postApiThemeCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiThemeCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a theme's color palette
         * @param {EndpointsApiPostApiThemeColorUpdateIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         */
        async postApiThemeColorUpdateId(requestParameters: EndpointsApiPostApiThemeColorUpdateIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiThemeColorUpdateId(requestParameters.id, requestParameters.postApiThemeColorUpdateIdRequest, options);
            // If your other Fp methods don't reference `operationServerMap`, drop the
            // next two lines and the basePath fallback below — see note at the
            // bottom of this file.
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiThemeColorUpdateId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the update.
         * @param {PostApiThemeSettingsUpdateIdRequest} [postApiThemeSettingsUpdateIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiThemeSettingsUpdateId(id: string, postApiThemeSettingsUpdateIdRequest?: PostApiThemeSettingsUpdateIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiThemeSettingsUpdateId(id, postApiThemeSettingsUpdateIdRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiThemeSettingsUpdateId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a saved color theme
         * @param {EndpointsApiDeleteApiThemeColorIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         */
        async deleteApiThemeColorId(requestParameters: EndpointsApiDeleteApiThemeColorIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteApiThemeColorId(requestParameters.id, options);
            // Drop these two lines (and the basePath fallback below) if your other Fp
            // methods don't reference `operationServerMap` — see the note from the
            // postApiThemeColorUpdateId snippet.
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.deleteApiThemeColorId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {File} themeZip Must be a file.
         * @param {string} [name] Must not be greater than 255 characters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiThemeUpload(themeZip: File, name?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiThemeUpload(themeZip, name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiThemeUpload']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiUserPermissionsUpdateRequest} postApiUserPermissionsUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiUserPermissionsUpdate(postApiUserPermissionsUpdateRequest: PostApiUserPermissionsUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiUserPermissionsUpdate(postApiUserPermissionsUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiUserPermissionsUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiUserRoleCreateRequest} postApiUserRoleCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiUserRoleCreate(postApiUserRoleCreateRequest: PostApiUserRoleCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiUserRoleCreate(postApiUserRoleCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiUserRoleCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostApiUserRoleDeleteRequest} postApiUserRoleDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiUserRoleDelete(postApiUserRoleDeleteRequest: PostApiUserRoleDeleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiUserRoleDelete(postApiUserRoleDeleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiUserRoleDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} role 
         * @param {PostApiUserRoleUpdateRoleRequest} postApiUserRoleUpdateRoleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiUserRoleUpdateRole(role: string, postApiUserRoleUpdateRoleRequest: PostApiUserRoleUpdateRoleRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiUserRoleUpdateRole(role, postApiUserRoleUpdateRoleRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postApiUserRoleUpdateRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postFrontLogin(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postFrontLogin(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postFrontLogin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the rate.
         * @param {PostFrontProductRateIdRequest} [postFrontProductRateIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postFrontProductRateId(id: string, postFrontProductRateIdRequest?: PostFrontProductRateIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postFrontProductRateId(id, postFrontProductRateIdRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postFrontProductRateId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postFrontRegister(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postFrontRegister(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postFrontRegister']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postFrontReset(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postFrontReset(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postFrontReset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postFrontResetPassword(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postFrontResetPassword(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postFrontResetPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostV1BannerCreateRequest} postV1BannerCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postV1BannerCreate(postV1BannerCreateRequest: PostV1BannerCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postV1BannerCreate(postV1BannerCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postV1BannerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostV1BannerDeleteRequest} [postV1BannerDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postV1BannerDelete(postV1BannerDeleteRequest?: PostV1BannerDeleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postV1BannerDelete(postV1BannerDeleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postV1BannerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostV1BannerUpdateRequest} postV1BannerUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postV1BannerUpdate(postV1BannerUpdateRequest: PostV1BannerUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postV1BannerUpdate(postV1BannerUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postV1BannerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostV1FooterCreateRequest} postV1FooterCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postV1FooterCreate(postV1FooterCreateRequest: PostV1FooterCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postV1FooterCreate(postV1FooterCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postV1FooterCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostV1FooterDeleteRequest} [postV1FooterDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postV1FooterDelete(postV1FooterDeleteRequest?: PostV1FooterDeleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postV1FooterDelete(postV1FooterDeleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postV1FooterDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostV1FooterUpdateRequest} postV1FooterUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postV1FooterUpdate(postV1FooterUpdateRequest: PostV1FooterUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postV1FooterUpdate(postV1FooterUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postV1FooterUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postV1Login(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postV1Login(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postV1Login']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostV1MenuCreateRequest} postV1MenuCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postV1MenuCreate(postV1MenuCreateRequest: PostV1MenuCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postV1MenuCreate(postV1MenuCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postV1MenuCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostV1MenuDeleteRequest} [postV1MenuDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postV1MenuDelete(postV1MenuDeleteRequest?: PostV1MenuDeleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postV1MenuDelete(postV1MenuDeleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postV1MenuDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} id The ID of the update.
         * @param {PostV1MenuUpdateIdRequest} postV1MenuUpdateIdRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postV1MenuUpdateId(id: string, postV1MenuUpdateIdRequest: PostV1MenuUpdateIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postV1MenuUpdateId(id, postV1MenuUpdateIdRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postV1MenuUpdateId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {PostV1NavbarModeUpdateRequest} postV1NavbarModeUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postV1NavbarModeUpdate(postV1NavbarModeUpdateRequest: PostV1NavbarModeUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postV1NavbarModeUpdate(postV1NavbarModeUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postV1NavbarModeUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postV1Register(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postV1Register(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postV1Register']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postV1Reset(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postV1Reset(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postV1Reset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postV1ResetPassword(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postV1ResetPassword(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.postV1ResetPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} cartItemId 
         * @param {PutApiCartItemsCartItemIdRequest} putApiCartItemsCartItemIdRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putApiCartItemsCartItemId(cartItemId: string, putApiCartItemsCartItemIdRequest: PutApiCartItemsCartItemIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putApiCartItemsCartItemId(cartItemId, putApiCartItemsCartItemIdRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.putApiCartItemsCartItemId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Serve the generated OpenAPI YAML file.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async serveTheGeneratedOpenAPIYAMLFile(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.serveTheGeneratedOpenAPIYAMLFile(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndpointsApi.serveTheGeneratedOpenAPIYAMLFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EndpointsApi - factory interface
 */
export const EndpointsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EndpointsApiFp(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApiCartClear(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteApiCartClear(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiDeleteApiCartItemsCartItemIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApiCartItemsCartItemId(requestParameters: EndpointsApiDeleteApiCartItemsCartItemIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteApiCartItemsCartItemId(requestParameters.cartItemId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Execute the job.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeTheJob(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.executeTheJob(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiAccountsDebugAuth(options?: RawAxiosRequestConfig): AxiosPromise<GetApiAccountsDebugAuth200Response> {
            return localVarFp.getApiAccountsDebugAuth(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetApiAdminCartsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiAdminCarts(requestParameters: EndpointsApiGetApiAdminCartsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiAdminCarts(requestParameters.getApiAdminCartsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiAmazonSettings(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiAmazonSettings(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiAramexSettings(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiAramexSettings(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetApiAttributesSeoIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiAttributesSeoId(requestParameters: EndpointsApiGetApiAttributesSeoIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiAttributesSeoId(requestParameters.id, requestParameters.getApiAttributesSeoIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetApiAttributesSeosRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiAttributesSeos(requestParameters: EndpointsApiGetApiAttributesSeosRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiAttributesSeos(requestParameters.getApiAttributesSeosRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetApiBillingCreditIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiBillingCreditId(requestParameters: EndpointsApiGetApiBillingCreditIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiBillingCreditId(requestParameters.id, requestParameters.getApiBillingCreditIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetApiBillingCreditsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiBillingCredits(requestParameters: EndpointsApiGetApiBillingCreditsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiBillingCredits(requestParameters.getApiBillingCreditsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiCart(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiCart(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiCartDetails(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiCartDetails(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetApiCatalogAttributeIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiCatalogAttributeId(requestParameters: EndpointsApiGetApiCatalogAttributeIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiCatalogAttributeId(requestParameters.id, requestParameters.getApiCatalogAttributeIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetApiCatalogAttributeValueIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiCatalogAttributeValueId(requestParameters: EndpointsApiGetApiCatalogAttributeValueIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiCatalogAttributeValueId(requestParameters.id, requestParameters.postV1FooterDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetApiCatalogAttributesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiCatalogAttributes(requestParameters: EndpointsApiGetApiCatalogAttributesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiCatalogAttributes(requestParameters.getApiContentPageIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetApiCatalogAttributesValuesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiCatalogAttributesValues(requestParameters: EndpointsApiGetApiCatalogAttributesValuesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiCatalogAttributesValues(requestParameters.getApiCatalogAttributesValuesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetApiCatalogBrandIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiCatalogBrandId(requestParameters: EndpointsApiGetApiCatalogBrandIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiCatalogBrandId(requestParameters.id, requestParameters.getApiCatalogBrandIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetApiCatalogBrandsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiCatalogBrands(requestParameters: EndpointsApiGetApiCatalogBrandsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiCatalogBrands(requestParameters.getApiCatalogBrandsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetApiCatalogCategoriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiCatalogCategories(requestParameters: EndpointsApiGetApiCatalogCategoriesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiCatalogCategories(requestParameters.getApiCatalogCategoriesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetApiCatalogCategoryIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiCatalogCategoryId(requestParameters: EndpointsApiGetApiCatalogCategoryIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiCatalogCategoryId(requestParameters.id, requestParameters.getApiCatalogCategoryIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetApiCatalogProductAttributesIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiCatalogProductAttributesId(requestParameters: EndpointsApiGetApiCatalogProductAttributesIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiCatalogProductAttributesId(requestParameters.id, requestParameters.getApiCatalogAttributesValuesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetApiCatalogProductIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiCatalogProductId(requestParameters: EndpointsApiGetApiCatalogProductIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiCatalogProductId(requestParameters.id, requestParameters.getApiCatalogProductIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetApiCatalogProductSearchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiCatalogProductSearch(requestParameters: EndpointsApiGetApiCatalogProductSearchRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiCatalogProductSearch(requestParameters.getApiCatalogProductSearchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetApiCatalogProductsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiCatalogProducts(requestParameters: EndpointsApiGetApiCatalogProductsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiCatalogProducts(requestParameters.getApiCatalogProductsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetApiCatalogProductsAttributesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiCatalogProductsAttributes(requestParameters: EndpointsApiGetApiCatalogProductsAttributesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiCatalogProductsAttributes(requestParameters.getApiCatalogProductsAttributesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiCatalogProductsExport(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiCatalogProductsExport(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetApiCatalogStoreIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiCatalogStoreId(requestParameters: EndpointsApiGetApiCatalogStoreIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiCatalogStoreId(requestParameters.id, requestParameters.getApiCatalogStoreIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetApiCatalogStoresRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiCatalogStores(requestParameters: EndpointsApiGetApiCatalogStoresRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiCatalogStores(requestParameters.getApiCatalogStoresRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetApiCatalogTagIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiCatalogTagId(requestParameters: EndpointsApiGetApiCatalogTagIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiCatalogTagId(requestParameters.id, requestParameters.getApiCatalogTagIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetApiCatalogTagsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiCatalogTags(requestParameters: EndpointsApiGetApiCatalogTagsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiCatalogTags(requestParameters.getApiCatalogTagsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetApiClientUserIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiClientUserId(requestParameters: EndpointsApiGetApiClientUserIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiClientUserId(requestParameters.id, requestParameters.getUsersRequest1, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetApiCommunicationsNewsletterIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiCommunicationsNewsletterId(requestParameters: EndpointsApiGetApiCommunicationsNewsletterIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiCommunicationsNewsletterId(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiCommunicationsNewsletters(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiCommunicationsNewsletters(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetApiCommunicationsSubscriberIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiCommunicationsSubscriberId(requestParameters: EndpointsApiGetApiCommunicationsSubscriberIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiCommunicationsSubscriberId(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiCommunicationsSubscribers(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiCommunicationsSubscribers(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetApiContentPageIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiContentPageId(requestParameters: EndpointsApiGetApiContentPageIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiContentPageId(requestParameters.id, requestParameters.getApiContentPageIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetApiContentPagesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiContentPages(requestParameters: EndpointsApiGetApiContentPagesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiContentPages(requestParameters.getApiContentPagesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiDashStats(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiDashStats(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiInstashopSettings(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiInstashopSettings(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetApiInvoicesSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiInvoicesSettings(requestParameters: EndpointsApiGetApiInvoicesSettingsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiInvoicesSettings(requestParameters.getApiInvoicesSettingsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetApiInvoicesSettingsIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiInvoicesSettingsId(requestParameters: EndpointsApiGetApiInvoicesSettingsIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiInvoicesSettingsId(requestParameters.id, requestParameters.getApiInvoicesSettingsIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetApiMediaFilesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiMediaFiles(requestParameters: EndpointsApiGetApiMediaFilesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiMediaFiles(requestParameters.getApiContentPagesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetApiMediaFilesIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiMediaFilesId(requestParameters: EndpointsApiGetApiMediaFilesIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiMediaFilesId(requestParameters.id, requestParameters.getApiMediaFilesIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetApiMediaSearchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiMediaSearch(requestParameters: EndpointsApiGetApiMediaSearchRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiMediaSearch(requestParameters.getApiMediaSearchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiMediaSettingsSizes(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiMediaSettingsSizes(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiMediaThumbThumbs(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiMediaThumbThumbs(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiNoonSettings(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiNoonSettings(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetApiOrdersExportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiOrdersExport(requestParameters: EndpointsApiGetApiOrdersExportRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiOrdersExport(requestParameters.getApiOrdersExportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetApiOrdersOrderIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiOrdersOrderId(requestParameters: EndpointsApiGetApiOrdersOrderIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiOrdersOrderId(requestParameters.id, requestParameters.getApiOrdersOrderIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetApiOrdersOrdersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiOrdersOrders(requestParameters: EndpointsApiGetApiOrdersOrdersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiOrdersOrders(requestParameters.getApiOrdersOrdersRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiOrdersStatus(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiOrdersStatus(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetApiOrdersStatusIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiOrdersStatusId(requestParameters: EndpointsApiGetApiOrdersStatusIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiOrdersStatusId(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetApiPathRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiPath(requestParameters: EndpointsApiGetApiPathRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiPath(requestParameters.path, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetApiPromotionsCodeIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiPromotionsCodeId(requestParameters: EndpointsApiGetApiPromotionsCodeIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiPromotionsCodeId(requestParameters.id, requestParameters.getApiPromotionsCodeIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetApiPromotionsCodesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiPromotionsCodes(requestParameters: EndpointsApiGetApiPromotionsCodesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiPromotionsCodes(requestParameters.getApiPromotionsCodesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetApiPromotionsOfferIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiPromotionsOfferId(requestParameters: EndpointsApiGetApiPromotionsOfferIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiPromotionsOfferId(requestParameters.id, requestParameters.getApiPromotionsOfferIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetApiPromotionsOffersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiPromotionsOffers(requestParameters: EndpointsApiGetApiPromotionsOffersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiPromotionsOffers(requestParameters.getApiPromotionsOffersRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiSalesPingg(options?: RawAxiosRequestConfig): AxiosPromise<GetV1TestPing200Response> {
            return localVarFp.getApiSalesPingg(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiSettingsCcavenueSettings(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiSettingsCcavenueSettings(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetApiSettingsCurrenciesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiSettingsCurrencies(requestParameters: EndpointsApiGetApiSettingsCurrenciesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiSettingsCurrencies(requestParameters.getApiSettingsCurrenciesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetApiSettingsCurrencyIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiSettingsCurrencyId(requestParameters: EndpointsApiGetApiSettingsCurrencyIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiSettingsCurrencyId(requestParameters.id, requestParameters.getApiSettingsCurrencyIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiSettingsNetworkSettings(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiSettingsNetworkSettings(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiSettingsOnlinePaymentCardMethods(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiSettingsOnlinePaymentCardMethods(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiSettingsOnlinePaymentGateways(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiSettingsOnlinePaymentGateways(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiSettingsPayfortSettings(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiSettingsPayfortSettings(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetApiSettingsPaymentModeIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiSettingsPaymentModeId(requestParameters: EndpointsApiGetApiSettingsPaymentModeIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiSettingsPaymentModeId(requestParameters.id, requestParameters.getApiSettingsPaymentModeIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetApiSettingsPaymentModesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiSettingsPaymentModes(requestParameters: EndpointsApiGetApiSettingsPaymentModesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiSettingsPaymentModes(requestParameters.getApiSettingsPaymentModesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiSettingsPaypalSettings(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiSettingsPaypalSettings(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiSettingsStripeSettings(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiSettingsStripeSettings(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiSettingsTabbySettings(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiSettingsTabbySettings(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiSettingsTamaraSettings(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiSettingsTamaraSettings(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetApiShippingFlatRateIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiShippingFlatRateId(requestParameters: EndpointsApiGetApiShippingFlatRateIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiShippingFlatRateId(requestParameters.id, requestParameters.getApiShippingFlatRateIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetApiShippingFlatRatesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiShippingFlatRates(requestParameters: EndpointsApiGetApiShippingFlatRatesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiShippingFlatRates(requestParameters.getApiShippingFlatRatesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetApiShippingShippingDetailUsernameRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiShippingShippingDetailUsername(requestParameters: EndpointsApiGetApiShippingShippingDetailUsernameRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiShippingShippingDetailUsername(requestParameters.username, requestParameters.getApiShippingShippingDetailUsernameRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetApiShippingShippingDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiShippingShippingDetails(requestParameters: EndpointsApiGetApiShippingShippingDetailsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiShippingShippingDetails(requestParameters.getApiShippingShippingDetailsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetApiShippingShippingServiceIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiShippingShippingServiceId(requestParameters: EndpointsApiGetApiShippingShippingServiceIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiShippingShippingServiceId(requestParameters.id, requestParameters.getApiShippingShippingServiceIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetApiShippingShippingServicesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiShippingShippingServices(requestParameters: EndpointsApiGetApiShippingShippingServicesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiShippingShippingServices(requestParameters.getApiShippingShippingServicesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiThemeActive(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiThemeActive(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiThemes(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiThemes(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetApiUserPermissionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiUserPermissions(requestParameters: EndpointsApiGetApiUserPermissionsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiUserPermissions(requestParameters.getApiUserPermissionsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetApiUserPermissionsRoleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiUserPermissionsRole(requestParameters: EndpointsApiGetApiUserPermissionsRoleRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getApiUserPermissionsRole(requestParameters.role, requestParameters.getApiUserPermissionsRoleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetFrontBannerIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrontBannerId(requestParameters: EndpointsApiGetFrontBannerIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetV1CountriesCountries200Response> {
            return localVarFp.getFrontBannerId(requestParameters.id, requestParameters.getFrontBannerIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetFrontBannersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrontBanners(requestParameters: EndpointsApiGetFrontBannersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetFrontBanners200Response> {
            return localVarFp.getFrontBanners(requestParameters.getFrontBannersRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetFrontBrandIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrontBrandId(requestParameters: EndpointsApiGetFrontBrandIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getFrontBrandId(requestParameters.id, requestParameters.getFrontBrandIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetFrontBrandsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrontBrands(requestParameters: EndpointsApiGetFrontBrandsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetFrontBrands200Response> {
            return localVarFp.getFrontBrands(requestParameters.getFrontBrandsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetFrontCategoriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrontCategories(requestParameters: EndpointsApiGetFrontCategoriesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetFrontCategories200Response> {
            return localVarFp.getFrontCategories(requestParameters.getFrontCategoriesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetFrontCategoryIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrontCategoryId(requestParameters: EndpointsApiGetFrontCategoryIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getFrontCategoryId(requestParameters.id, requestParameters.getFrontCategoryIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetFrontFooterIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrontFooterId(requestParameters: EndpointsApiGetFrontFooterIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetV1CountriesCountries200Response> {
            return localVarFp.getFrontFooterId(requestParameters.id, requestParameters.getFrontFooterIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetFrontFootersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrontFooters(requestParameters: EndpointsApiGetFrontFootersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetV1CountriesCountries200Response> {
            return localVarFp.getFrontFooters(requestParameters.getFrontFootersRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrontLogout(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getFrontLogout(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetFrontMenuIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrontMenuId(requestParameters: EndpointsApiGetFrontMenuIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetV1CountriesCountries200Response> {
            return localVarFp.getFrontMenuId(requestParameters.id, requestParameters.getFrontMenuIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetFrontMenusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrontMenus(requestParameters: EndpointsApiGetFrontMenusRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetV1CountriesCountries200Response> {
            return localVarFp.getFrontMenus(requestParameters.getFrontMenusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrontNavbarMode(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getFrontNavbarMode(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetFrontProductIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrontProductId(requestParameters: EndpointsApiGetFrontProductIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getFrontProductId(requestParameters.id, requestParameters.getFrontProductIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetFrontProductsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrontProducts(requestParameters: EndpointsApiGetFrontProductsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetFrontProducts200Response> {
            return localVarFp.getFrontProducts(requestParameters.getFrontProductsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetFrontSeoIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrontSeoId(requestParameters: EndpointsApiGetFrontSeoIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetV1CountriesCountries200Response> {
            return localVarFp.getFrontSeoId(requestParameters.id, requestParameters.getFrontSeoIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetFrontSeosRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrontSeos(requestParameters: EndpointsApiGetFrontSeosRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetV1CountriesCountries200Response> {
            return localVarFp.getFrontSeos(requestParameters.getFrontMenuIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrontTestPing(options?: RawAxiosRequestConfig): AxiosPromise<GetV1TestPing200Response> {
            return localVarFp.getFrontTestPing(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrontThemeActive(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getFrontThemeActive(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetFrontVerifyResetPasswordTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrontVerifyResetPasswordToken(requestParameters: EndpointsApiGetFrontVerifyResetPasswordTokenRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getFrontVerifyResetPasswordToken(requestParameters.token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetFrontVerifyTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrontVerifyToken(requestParameters: EndpointsApiGetFrontVerifyTokenRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getFrontVerifyToken(requestParameters.token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetV1BannerIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1BannerId(requestParameters: EndpointsApiGetV1BannerIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getV1BannerId(requestParameters.id, requestParameters.getV1BannersRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetV1BannersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1Banners(requestParameters: EndpointsApiGetV1BannersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getV1Banners(requestParameters.getV1BannersRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1ClearAllCache(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getV1ClearAllCache(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1CountriesCountries(options?: RawAxiosRequestConfig): AxiosPromise<GetV1CountriesCountries200Response> {
            return localVarFp.getV1CountriesCountries(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetV1CountriesCountryIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1CountriesCountryId(requestParameters: EndpointsApiGetV1CountriesCountryIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getV1CountriesCountryId(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetV1FooterIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1FooterId(requestParameters: EndpointsApiGetV1FooterIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getV1FooterId(requestParameters.id, requestParameters.getV1FooterIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetV1FootersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1Footers(requestParameters: EndpointsApiGetV1FootersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getV1Footers(requestParameters.getV1FootersRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1Logout(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getV1Logout(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetV1MenuIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1MenuId(requestParameters: EndpointsApiGetV1MenuIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getV1MenuId(requestParameters.id, requestParameters.getV1MenuIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetV1MenusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1Menus(requestParameters: EndpointsApiGetV1MenusRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getV1Menus(requestParameters.getV1MenusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1TestPing(options?: RawAxiosRequestConfig): AxiosPromise<GetV1TestPing200Response> {
            return localVarFp.getV1TestPing(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetV1VerifyResetPasswordTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1VerifyResetPasswordToken(requestParameters: EndpointsApiGetV1VerifyResetPasswordTokenRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getV1VerifyResetPasswordToken(requestParameters.token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiGetV1VerifyTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1VerifyToken(requestParameters: EndpointsApiGetV1VerifyTokenRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getV1VerifyToken(requestParameters.token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPatchApiShippingShippingServiceIdActivateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchApiShippingShippingServiceIdActivate(requestParameters: EndpointsApiPatchApiShippingShippingServiceIdActivateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.patchApiShippingShippingServiceIdActivate(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiAccountsUserCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiAccountsUserCreate(requestParameters: EndpointsApiPostApiAccountsUserCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiAccountsUserCreate(requestParameters.postApiAccountsUserCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiAccountsUserDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiAccountsUserDelete(requestParameters: EndpointsApiPostApiAccountsUserDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiAccountsUserDelete(requestParameters.postApiAccountsUserDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiAccountsUserUpdateIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiAccountsUserUpdateId(requestParameters: EndpointsApiPostApiAccountsUserUpdateIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiAccountsUserUpdateId(requestParameters.id, requestParameters.postApiAccountsUserUpdateIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiAmazonSettingsUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiAmazonSettingsUpdate(requestParameters: EndpointsApiPostApiAmazonSettingsUpdateRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiAmazonSettingsUpdate(requestParameters.postApiAmazonSettingsUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiAramexSettingsUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiAramexSettingsUpdate(requestParameters: EndpointsApiPostApiAramexSettingsUpdateRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiAramexSettingsUpdate(requestParameters.postApiAramexSettingsUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiAttributesSeoCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiAttributesSeoCreate(requestParameters: EndpointsApiPostApiAttributesSeoCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiAttributesSeoCreate(requestParameters.postApiAttributesSeoCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiAttributesSeoDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiAttributesSeoDelete(requestParameters: EndpointsApiPostApiAttributesSeoDeleteRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiAttributesSeoDelete(requestParameters.postV1FooterDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiAttributesSeoUpdateIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiAttributesSeoUpdateId(requestParameters: EndpointsApiPostApiAttributesSeoUpdateIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiAttributesSeoUpdateId(requestParameters.id, requestParameters.postApiAttributesSeoUpdateIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiBillingBillingDetailsCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiBillingBillingDetailsCreate(requestParameters: EndpointsApiPostApiBillingBillingDetailsCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiBillingBillingDetailsCreate(requestParameters.postApiBillingBillingDetailsCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiBillingBillingDetailsDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiBillingBillingDetailsDelete(requestParameters: EndpointsApiPostApiBillingBillingDetailsDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiBillingBillingDetailsDelete(requestParameters.postApiBillingBillingDetailsDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiBillingBillingDetailsUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiBillingBillingDetailsUpdate(requestParameters: EndpointsApiPostApiBillingBillingDetailsUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiBillingBillingDetailsUpdate(requestParameters.postApiBillingBillingDetailsUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiBillingCreditCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiBillingCreditCreate(requestParameters: EndpointsApiPostApiBillingCreditCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiBillingCreditCreate(requestParameters.postApiBillingCreditCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiBillingCreditDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiBillingCreditDelete(requestParameters: EndpointsApiPostApiBillingCreditDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiBillingCreditDelete(requestParameters.postApiBillingCreditDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiBillingCreditUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiBillingCreditUpdate(requestParameters: EndpointsApiPostApiBillingCreditUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiBillingCreditUpdate(requestParameters.postApiBillingCreditUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiCartAddRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCartAdd(requestParameters: EndpointsApiPostApiCartAddRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiCartAdd(requestParameters.postApiCartAddRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiCatalogAttributeCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCatalogAttributeCreate(requestParameters: EndpointsApiPostApiCatalogAttributeCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiCatalogAttributeCreate(requestParameters.postApiCatalogAttributeCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiCatalogAttributeDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCatalogAttributeDelete(requestParameters: EndpointsApiPostApiCatalogAttributeDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiCatalogAttributeDelete(requestParameters.postApiCatalogAttributeDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiCatalogAttributeUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCatalogAttributeUpdate(requestParameters: EndpointsApiPostApiCatalogAttributeUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiCatalogAttributeUpdate(requestParameters.postApiCatalogAttributeUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiCatalogAttributeValueCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCatalogAttributeValueCreate(requestParameters: EndpointsApiPostApiCatalogAttributeValueCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiCatalogAttributeValueCreate(requestParameters.postApiCatalogAttributeValueCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiCatalogAttributeValueDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCatalogAttributeValueDelete(requestParameters: EndpointsApiPostApiCatalogAttributeValueDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiCatalogAttributeValueDelete(requestParameters.postApiCatalogAttributeValueDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiCatalogAttributeValueUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCatalogAttributeValueUpdate(requestParameters: EndpointsApiPostApiCatalogAttributeValueUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiCatalogAttributeValueUpdate(requestParameters.postApiCatalogAttributeValueUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiCatalogBrandCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCatalogBrandCreate(requestParameters: EndpointsApiPostApiCatalogBrandCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiCatalogBrandCreate(requestParameters.postApiCatalogBrandCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiCatalogBrandDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCatalogBrandDelete(requestParameters: EndpointsApiPostApiCatalogBrandDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiCatalogBrandDelete(requestParameters.postApiCatalogBrandDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiCatalogBrandUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCatalogBrandUpdate(requestParameters: EndpointsApiPostApiCatalogBrandUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiCatalogBrandUpdate(requestParameters.postApiCatalogBrandUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiCatalogCategoryCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCatalogCategoryCreate(requestParameters: EndpointsApiPostApiCatalogCategoryCreateRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiCatalogCategoryCreate(requestParameters.postApiCatalogCategoryCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiCatalogCategoryDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCatalogCategoryDelete(requestParameters: EndpointsApiPostApiCatalogCategoryDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiCatalogCategoryDelete(requestParameters.postApiCatalogCategoryDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiCatalogCategoryUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCatalogCategoryUpdate(requestParameters: EndpointsApiPostApiCatalogCategoryUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiCatalogCategoryUpdate(requestParameters.postApiCatalogCategoryUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiCatalogProductAttributesCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCatalogProductAttributesCreate(requestParameters: EndpointsApiPostApiCatalogProductAttributesCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiCatalogProductAttributesCreate(requestParameters.postApiCatalogProductAttributesCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiCatalogProductAttributesDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCatalogProductAttributesDelete(requestParameters: EndpointsApiPostApiCatalogProductAttributesDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiCatalogProductAttributesDelete(requestParameters.postApiCatalogProductAttributesDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiCatalogProductAttributesUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCatalogProductAttributesUpdate(requestParameters: EndpointsApiPostApiCatalogProductAttributesUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiCatalogProductAttributesUpdate(requestParameters.postApiCatalogProductAttributesUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiCatalogProductCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCatalogProductCreate(requestParameters: EndpointsApiPostApiCatalogProductCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiCatalogProductCreate(requestParameters.postApiCatalogProductCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiCatalogProductDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCatalogProductDelete(requestParameters: EndpointsApiPostApiCatalogProductDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiCatalogProductDelete(requestParameters.postApiCatalogProductDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiCatalogProductUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCatalogProductUpdate(requestParameters: EndpointsApiPostApiCatalogProductUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiCatalogProductUpdate(requestParameters.postApiCatalogProductUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiCatalogStoreCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCatalogStoreCreate(requestParameters: EndpointsApiPostApiCatalogStoreCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiCatalogStoreCreate(requestParameters.postApiCatalogStoreCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiCatalogStoreDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCatalogStoreDelete(requestParameters: EndpointsApiPostApiCatalogStoreDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiCatalogStoreDelete(requestParameters.postApiCatalogStoreDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiCatalogStoreUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCatalogStoreUpdate(requestParameters: EndpointsApiPostApiCatalogStoreUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiCatalogStoreUpdate(requestParameters.postApiCatalogStoreUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiCatalogTagCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCatalogTagCreate(requestParameters: EndpointsApiPostApiCatalogTagCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiCatalogTagCreate(requestParameters.postApiCatalogTagCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiCatalogTagDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCatalogTagDelete(requestParameters: EndpointsApiPostApiCatalogTagDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiCatalogTagDelete(requestParameters.postApiCatalogTagDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiCatalogTagUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCatalogTagUpdate(requestParameters: EndpointsApiPostApiCatalogTagUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiCatalogTagUpdate(requestParameters.postApiCatalogTagUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiCommunicationsNewsletterCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCommunicationsNewsletterCreate(requestParameters: EndpointsApiPostApiCommunicationsNewsletterCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiCommunicationsNewsletterCreate(requestParameters.postApiCommunicationsNewsletterCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiCommunicationsNewsletterDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCommunicationsNewsletterDelete(requestParameters: EndpointsApiPostApiCommunicationsNewsletterDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiCommunicationsNewsletterDelete(requestParameters.postApiCommunicationsNewsletterDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiCommunicationsNewsletterUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCommunicationsNewsletterUpdate(requestParameters: EndpointsApiPostApiCommunicationsNewsletterUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiCommunicationsNewsletterUpdate(requestParameters.postApiCommunicationsNewsletterUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiCommunicationsSubscriberCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCommunicationsSubscriberCreate(requestParameters: EndpointsApiPostApiCommunicationsSubscriberCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiCommunicationsSubscriberCreate(requestParameters.postApiCommunicationsSubscriberCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiCommunicationsSubscriberDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCommunicationsSubscriberDelete(requestParameters: EndpointsApiPostApiCommunicationsSubscriberDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiCommunicationsSubscriberDelete(requestParameters.postApiAccountsUserDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiCommunicationsSubscriberUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiCommunicationsSubscriberUpdate(requestParameters: EndpointsApiPostApiCommunicationsSubscriberUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiCommunicationsSubscriberUpdate(requestParameters.postApiCommunicationsSubscriberUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiContentPageCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiContentPageCreate(requestParameters: EndpointsApiPostApiContentPageCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiContentPageCreate(requestParameters.postApiContentPageCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiContentPageDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiContentPageDelete(requestParameters: EndpointsApiPostApiContentPageDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiContentPageDelete(requestParameters.postApiContentPageDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiContentPageUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiContentPageUpdate(requestParameters: EndpointsApiPostApiContentPageUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiContentPageUpdate(requestParameters.postApiContentPageUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiInstashopSettingsUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiInstashopSettingsUpdate(requestParameters: EndpointsApiPostApiInstashopSettingsUpdateRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiInstashopSettingsUpdate(requestParameters.postApiInstashopSettingsUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiInvoicesSettingsCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiInvoicesSettingsCreate(requestParameters: EndpointsApiPostApiInvoicesSettingsCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiInvoicesSettingsCreate(requestParameters.postApiInvoicesSettingsCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiInvoicesSettingsDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiInvoicesSettingsDelete(requestParameters: EndpointsApiPostApiInvoicesSettingsDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiInvoicesSettingsDelete(requestParameters.postApiInvoicesSettingsDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiInvoicesSettingsUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiInvoicesSettingsUpdate(requestParameters: EndpointsApiPostApiInvoicesSettingsUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiInvoicesSettingsUpdate(requestParameters.postApiInvoicesSettingsUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiMediaFileDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiMediaFileDelete(requestParameters: EndpointsApiPostApiMediaFileDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiMediaFileDelete(requestParameters.postApiMediaFileDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiMediaFileUpdateIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiMediaFileUpdateId(requestParameters: EndpointsApiPostApiMediaFileUpdateIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiMediaFileUpdateId(requestParameters.id, requestParameters.postApiMediaFileUpdateIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiMediaFileUploadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiMediaFileUpload(requestParameters: EndpointsApiPostApiMediaFileUploadRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiMediaFileUpload(requestParameters.postApiMediaFileUploadRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiMediaSettingsSizeUpdateIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiMediaSettingsSizeUpdateId(requestParameters: EndpointsApiPostApiMediaSettingsSizeUpdateIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiMediaSettingsSizeUpdateId(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiMediaThumbUpdateAudio(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiMediaThumbUpdateAudio(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiMediaThumbUpdateDocument(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiMediaThumbUpdateDocument(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiMediaThumbUpdateVideo(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiMediaThumbUpdateVideo(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiNoonSettingsUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiNoonSettingsUpdate(requestParameters: EndpointsApiPostApiNoonSettingsUpdateRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiNoonSettingsUpdate(requestParameters.postApiNoonSettingsUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiOrdersOrderCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiOrdersOrderCreate(requestParameters: EndpointsApiPostApiOrdersOrderCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiOrdersOrderCreate(requestParameters.postApiOrdersOrderCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiOrdersOrderDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiOrdersOrderDelete(requestParameters: EndpointsApiPostApiOrdersOrderDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiOrdersOrderDelete(requestParameters.postApiOrdersOrderDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiOrdersOrderUpdateIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiOrdersOrderUpdateId(requestParameters: EndpointsApiPostApiOrdersOrderUpdateIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiOrdersOrderUpdateId(requestParameters.id, requestParameters.postApiOrdersOrderUpdateIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiOrdersStatusCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiOrdersStatusCreate(requestParameters: EndpointsApiPostApiOrdersStatusCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiOrdersStatusCreate(requestParameters.postApiOrdersStatusCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiOrdersStatusDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiOrdersStatusDelete(requestParameters: EndpointsApiPostApiOrdersStatusDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiOrdersStatusDelete(requestParameters.postApiOrdersStatusDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiOrdersStatusUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiOrdersStatusUpdate(requestParameters: EndpointsApiPostApiOrdersStatusUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiOrdersStatusUpdate(requestParameters.postApiOrdersStatusUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiPaymentInitiateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiPaymentInitiate(requestParameters: EndpointsApiPostApiPaymentInitiateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiPaymentInitiate(requestParameters.postApiPaymentInitiateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiPromotionsCodeCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiPromotionsCodeCreate(requestParameters: EndpointsApiPostApiPromotionsCodeCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiPromotionsCodeCreate(requestParameters.postApiPromotionsCodeCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiPromotionsCodeDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiPromotionsCodeDelete(requestParameters: EndpointsApiPostApiPromotionsCodeDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiPromotionsCodeDelete(requestParameters.postApiPromotionsCodeDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiPromotionsCodeUpdateIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiPromotionsCodeUpdateId(requestParameters: EndpointsApiPostApiPromotionsCodeUpdateIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiPromotionsCodeUpdateId(requestParameters.id, requestParameters.postApiPromotionsCodeUpdateIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiPromotionsOfferCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiPromotionsOfferCreate(requestParameters: EndpointsApiPostApiPromotionsOfferCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiPromotionsOfferCreate(requestParameters.postApiPromotionsOfferCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiPromotionsOfferDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiPromotionsOfferDelete(requestParameters: EndpointsApiPostApiPromotionsOfferDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiPromotionsOfferDelete(requestParameters.postApiCatalogProductDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiPromotionsOfferUpdateIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiPromotionsOfferUpdateId(requestParameters: EndpointsApiPostApiPromotionsOfferUpdateIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiPromotionsOfferUpdateId(requestParameters.id, requestParameters.postApiPromotionsOfferUpdateIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiSettingsCcavenueSettingsUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiSettingsCcavenueSettingsUpdate(requestParameters: EndpointsApiPostApiSettingsCcavenueSettingsUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiSettingsCcavenueSettingsUpdate(requestParameters.postApiSettingsCcavenueSettingsUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiSettingsCurrencyCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiSettingsCurrencyCreate(requestParameters: EndpointsApiPostApiSettingsCurrencyCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiSettingsCurrencyCreate(requestParameters.postApiSettingsCurrencyCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiSettingsCurrencyDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiSettingsCurrencyDelete(requestParameters: EndpointsApiPostApiSettingsCurrencyDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiSettingsCurrencyDelete(requestParameters.postApiCatalogTagDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiSettingsCurrencyUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiSettingsCurrencyUpdate(requestParameters: EndpointsApiPostApiSettingsCurrencyUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiSettingsCurrencyUpdate(requestParameters.postApiSettingsCurrencyUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiSettingsNetworkSettingsUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiSettingsNetworkSettingsUpdate(requestParameters: EndpointsApiPostApiSettingsNetworkSettingsUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiSettingsNetworkSettingsUpdate(requestParameters.postApiSettingsNetworkSettingsUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiSettingsOnlinePaymentCardMethodActivateIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiSettingsOnlinePaymentCardMethodActivateId(requestParameters: EndpointsApiPostApiSettingsOnlinePaymentCardMethodActivateIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiSettingsOnlinePaymentCardMethodActivateId(requestParameters.id, requestParameters.postApiSettingsOnlinePaymentGatewayActivateIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiSettingsOnlinePaymentGatewayActivateIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiSettingsOnlinePaymentGatewayActivateId(requestParameters: EndpointsApiPostApiSettingsOnlinePaymentGatewayActivateIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiSettingsOnlinePaymentGatewayActivateId(requestParameters.id, requestParameters.postApiSettingsOnlinePaymentGatewayActivateIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiSettingsPayfortSettingsUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiSettingsPayfortSettingsUpdate(requestParameters: EndpointsApiPostApiSettingsPayfortSettingsUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiSettingsPayfortSettingsUpdate(requestParameters.postApiSettingsPayfortSettingsUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiSettingsPaymentModeCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiSettingsPaymentModeCreate(requestParameters: EndpointsApiPostApiSettingsPaymentModeCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiSettingsPaymentModeCreate(requestParameters.postApiSettingsPaymentModeCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiSettingsPaymentModeDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiSettingsPaymentModeDelete(requestParameters: EndpointsApiPostApiSettingsPaymentModeDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiSettingsPaymentModeDelete(requestParameters.postApiSettingsPaymentModeDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiSettingsPaymentModeUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiSettingsPaymentModeUpdate(requestParameters: EndpointsApiPostApiSettingsPaymentModeUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiSettingsPaymentModeUpdate(requestParameters.postApiSettingsPaymentModeUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiSettingsPaypalSettingsUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiSettingsPaypalSettingsUpdate(requestParameters: EndpointsApiPostApiSettingsPaypalSettingsUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiSettingsPaypalSettingsUpdate(requestParameters.postApiSettingsPaypalSettingsUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiSettingsStripeSettingsUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiSettingsStripeSettingsUpdate(requestParameters: EndpointsApiPostApiSettingsStripeSettingsUpdateRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiSettingsStripeSettingsUpdate(requestParameters.postApiSettingsStripeSettingsUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiSettingsTabbySettingsUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiSettingsTabbySettingsUpdate(requestParameters: EndpointsApiPostApiSettingsTabbySettingsUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiSettingsTabbySettingsUpdate(requestParameters.postApiSettingsTabbySettingsUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiSettingsTamaraSettingsUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiSettingsTamaraSettingsUpdate(requestParameters: EndpointsApiPostApiSettingsTamaraSettingsUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiSettingsTamaraSettingsUpdate(requestParameters.postApiSettingsTamaraSettingsUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiShippingCostCalculatorRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiShippingCostCalculator(requestParameters: EndpointsApiPostApiShippingCostCalculatorRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiShippingCostCalculator(requestParameters.postApiShippingCostCalculatorRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiShippingFlatRateCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiShippingFlatRateCreate(requestParameters: EndpointsApiPostApiShippingFlatRateCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiShippingFlatRateCreate(requestParameters.postApiShippingFlatRateCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiShippingFlatRateDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiShippingFlatRateDelete(requestParameters: EndpointsApiPostApiShippingFlatRateDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiShippingFlatRateDelete(requestParameters.postApiCatalogCategoryDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiShippingFlatRateUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiShippingFlatRateUpdate(requestParameters: EndpointsApiPostApiShippingFlatRateUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiShippingFlatRateUpdate(requestParameters.postApiShippingFlatRateUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiShippingShippingDetailsCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiShippingShippingDetailsCreate(requestParameters: EndpointsApiPostApiShippingShippingDetailsCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiShippingShippingDetailsCreate(requestParameters.postApiShippingShippingDetailsCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiShippingShippingDetailsDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiShippingShippingDetailsDelete(requestParameters: EndpointsApiPostApiShippingShippingDetailsDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiShippingShippingDetailsDelete(requestParameters.postApiShippingShippingDetailsDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiShippingShippingDetailsUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiShippingShippingDetailsUpdate(requestParameters: EndpointsApiPostApiShippingShippingDetailsUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiShippingShippingDetailsUpdate(requestParameters.postApiShippingShippingDetailsUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiShippingShippingServiceCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiShippingShippingServiceCreate(requestParameters: EndpointsApiPostApiShippingShippingServiceCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiShippingShippingServiceCreate(requestParameters.postApiShippingShippingServiceCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiShippingShippingServiceDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiShippingShippingServiceDelete(requestParameters: EndpointsApiPostApiShippingShippingServiceDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiShippingShippingServiceDelete(requestParameters.postApiShippingShippingServiceDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiShippingShippingServiceUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiShippingShippingServiceUpdate(requestParameters: EndpointsApiPostApiShippingShippingServiceUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiShippingShippingServiceUpdate(requestParameters.postApiShippingShippingServiceUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiThemeActivateIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiThemeActivateId(requestParameters: EndpointsApiPostApiThemeActivateIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiThemeActivateId(requestParameters.id, requestParameters.getApiSettingsCurrencyIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new theme
         * @param {EndpointsApiPostApiThemeCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiThemeCreate(requestParameters: EndpointsApiPostApiThemeCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiThemeCreate(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a theme's color palette
         * @param {EndpointsApiPostApiThemeColorUpdateIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiThemeColorUpdateId(requestParameters: EndpointsApiPostApiThemeColorUpdateIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.postApiThemeColorUpdateId(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiThemeSettingsUpdateIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiThemeSettingsUpdateId(requestParameters: EndpointsApiPostApiThemeSettingsUpdateIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiThemeSettingsUpdateId(requestParameters.id, requestParameters.postApiThemeSettingsUpdateIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a saved color theme
         * @param {EndpointsApiDeleteApiThemeColorIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApiThemeColorId(requestParameters: EndpointsApiDeleteApiThemeColorIdRequest, options?: RawAxiosRequestConfig) {
            return localVarFp.deleteApiThemeColorId(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiThemeUploadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiThemeUpload(requestParameters: EndpointsApiPostApiThemeUploadRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiThemeUpload(requestParameters.themeZip, requestParameters.name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiUserPermissionsUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiUserPermissionsUpdate(requestParameters: EndpointsApiPostApiUserPermissionsUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiUserPermissionsUpdate(requestParameters.postApiUserPermissionsUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiUserRoleCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiUserRoleCreate(requestParameters: EndpointsApiPostApiUserRoleCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiUserRoleCreate(requestParameters.postApiUserRoleCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiUserRoleDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiUserRoleDelete(requestParameters: EndpointsApiPostApiUserRoleDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiUserRoleDelete(requestParameters.postApiUserRoleDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostApiUserRoleUpdateRoleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiUserRoleUpdateRole(requestParameters: EndpointsApiPostApiUserRoleUpdateRoleRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postApiUserRoleUpdateRole(requestParameters.role, requestParameters.postApiUserRoleUpdateRoleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFrontLogin(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postFrontLogin(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostFrontProductRateIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFrontProductRateId(requestParameters: EndpointsApiPostFrontProductRateIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postFrontProductRateId(requestParameters.id, requestParameters.postFrontProductRateIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFrontRegister(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postFrontRegister(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFrontReset(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postFrontReset(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFrontResetPassword(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postFrontResetPassword(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostV1BannerCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postV1BannerCreate(requestParameters: EndpointsApiPostV1BannerCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postV1BannerCreate(requestParameters.postV1BannerCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostV1BannerDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postV1BannerDelete(requestParameters: EndpointsApiPostV1BannerDeleteRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postV1BannerDelete(requestParameters.postV1BannerDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostV1BannerUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postV1BannerUpdate(requestParameters: EndpointsApiPostV1BannerUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postV1BannerUpdate(requestParameters.postV1BannerUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostV1FooterCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postV1FooterCreate(requestParameters: EndpointsApiPostV1FooterCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postV1FooterCreate(requestParameters.postV1FooterCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostV1FooterDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postV1FooterDelete(requestParameters: EndpointsApiPostV1FooterDeleteRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postV1FooterDelete(requestParameters.postV1FooterDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostV1FooterUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postV1FooterUpdate(requestParameters: EndpointsApiPostV1FooterUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postV1FooterUpdate(requestParameters.postV1FooterUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postV1Login(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postV1Login(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostV1MenuCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postV1MenuCreate(requestParameters: EndpointsApiPostV1MenuCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postV1MenuCreate(requestParameters.postV1MenuCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostV1MenuDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postV1MenuDelete(requestParameters: EndpointsApiPostV1MenuDeleteRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postV1MenuDelete(requestParameters.postV1MenuDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostV1MenuUpdateIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postV1MenuUpdateId(requestParameters: EndpointsApiPostV1MenuUpdateIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postV1MenuUpdateId(requestParameters.id, requestParameters.postV1MenuUpdateIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        /**
         * 
         * @summary 
         * @param {EndpointsApiPostV1NavbarModeUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postV1NavbarModeUpdate(requestParameters: EndpointsApiPostV1NavbarModeUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postV1NavbarModeUpdate(requestParameters.postV1NavbarModeUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postV1Register(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postV1Register(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postV1Reset(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postV1Reset(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postV1ResetPassword(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postV1ResetPassword(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EndpointsApiPutApiCartItemsCartItemIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putApiCartItemsCartItemId(requestParameters: EndpointsApiPutApiCartItemsCartItemIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putApiCartItemsCartItemId(requestParameters.cartItemId, requestParameters.putApiCartItemsCartItemIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Serve the generated OpenAPI YAML file.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serveTheGeneratedOpenAPIYAMLFile(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.serveTheGeneratedOpenAPIYAMLFile(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for deleteApiCartItemsCartItemId operation in EndpointsApi.
 */
export interface EndpointsApiDeleteApiCartItemsCartItemIdRequest {
    /**
     * 
     */
    readonly cartItemId: string
}

/**
 * Request parameters for getApiAdminCarts operation in EndpointsApi.
 */
export interface EndpointsApiGetApiAdminCartsRequest {
    readonly getApiAdminCartsRequest?: GetApiAdminCartsRequest
}

/**
 * Request parameters for getApiAttributesSeoId operation in EndpointsApi.
 */
export interface EndpointsApiGetApiAttributesSeoIdRequest {
    /**
     * The ID of the seo.
     */
    readonly id: string

    readonly getApiAttributesSeoIdRequest?: GetApiAttributesSeoIdRequest
}

/**
 * Request parameters for getApiAttributesSeos operation in EndpointsApi.
 */
export interface EndpointsApiGetApiAttributesSeosRequest {
    readonly getApiAttributesSeosRequest?: GetApiAttributesSeosRequest
}

/**
 * Request parameters for getApiBillingCreditId operation in EndpointsApi.
 */
export interface EndpointsApiGetApiBillingCreditIdRequest {
    /**
     * The ID of the credit.
     */
    readonly id: string

    readonly getApiBillingCreditIdRequest?: GetApiBillingCreditIdRequest
}

/**
 * Request parameters for getApiBillingCredits operation in EndpointsApi.
 */
export interface EndpointsApiGetApiBillingCreditsRequest {
    readonly getApiBillingCreditsRequest?: GetApiBillingCreditsRequest
}

/**
 * Request parameters for getApiCatalogAttributeId operation in EndpointsApi.
 */
export interface EndpointsApiGetApiCatalogAttributeIdRequest {
    /**
     * The ID of the attribute.
     */
    readonly id: string

    readonly getApiCatalogAttributeIdRequest?: GetApiCatalogAttributeIdRequest
}

/**
 * Request parameters for getApiCatalogAttributeValueId operation in EndpointsApi.
 */
export interface EndpointsApiGetApiCatalogAttributeValueIdRequest {
    /**
     * The ID of the attribute value.
     */
    readonly id: string

    readonly postV1FooterDeleteRequest?: PostV1FooterDeleteRequest
}

/**
 * Request parameters for getApiCatalogAttributes operation in EndpointsApi.
 */
export interface EndpointsApiGetApiCatalogAttributesRequest {
    readonly getApiContentPageIdRequest?: GetApiContentPageIdRequest
}

/**
 * Request parameters for getApiCatalogAttributesValues operation in EndpointsApi.
 */
export interface EndpointsApiGetApiCatalogAttributesValuesRequest {
    readonly getApiCatalogAttributesValuesRequest?: GetApiCatalogAttributesValuesRequest
}

/**
 * Request parameters for getApiCatalogBrandId operation in EndpointsApi.
 */
export interface EndpointsApiGetApiCatalogBrandIdRequest {
    /**
     * The ID of the brand.
     */
    readonly id: string

    readonly getApiCatalogBrandIdRequest?: GetApiCatalogBrandIdRequest
}

/**
 * Request parameters for getApiCatalogBrands operation in EndpointsApi.
 */
export interface EndpointsApiGetApiCatalogBrandsRequest {
    readonly getApiCatalogBrandsRequest?: GetApiCatalogBrandsRequest
}

/**
 * Request parameters for getApiCatalogCategories operation in EndpointsApi.
 */
export interface EndpointsApiGetApiCatalogCategoriesRequest {
    readonly getApiCatalogCategoriesRequest?: GetApiCatalogCategoriesRequest
}

/**
 * Request parameters for getApiCatalogCategoryId operation in EndpointsApi.
 */
export interface EndpointsApiGetApiCatalogCategoryIdRequest {
    /**
     * The ID of the category.
     */
    readonly id: string

    readonly getApiCatalogCategoryIdRequest?: GetApiCatalogCategoryIdRequest
}

/**
 * Request parameters for getApiCatalogProductAttributesId operation in EndpointsApi.
 */
export interface EndpointsApiGetApiCatalogProductAttributesIdRequest {
    /**
     * The ID of the product attribute.
     */
    readonly id: string

    readonly getApiCatalogAttributesValuesRequest?: GetApiCatalogAttributesValuesRequest
}

/**
 * Request parameters for getApiCatalogProductId operation in EndpointsApi.
 */
export interface EndpointsApiGetApiCatalogProductIdRequest {
    /**
     * The ID of the product.
     */
    readonly id: string

    readonly getApiCatalogProductIdRequest?: GetApiCatalogProductIdRequest
}

/**
 * Request parameters for getApiCatalogProductSearch operation in EndpointsApi.
 */
export interface EndpointsApiGetApiCatalogProductSearchRequest {
    readonly getApiCatalogProductSearchRequest?: GetApiCatalogProductSearchRequest
}

/**
 * Request parameters for getApiCatalogProducts operation in EndpointsApi.
 */
export interface EndpointsApiGetApiCatalogProductsRequest {
    readonly getApiCatalogProductsRequest?: GetApiCatalogProductsRequest
}

/**
 * Request parameters for getApiCatalogProductsAttributes operation in EndpointsApi.
 */
export interface EndpointsApiGetApiCatalogProductsAttributesRequest {
    readonly getApiCatalogProductsAttributesRequest?: GetApiCatalogProductsAttributesRequest
}

/**
 * Request parameters for getApiCatalogStoreId operation in EndpointsApi.
 */
export interface EndpointsApiGetApiCatalogStoreIdRequest {
    /**
     * The ID of the store.
     */
    readonly id: string

    readonly getApiCatalogStoreIdRequest?: GetApiCatalogStoreIdRequest
}

/**
 * Request parameters for getApiCatalogStores operation in EndpointsApi.
 */
export interface EndpointsApiGetApiCatalogStoresRequest {
    readonly getApiCatalogStoresRequest?: GetApiCatalogStoresRequest
}

/**
 * Request parameters for getApiCatalogTagId operation in EndpointsApi.
 */
export interface EndpointsApiGetApiCatalogTagIdRequest {
    /**
     * The ID of the tag.
     */
    readonly id: string

    readonly getApiCatalogTagIdRequest?: GetApiCatalogTagIdRequest
}

/**
 * Request parameters for getApiCatalogTags operation in EndpointsApi.
 */
export interface EndpointsApiGetApiCatalogTagsRequest {
    readonly getApiCatalogTagsRequest?: GetApiCatalogTagsRequest
}

/**
 * Request parameters for getApiClientUserId operation in EndpointsApi.
 */
export interface EndpointsApiGetApiClientUserIdRequest {
    /**
     * The ID of the user.
     */
    readonly id: string

    readonly getUsersRequest1?: GetUsersRequest1
}

/**
 * Request parameters for getApiCommunicationsNewsletterId operation in EndpointsApi.
 */
export interface EndpointsApiGetApiCommunicationsNewsletterIdRequest {
    /**
     * The ID of the newsletter.
     */
    readonly id: string
}

/**
 * Request parameters for getApiCommunicationsSubscriberId operation in EndpointsApi.
 */
export interface EndpointsApiGetApiCommunicationsSubscriberIdRequest {
    /**
     * The ID of the subscriber.
     */
    readonly id: string
}

/**
 * Request parameters for getApiContentPageId operation in EndpointsApi.
 */
export interface EndpointsApiGetApiContentPageIdRequest {
    /**
     * The ID of the page.
     */
    readonly id: string

    readonly getApiContentPageIdRequest?: GetApiContentPageIdRequest
}

/**
 * Request parameters for getApiContentPages operation in EndpointsApi.
 */
export interface EndpointsApiGetApiContentPagesRequest {
    readonly getApiContentPagesRequest?: GetApiContentPagesRequest
}

/**
 * Request parameters for getApiInvoicesSettings operation in EndpointsApi.
 */
export interface EndpointsApiGetApiInvoicesSettingsRequest {
    readonly getApiInvoicesSettingsRequest?: GetApiInvoicesSettingsRequest
}

/**
 * Request parameters for getApiInvoicesSettingsId operation in EndpointsApi.
 */
export interface EndpointsApiGetApiInvoicesSettingsIdRequest {
    /**
     * The ID of the setting.
     */
    readonly id: string

    readonly getApiInvoicesSettingsIdRequest?: GetApiInvoicesSettingsIdRequest
}

/**
 * Request parameters for getApiMediaFiles operation in EndpointsApi.
 */
export interface EndpointsApiGetApiMediaFilesRequest {
    readonly getApiContentPagesRequest?: GetApiContentPagesRequest
}

/**
 * Request parameters for getApiMediaFilesId operation in EndpointsApi.
 */
export interface EndpointsApiGetApiMediaFilesIdRequest {
    /**
     * The ID of the file.
     */
    readonly id: string

    readonly getApiMediaFilesIdRequest?: GetApiMediaFilesIdRequest
}

/**
 * Request parameters for getApiMediaSearch operation in EndpointsApi.
 */
export interface EndpointsApiGetApiMediaSearchRequest {
    readonly getApiMediaSearchRequest?: GetApiMediaSearchRequest
}

/**
 * Request parameters for getApiOrdersExport operation in EndpointsApi.
 */
export interface EndpointsApiGetApiOrdersExportRequest {
    readonly getApiOrdersExportRequest?: GetApiOrdersExportRequest
}

/**
 * Request parameters for getApiOrdersOrderId operation in EndpointsApi.
 */
export interface EndpointsApiGetApiOrdersOrderIdRequest {
    /**
     * The ID of the order.
     */
    readonly id: string

    readonly getApiOrdersOrderIdRequest?: GetApiOrdersOrderIdRequest
}

/**
 * Request parameters for getApiOrdersOrders operation in EndpointsApi.
 */
export interface EndpointsApiGetApiOrdersOrdersRequest {
    readonly getApiOrdersOrdersRequest?: GetApiOrdersOrdersRequest
}

/**
 * Request parameters for getApiOrdersStatusId operation in EndpointsApi.
 */
export interface EndpointsApiGetApiOrdersStatusIdRequest {
    /**
     * The ID of the status.
     */
    readonly id: string
}

/**
 * Request parameters for getApiPath operation in EndpointsApi.
 */
export interface EndpointsApiGetApiPathRequest {
    /**
     * 
     */
    readonly path: string
}

/**
 * Request parameters for getApiPromotionsCodeId operation in EndpointsApi.
 */
export interface EndpointsApiGetApiPromotionsCodeIdRequest {
    /**
     * The ID of the code.
     */
    readonly id: string

    readonly getApiPromotionsCodeIdRequest?: GetApiPromotionsCodeIdRequest
}

/**
 * Request parameters for getApiPromotionsCodes operation in EndpointsApi.
 */
export interface EndpointsApiGetApiPromotionsCodesRequest {
    readonly getApiPromotionsCodesRequest?: GetApiPromotionsCodesRequest
}

/**
 * Request parameters for getApiPromotionsOfferId operation in EndpointsApi.
 */
export interface EndpointsApiGetApiPromotionsOfferIdRequest {
    /**
     * The ID of the offer.
     */
    readonly id: string

    readonly getApiPromotionsOfferIdRequest?: GetApiPromotionsOfferIdRequest
}

/**
 * Request parameters for getApiPromotionsOffers operation in EndpointsApi.
 */
export interface EndpointsApiGetApiPromotionsOffersRequest {
    readonly getApiPromotionsOffersRequest?: GetApiPromotionsOffersRequest
}

/**
 * Request parameters for getApiSettingsCurrencies operation in EndpointsApi.
 */
export interface EndpointsApiGetApiSettingsCurrenciesRequest {
    readonly getApiSettingsCurrenciesRequest?: GetApiSettingsCurrenciesRequest
}

/**
 * Request parameters for getApiSettingsCurrencyId operation in EndpointsApi.
 */
export interface EndpointsApiGetApiSettingsCurrencyIdRequest {
    /**
     * The ID of the currency.
     */
    readonly id: string

    readonly getApiSettingsCurrencyIdRequest?: GetApiSettingsCurrencyIdRequest
}

/**
 * Request parameters for getApiSettingsPaymentModeId operation in EndpointsApi.
 */
export interface EndpointsApiGetApiSettingsPaymentModeIdRequest {
    /**
     * The ID of the payment mode.
     */
    readonly id: string

    readonly getApiSettingsPaymentModeIdRequest?: GetApiSettingsPaymentModeIdRequest
}

/**
 * Request parameters for getApiSettingsPaymentModes operation in EndpointsApi.
 */
export interface EndpointsApiGetApiSettingsPaymentModesRequest {
    readonly getApiSettingsPaymentModesRequest?: GetApiSettingsPaymentModesRequest
}

/**
 * Request parameters for getApiShippingFlatRateId operation in EndpointsApi.
 */
export interface EndpointsApiGetApiShippingFlatRateIdRequest {
    /**
     * The ID of the flat rate.
     */
    readonly id: string

    readonly getApiShippingFlatRateIdRequest?: GetApiShippingFlatRateIdRequest
}

/**
 * Request parameters for getApiShippingFlatRates operation in EndpointsApi.
 */
export interface EndpointsApiGetApiShippingFlatRatesRequest {
    readonly getApiShippingFlatRatesRequest?: GetApiShippingFlatRatesRequest
}

/**
 * Request parameters for getApiShippingShippingDetailUsername operation in EndpointsApi.
 */
export interface EndpointsApiGetApiShippingShippingDetailUsernameRequest {
    /**
     * 
     */
    readonly username: string

    readonly getApiShippingShippingDetailUsernameRequest?: GetApiShippingShippingDetailUsernameRequest
}

/**
 * Request parameters for getApiShippingShippingDetails operation in EndpointsApi.
 */
export interface EndpointsApiGetApiShippingShippingDetailsRequest {
    readonly getApiShippingShippingDetailsRequest?: GetApiShippingShippingDetailsRequest
}

/**
 * Request parameters for getApiShippingShippingServiceId operation in EndpointsApi.
 */
export interface EndpointsApiGetApiShippingShippingServiceIdRequest {
    /**
     * The ID of the shipping service.
     */
    readonly id: string

    readonly getApiShippingShippingServiceIdRequest?: GetApiShippingShippingServiceIdRequest
}

/**
 * Request parameters for getApiShippingShippingServices operation in EndpointsApi.
 */
export interface EndpointsApiGetApiShippingShippingServicesRequest {
    readonly getApiShippingShippingServicesRequest?: GetApiShippingShippingServicesRequest
}

/**
 * Request parameters for getApiUserPermissions operation in EndpointsApi.
 */
export interface EndpointsApiGetApiUserPermissionsRequest {
    readonly getApiUserPermissionsRequest?: GetApiUserPermissionsRequest
}

/**
 * Request parameters for getApiUserPermissionsRole operation in EndpointsApi.
 */
export interface EndpointsApiGetApiUserPermissionsRoleRequest {
    /**
     * 
     */
    readonly role: string

    readonly getApiUserPermissionsRoleRequest?: GetApiUserPermissionsRoleRequest
}

/**
 * Request parameters for getFrontBannerId operation in EndpointsApi.
 */
export interface EndpointsApiGetFrontBannerIdRequest {
    /**
     * The ID of the banner.
     */
    readonly id: string

    readonly getFrontBannerIdRequest?: GetFrontBannerIdRequest
}

/**
 * Request parameters for getFrontBanners operation in EndpointsApi.
 */
export interface EndpointsApiGetFrontBannersRequest {
    readonly getFrontBannersRequest?: GetFrontBannersRequest
}

/**
 * Request parameters for getFrontBrandId operation in EndpointsApi.
 */
export interface EndpointsApiGetFrontBrandIdRequest {
    /**
     * The ID of the brand.
     */
    readonly id: string

    readonly getFrontBrandIdRequest?: GetFrontBrandIdRequest
}

/**
 * Request parameters for getFrontBrands operation in EndpointsApi.
 */
export interface EndpointsApiGetFrontBrandsRequest {
    readonly getFrontBrandsRequest?: GetFrontBrandsRequest
}

/**
 * Request parameters for getFrontCategories operation in EndpointsApi.
 */
export interface EndpointsApiGetFrontCategoriesRequest {
    readonly getFrontCategoriesRequest?: GetFrontCategoriesRequest
}

/**
 * Request parameters for getFrontCategoryId operation in EndpointsApi.
 */
export interface EndpointsApiGetFrontCategoryIdRequest {
    /**
     * The ID of the category.
     */
    readonly id: string

    readonly getFrontCategoryIdRequest?: GetFrontCategoryIdRequest
}

/**
 * Request parameters for getFrontFooterId operation in EndpointsApi.
 */
export interface EndpointsApiGetFrontFooterIdRequest {
    /**
     * The ID of the footer.
     */
    readonly id: string

    readonly getFrontFooterIdRequest?: GetFrontFooterIdRequest
}

/**
 * Request parameters for getFrontFooters operation in EndpointsApi.
 */
export interface EndpointsApiGetFrontFootersRequest {
    readonly getFrontFootersRequest?: GetFrontFootersRequest
}

/**
 * Request parameters for getFrontMenuId operation in EndpointsApi.
 */
export interface EndpointsApiGetFrontMenuIdRequest {
    /**
     * The ID of the menu.
     */
    readonly id: string

    readonly getFrontMenuIdRequest?: GetFrontMenuIdRequest
}

/**
 * Request parameters for getFrontMenus operation in EndpointsApi.
 */
export interface EndpointsApiGetFrontMenusRequest {
    readonly getFrontMenusRequest?: GetFrontMenusRequest
}

/**
 * Request parameters for getFrontProductId operation in EndpointsApi.
 */
export interface EndpointsApiGetFrontProductIdRequest {
    /**
     * The ID of the product.
     */
    readonly id: string

    readonly getFrontProductIdRequest?: GetFrontProductIdRequest
}

/**
 * Request parameters for getFrontProducts operation in EndpointsApi.
 */
export interface EndpointsApiGetFrontProductsRequest {
    readonly getFrontProductsRequest?: GetFrontProductsRequest
}

/**
 * Request parameters for getFrontSeoId operation in EndpointsApi.
 */
export interface EndpointsApiGetFrontSeoIdRequest {
    /**
     * The ID of the seo.
     */
    readonly id: string

    readonly getFrontSeoIdRequest?: GetFrontSeoIdRequest
}

/**
 * Request parameters for getFrontSeos operation in EndpointsApi.
 */
export interface EndpointsApiGetFrontSeosRequest {
    readonly getFrontMenuIdRequest?: GetFrontMenuIdRequest
}

/**
 * Request parameters for getFrontVerifyResetPasswordToken operation in EndpointsApi.
 */
export interface EndpointsApiGetFrontVerifyResetPasswordTokenRequest {
    /**
     * 
     */
    readonly token: string
}

/**
 * Request parameters for getFrontVerifyToken operation in EndpointsApi.
 */
export interface EndpointsApiGetFrontVerifyTokenRequest {
    /**
     * 
     */
    readonly token: string
}

/**
 * Request parameters for getV1BannerId operation in EndpointsApi.
 */
export interface EndpointsApiGetV1BannerIdRequest {
    /**
     * The ID of the banner.
     */
    readonly id: string

    readonly getV1BannersRequest?: GetV1BannersRequest
}

/**
 * Request parameters for getV1Banners operation in EndpointsApi.
 */
export interface EndpointsApiGetV1BannersRequest {
    readonly getV1BannersRequest?: GetV1BannersRequest
}

/**
 * Request parameters for getV1CountriesCountryId operation in EndpointsApi.
 */
export interface EndpointsApiGetV1CountriesCountryIdRequest {
    /**
     * The ID of the country.
     */
    readonly id: string
}

/**
 * Request parameters for getV1FooterId operation in EndpointsApi.
 */
export interface EndpointsApiGetV1FooterIdRequest {
    /**
     * The ID of the footer.
     */
    readonly id: string

    readonly getV1FooterIdRequest?: GetV1FooterIdRequest
}

/**
 * Request parameters for getV1Footers operation in EndpointsApi.
 */
export interface EndpointsApiGetV1FootersRequest {
    readonly getV1FootersRequest?: GetV1FootersRequest
}

/**
 * Request parameters for getV1MenuId operation in EndpointsApi.
 */
export interface EndpointsApiGetV1MenuIdRequest {
    /**
     * The ID of the menu.
     */
    readonly id: string

    readonly getV1MenuIdRequest?: GetV1MenuIdRequest
}

/**
 * Request parameters for getV1Menus operation in EndpointsApi.
 */
export interface EndpointsApiGetV1MenusRequest {
    readonly getV1MenusRequest?: GetV1MenusRequest
}

/**
 * Request parameters for getV1VerifyResetPasswordToken operation in EndpointsApi.
 */
export interface EndpointsApiGetV1VerifyResetPasswordTokenRequest {
    /**
     * 
     */
    readonly token: string
}

/**
 * Request parameters for getV1VerifyToken operation in EndpointsApi.
 */
export interface EndpointsApiGetV1VerifyTokenRequest {
    /**
     * 
     */
    readonly token: string
}

/**
 * Request parameters for patchApiShippingShippingServiceIdActivate operation in EndpointsApi.
 */
export interface EndpointsApiPatchApiShippingShippingServiceIdActivateRequest {
    /**
     * The ID of the shipping service.
     */
    readonly id: string
}

/**
 * Request parameters for postApiAccountsUserCreate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiAccountsUserCreateRequest {
    readonly postApiAccountsUserCreateRequest: PostApiAccountsUserCreateRequest
}

/**
 * Request parameters for postApiAccountsUserDelete operation in EndpointsApi.
 */
export interface EndpointsApiPostApiAccountsUserDeleteRequest {
    readonly postApiAccountsUserDeleteRequest: PostApiAccountsUserDeleteRequest
}

/**
 * Request parameters for postApiAccountsUserUpdateId operation in EndpointsApi.
 */
export interface EndpointsApiPostApiAccountsUserUpdateIdRequest {
    /**
     * The ID of the update.
     */
    readonly id: string

    readonly postApiAccountsUserUpdateIdRequest: PostApiAccountsUserUpdateIdRequest
}

/**
 * Request parameters for postApiAmazonSettingsUpdate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiAmazonSettingsUpdateRequest {
    readonly postApiAmazonSettingsUpdateRequest?: PostApiAmazonSettingsUpdateRequest
}

/**
 * Request parameters for postApiAramexSettingsUpdate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiAramexSettingsUpdateRequest {
    readonly postApiAramexSettingsUpdateRequest?: PostApiAramexSettingsUpdateRequest
}

/**
 * Request parameters for postApiAttributesSeoCreate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiAttributesSeoCreateRequest {
    readonly postApiAttributesSeoCreateRequest: PostApiAttributesSeoCreateRequest
}

/**
 * Request parameters for postApiAttributesSeoDelete operation in EndpointsApi.
 */
export interface EndpointsApiPostApiAttributesSeoDeleteRequest {
    readonly postV1FooterDeleteRequest?: PostV1FooterDeleteRequest
}

/**
 * Request parameters for postApiAttributesSeoUpdateId operation in EndpointsApi.
 */
export interface EndpointsApiPostApiAttributesSeoUpdateIdRequest {
    /**
     * The ID of the update.
     */
    readonly id: string

    readonly postApiAttributesSeoUpdateIdRequest: PostApiAttributesSeoUpdateIdRequest
}

/**
 * Request parameters for postApiBillingBillingDetailsCreate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiBillingBillingDetailsCreateRequest {
    readonly postApiBillingBillingDetailsCreateRequest: PostApiBillingBillingDetailsCreateRequest
}

/**
 * Request parameters for postApiBillingBillingDetailsDelete operation in EndpointsApi.
 */
export interface EndpointsApiPostApiBillingBillingDetailsDeleteRequest {
    readonly postApiBillingBillingDetailsDeleteRequest: PostApiBillingBillingDetailsDeleteRequest
}

/**
 * Request parameters for postApiBillingBillingDetailsUpdate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiBillingBillingDetailsUpdateRequest {
    readonly postApiBillingBillingDetailsUpdateRequest: PostApiBillingBillingDetailsUpdateRequest
}

/**
 * Request parameters for postApiBillingCreditCreate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiBillingCreditCreateRequest {
    readonly postApiBillingCreditCreateRequest: PostApiBillingCreditCreateRequest
}

/**
 * Request parameters for postApiBillingCreditDelete operation in EndpointsApi.
 */
export interface EndpointsApiPostApiBillingCreditDeleteRequest {
    readonly postApiBillingCreditDeleteRequest: PostApiBillingCreditDeleteRequest
}

/**
 * Request parameters for postApiBillingCreditUpdate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiBillingCreditUpdateRequest {
    readonly postApiBillingCreditUpdateRequest: PostApiBillingCreditUpdateRequest
}

/**
 * Request parameters for postApiCartAdd operation in EndpointsApi.
 */
export interface EndpointsApiPostApiCartAddRequest {
    readonly postApiCartAddRequest?: PostApiCartAddRequest
}

/**
 * Request parameters for postApiCatalogAttributeCreate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiCatalogAttributeCreateRequest {
    readonly postApiCatalogAttributeCreateRequest: PostApiCatalogAttributeCreateRequest
}

/**
 * Request parameters for postApiCatalogAttributeDelete operation in EndpointsApi.
 */
export interface EndpointsApiPostApiCatalogAttributeDeleteRequest {
    readonly postApiCatalogAttributeDeleteRequest: PostApiCatalogAttributeDeleteRequest
}

/**
 * Request parameters for postApiCatalogAttributeUpdate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiCatalogAttributeUpdateRequest {
    readonly postApiCatalogAttributeUpdateRequest: PostApiCatalogAttributeUpdateRequest
}

/**
 * Request parameters for postApiCatalogAttributeValueCreate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiCatalogAttributeValueCreateRequest {
    readonly postApiCatalogAttributeValueCreateRequest: PostApiCatalogAttributeValueCreateRequest
}

/**
 * Request parameters for postApiCatalogAttributeValueDelete operation in EndpointsApi.
 */
export interface EndpointsApiPostApiCatalogAttributeValueDeleteRequest {
    readonly postApiCatalogAttributeValueDeleteRequest: PostApiCatalogAttributeValueDeleteRequest
}

/**
 * Request parameters for postApiCatalogAttributeValueUpdate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiCatalogAttributeValueUpdateRequest {
    readonly postApiCatalogAttributeValueUpdateRequest: PostApiCatalogAttributeValueUpdateRequest
}

/**
 * Request parameters for postApiCatalogBrandCreate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiCatalogBrandCreateRequest {
    readonly postApiCatalogBrandCreateRequest: PostApiCatalogBrandCreateRequest
}

/**
 * Request parameters for postApiCatalogBrandDelete operation in EndpointsApi.
 */
export interface EndpointsApiPostApiCatalogBrandDeleteRequest {
    readonly postApiCatalogBrandDeleteRequest: PostApiCatalogBrandDeleteRequest
}

/**
 * Request parameters for postApiCatalogBrandUpdate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiCatalogBrandUpdateRequest {
    readonly postApiCatalogBrandUpdateRequest: PostApiCatalogBrandUpdateRequest
}

/**
 * Request parameters for postApiCatalogCategoryCreate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiCatalogCategoryCreateRequest {
    readonly postApiCatalogCategoryCreateRequest?: PostApiCatalogCategoryCreateRequest
}

/**
 * Request parameters for postApiCatalogCategoryDelete operation in EndpointsApi.
 */
export interface EndpointsApiPostApiCatalogCategoryDeleteRequest {
    readonly postApiCatalogCategoryDeleteRequest: PostApiCatalogCategoryDeleteRequest
}

/**
 * Request parameters for postApiCatalogCategoryUpdate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiCatalogCategoryUpdateRequest {
    readonly postApiCatalogCategoryUpdateRequest: PostApiCatalogCategoryUpdateRequest
}

/**
 * Request parameters for postApiCatalogProductAttributesCreate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiCatalogProductAttributesCreateRequest {
    readonly postApiCatalogProductAttributesCreateRequest: PostApiCatalogProductAttributesCreateRequest
}

/**
 * Request parameters for postApiCatalogProductAttributesDelete operation in EndpointsApi.
 */
export interface EndpointsApiPostApiCatalogProductAttributesDeleteRequest {
    readonly postApiCatalogProductAttributesDeleteRequest: PostApiCatalogProductAttributesDeleteRequest
}

/**
 * Request parameters for postApiCatalogProductAttributesUpdate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiCatalogProductAttributesUpdateRequest {
    readonly postApiCatalogProductAttributesUpdateRequest: PostApiCatalogProductAttributesUpdateRequest
}

/**
 * Request parameters for postApiCatalogProductCreate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiCatalogProductCreateRequest {
    readonly postApiCatalogProductCreateRequest: PostApiCatalogProductCreateRequest
}

/**
 * Request parameters for postApiCatalogProductDelete operation in EndpointsApi.
 */
export interface EndpointsApiPostApiCatalogProductDeleteRequest {
    readonly postApiCatalogProductDeleteRequest: PostApiCatalogProductDeleteRequest
}

/**
 * Request parameters for postApiCatalogProductUpdate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiCatalogProductUpdateRequest {
    readonly postApiCatalogProductUpdateRequest: PostApiCatalogProductUpdateRequest
}

/**
 * Request parameters for postApiCatalogStoreCreate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiCatalogStoreCreateRequest {
    readonly postApiCatalogStoreCreateRequest: PostApiCatalogStoreCreateRequest
}

/**
 * Request parameters for postApiCatalogStoreDelete operation in EndpointsApi.
 */
export interface EndpointsApiPostApiCatalogStoreDeleteRequest {
    readonly postApiCatalogStoreDeleteRequest: PostApiCatalogStoreDeleteRequest
}

/**
 * Request parameters for postApiCatalogStoreUpdate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiCatalogStoreUpdateRequest {
    readonly postApiCatalogStoreUpdateRequest: PostApiCatalogStoreUpdateRequest
}

/**
 * Request parameters for postApiCatalogTagCreate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiCatalogTagCreateRequest {
    readonly postApiCatalogTagCreateRequest: PostApiCatalogTagCreateRequest
}

/**
 * Request parameters for postApiCatalogTagDelete operation in EndpointsApi.
 */
export interface EndpointsApiPostApiCatalogTagDeleteRequest {
    readonly postApiCatalogTagDeleteRequest: PostApiCatalogTagDeleteRequest
}

/**
 * Request parameters for postApiCatalogTagUpdate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiCatalogTagUpdateRequest {
    readonly postApiCatalogTagUpdateRequest: PostApiCatalogTagUpdateRequest
}

/**
 * Request parameters for postApiCommunicationsNewsletterCreate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiCommunicationsNewsletterCreateRequest {
    readonly postApiCommunicationsNewsletterCreateRequest: PostApiCommunicationsNewsletterCreateRequest
}

/**
 * Request parameters for postApiCommunicationsNewsletterDelete operation in EndpointsApi.
 */
export interface EndpointsApiPostApiCommunicationsNewsletterDeleteRequest {
    readonly postApiCommunicationsNewsletterDeleteRequest: PostApiCommunicationsNewsletterDeleteRequest
}

/**
 * Request parameters for postApiCommunicationsNewsletterUpdate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiCommunicationsNewsletterUpdateRequest {
    readonly postApiCommunicationsNewsletterUpdateRequest: PostApiCommunicationsNewsletterUpdateRequest
}

/**
 * Request parameters for postApiCommunicationsSubscriberCreate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiCommunicationsSubscriberCreateRequest {
    readonly postApiCommunicationsSubscriberCreateRequest: PostApiCommunicationsSubscriberCreateRequest
}

/**
 * Request parameters for postApiCommunicationsSubscriberDelete operation in EndpointsApi.
 */
export interface EndpointsApiPostApiCommunicationsSubscriberDeleteRequest {
    readonly postApiAccountsUserDeleteRequest: PostApiAccountsUserDeleteRequest
}

/**
 * Request parameters for postApiCommunicationsSubscriberUpdate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiCommunicationsSubscriberUpdateRequest {
    readonly postApiCommunicationsSubscriberUpdateRequest: PostApiCommunicationsSubscriberUpdateRequest
}

/**
 * Request parameters for postApiContentPageCreate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiContentPageCreateRequest {
    readonly postApiContentPageCreateRequest: PostApiContentPageCreateRequest
}

/**
 * Request parameters for postApiContentPageDelete operation in EndpointsApi.
 */
export interface EndpointsApiPostApiContentPageDeleteRequest {
    readonly postApiContentPageDeleteRequest: PostApiContentPageDeleteRequest
}

/**
 * Request parameters for postApiContentPageUpdate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiContentPageUpdateRequest {
    readonly postApiContentPageUpdateRequest: PostApiContentPageUpdateRequest
}

/**
 * Request parameters for postApiInstashopSettingsUpdate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiInstashopSettingsUpdateRequest {
    readonly postApiInstashopSettingsUpdateRequest?: PostApiInstashopSettingsUpdateRequest
}

/**
 * Request parameters for postApiInvoicesSettingsCreate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiInvoicesSettingsCreateRequest {
    readonly postApiInvoicesSettingsCreateRequest: PostApiInvoicesSettingsCreateRequest
}

/**
 * Request parameters for postApiInvoicesSettingsDelete operation in EndpointsApi.
 */
export interface EndpointsApiPostApiInvoicesSettingsDeleteRequest {
    readonly postApiInvoicesSettingsDeleteRequest: PostApiInvoicesSettingsDeleteRequest
}

/**
 * Request parameters for postApiInvoicesSettingsUpdate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiInvoicesSettingsUpdateRequest {
    readonly postApiInvoicesSettingsUpdateRequest: PostApiInvoicesSettingsUpdateRequest
}

/**
 * Request parameters for postApiMediaFileDelete operation in EndpointsApi.
 */
export interface EndpointsApiPostApiMediaFileDeleteRequest {
    readonly postApiMediaFileDeleteRequest: PostApiMediaFileDeleteRequest
}

/**
 * Request parameters for postApiMediaFileUpdateId operation in EndpointsApi.
 */
export interface EndpointsApiPostApiMediaFileUpdateIdRequest {
    /**
     * The ID of the update.
     */
    readonly id: string

    readonly postApiMediaFileUpdateIdRequest?: PostApiMediaFileUpdateIdRequest
}

/**
 * Request parameters for postApiMediaFileUpload operation in EndpointsApi.
 */
export interface EndpointsApiPostApiMediaFileUploadRequest {
    readonly postApiMediaFileUploadRequest: PostApiMediaFileUploadRequest
}

/**
 * Request parameters for postApiMediaSettingsSizeUpdateId operation in EndpointsApi.
 */
export interface EndpointsApiPostApiMediaSettingsSizeUpdateIdRequest {
    /**
     * The ID of the update.
     */
    readonly id: string
}

/**
 * Request parameters for postApiNoonSettingsUpdate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiNoonSettingsUpdateRequest {
    readonly postApiNoonSettingsUpdateRequest?: PostApiNoonSettingsUpdateRequest
}

/**
 * Request parameters for postApiOrdersOrderCreate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiOrdersOrderCreateRequest {
    readonly postApiOrdersOrderCreateRequest: PostApiOrdersOrderCreateRequest
}

/**
 * Request parameters for postApiOrdersOrderDelete operation in EndpointsApi.
 */
export interface EndpointsApiPostApiOrdersOrderDeleteRequest {
    readonly postApiOrdersOrderDeleteRequest: PostApiOrdersOrderDeleteRequest
}

/**
 * Request parameters for postApiOrdersOrderUpdateId operation in EndpointsApi.
 */
export interface EndpointsApiPostApiOrdersOrderUpdateIdRequest {
    /**
     * The ID of the update.
     */
    readonly id: string

    readonly postApiOrdersOrderUpdateIdRequest: PostApiOrdersOrderUpdateIdRequest
}

/**
 * Request parameters for postApiOrdersStatusCreate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiOrdersStatusCreateRequest {
    readonly postApiOrdersStatusCreateRequest: PostApiOrdersStatusCreateRequest
}

/**
 * Request parameters for postApiOrdersStatusDelete operation in EndpointsApi.
 */
export interface EndpointsApiPostApiOrdersStatusDeleteRequest {
    readonly postApiOrdersStatusDeleteRequest: PostApiOrdersStatusDeleteRequest
}

/**
 * Request parameters for postApiOrdersStatusUpdate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiOrdersStatusUpdateRequest {
    readonly postApiOrdersStatusUpdateRequest: PostApiOrdersStatusUpdateRequest
}

/**
 * Request parameters for postApiPaymentInitiate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiPaymentInitiateRequest {
    readonly postApiPaymentInitiateRequest: PostApiPaymentInitiateRequest
}

/**
 * Request parameters for postApiPromotionsCodeCreate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiPromotionsCodeCreateRequest {
    readonly postApiPromotionsCodeCreateRequest: PostApiPromotionsCodeCreateRequest
}

/**
 * Request parameters for postApiPromotionsCodeDelete operation in EndpointsApi.
 */
export interface EndpointsApiPostApiPromotionsCodeDeleteRequest {
    readonly postApiPromotionsCodeDeleteRequest: PostApiPromotionsCodeDeleteRequest
}

/**
 * Request parameters for postApiPromotionsCodeUpdateId operation in EndpointsApi.
 */
export interface EndpointsApiPostApiPromotionsCodeUpdateIdRequest {
    /**
     * The ID of the update.
     */
    readonly id: string

    readonly postApiPromotionsCodeUpdateIdRequest: PostApiPromotionsCodeUpdateIdRequest
}

/**
 * Request parameters for postApiPromotionsOfferCreate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiPromotionsOfferCreateRequest {
    readonly postApiPromotionsOfferCreateRequest: PostApiPromotionsOfferCreateRequest
}

/**
 * Request parameters for postApiPromotionsOfferDelete operation in EndpointsApi.
 */
export interface EndpointsApiPostApiPromotionsOfferDeleteRequest {
    readonly postApiCatalogProductDeleteRequest: PostApiCatalogProductDeleteRequest
}

/**
 * Request parameters for postApiPromotionsOfferUpdateId operation in EndpointsApi.
 */
export interface EndpointsApiPostApiPromotionsOfferUpdateIdRequest {
    /**
     * The ID of the update.
     */
    readonly id: string

    readonly postApiPromotionsOfferUpdateIdRequest: PostApiPromotionsOfferUpdateIdRequest
}

/**
 * Request parameters for postApiSettingsCcavenueSettingsUpdate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiSettingsCcavenueSettingsUpdateRequest {
    readonly postApiSettingsCcavenueSettingsUpdateRequest: PostApiSettingsCcavenueSettingsUpdateRequest
}

/**
 * Request parameters for postApiSettingsCurrencyCreate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiSettingsCurrencyCreateRequest {
    readonly postApiSettingsCurrencyCreateRequest: PostApiSettingsCurrencyCreateRequest
}

/**
 * Request parameters for postApiSettingsCurrencyDelete operation in EndpointsApi.
 */
export interface EndpointsApiPostApiSettingsCurrencyDeleteRequest {
    readonly postApiCatalogTagDeleteRequest: PostApiCatalogTagDeleteRequest
}

/**
 * Request parameters for postApiSettingsCurrencyUpdate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiSettingsCurrencyUpdateRequest {
    readonly postApiSettingsCurrencyUpdateRequest: PostApiSettingsCurrencyUpdateRequest
}

/**
 * Request parameters for postApiSettingsNetworkSettingsUpdate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiSettingsNetworkSettingsUpdateRequest {
    readonly postApiSettingsNetworkSettingsUpdateRequest: PostApiSettingsNetworkSettingsUpdateRequest
}

/**
 * Request parameters for postApiSettingsOnlinePaymentCardMethodActivateId operation in EndpointsApi.
 */
export interface EndpointsApiPostApiSettingsOnlinePaymentCardMethodActivateIdRequest {
    /**
     * The ID of the activate.
     */
    readonly id: string

    readonly postApiSettingsOnlinePaymentGatewayActivateIdRequest: PostApiSettingsOnlinePaymentGatewayActivateIdRequest
}

/**
 * Request parameters for postApiSettingsOnlinePaymentGatewayActivateId operation in EndpointsApi.
 */
export interface EndpointsApiPostApiSettingsOnlinePaymentGatewayActivateIdRequest {
    /**
     * The ID of the activate.
     */
    readonly id: string

    readonly postApiSettingsOnlinePaymentGatewayActivateIdRequest: PostApiSettingsOnlinePaymentGatewayActivateIdRequest
}

/**
 * Request parameters for postApiSettingsPayfortSettingsUpdate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiSettingsPayfortSettingsUpdateRequest {
    readonly postApiSettingsPayfortSettingsUpdateRequest: PostApiSettingsPayfortSettingsUpdateRequest
}

/**
 * Request parameters for postApiSettingsPaymentModeCreate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiSettingsPaymentModeCreateRequest {
    readonly postApiSettingsPaymentModeCreateRequest: PostApiSettingsPaymentModeCreateRequest
}

/**
 * Request parameters for postApiSettingsPaymentModeDelete operation in EndpointsApi.
 */
export interface EndpointsApiPostApiSettingsPaymentModeDeleteRequest {
    readonly postApiSettingsPaymentModeDeleteRequest: PostApiSettingsPaymentModeDeleteRequest
}

/**
 * Request parameters for postApiSettingsPaymentModeUpdate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiSettingsPaymentModeUpdateRequest {
    readonly postApiSettingsPaymentModeUpdateRequest: PostApiSettingsPaymentModeUpdateRequest
}

/**
 * Request parameters for postApiSettingsPaypalSettingsUpdate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiSettingsPaypalSettingsUpdateRequest {
    readonly postApiSettingsPaypalSettingsUpdateRequest: PostApiSettingsPaypalSettingsUpdateRequest
}

/**
 * Request parameters for postApiSettingsStripeSettingsUpdate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiSettingsStripeSettingsUpdateRequest {
    readonly postApiSettingsStripeSettingsUpdateRequest?: PostApiSettingsStripeSettingsUpdateRequest
}

/**
 * Request parameters for postApiSettingsTabbySettingsUpdate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiSettingsTabbySettingsUpdateRequest {
    readonly postApiSettingsTabbySettingsUpdateRequest: PostApiSettingsTabbySettingsUpdateRequest
}

/**
 * Request parameters for postApiSettingsTamaraSettingsUpdate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiSettingsTamaraSettingsUpdateRequest {
    readonly postApiSettingsTamaraSettingsUpdateRequest: PostApiSettingsTamaraSettingsUpdateRequest
}

/**
 * Request parameters for postApiShippingCostCalculator operation in EndpointsApi.
 */
export interface EndpointsApiPostApiShippingCostCalculatorRequest {
    readonly postApiShippingCostCalculatorRequest: PostApiShippingCostCalculatorRequest
}

/**
 * Request parameters for postApiShippingFlatRateCreate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiShippingFlatRateCreateRequest {
    readonly postApiShippingFlatRateCreateRequest: PostApiShippingFlatRateCreateRequest
}

/**
 * Request parameters for postApiShippingFlatRateDelete operation in EndpointsApi.
 */
export interface EndpointsApiPostApiShippingFlatRateDeleteRequest {
    readonly postApiCatalogCategoryDeleteRequest: PostApiCatalogCategoryDeleteRequest
}

/**
 * Request parameters for postApiShippingFlatRateUpdate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiShippingFlatRateUpdateRequest {
    readonly postApiShippingFlatRateUpdateRequest: PostApiShippingFlatRateUpdateRequest
}

/**
 * Request parameters for postApiShippingShippingDetailsCreate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiShippingShippingDetailsCreateRequest {
    readonly postApiShippingShippingDetailsCreateRequest: PostApiShippingShippingDetailsCreateRequest
}

/**
 * Request parameters for postApiShippingShippingDetailsDelete operation in EndpointsApi.
 */
export interface EndpointsApiPostApiShippingShippingDetailsDeleteRequest {
    readonly postApiShippingShippingDetailsDeleteRequest: PostApiShippingShippingDetailsDeleteRequest
}

/**
 * Request parameters for postApiShippingShippingDetailsUpdate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiShippingShippingDetailsUpdateRequest {
    readonly postApiShippingShippingDetailsUpdateRequest: PostApiShippingShippingDetailsUpdateRequest
}

/**
 * Request parameters for postApiShippingShippingServiceCreate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiShippingShippingServiceCreateRequest {
    readonly postApiShippingShippingServiceCreateRequest: PostApiShippingShippingServiceCreateRequest
}

/**
 * Request parameters for postApiShippingShippingServiceDelete operation in EndpointsApi.
 */
export interface EndpointsApiPostApiShippingShippingServiceDeleteRequest {
    readonly postApiShippingShippingServiceDeleteRequest: PostApiShippingShippingServiceDeleteRequest
}

/**
 * Request parameters for postApiShippingShippingServiceUpdate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiShippingShippingServiceUpdateRequest {
    readonly postApiShippingShippingServiceUpdateRequest: PostApiShippingShippingServiceUpdateRequest
}

/**
 * Request parameters for postApiThemeCreate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiThemeCreateRequest {
    readonly name: string
    readonly path?: string
    readonly settings: string
    readonly is_active?: boolean
}

/**
 * Request parameters for postApiThemeColorUpdateId operation in EndpointsApi.
 */
export interface EndpointsApiPostApiThemeColorUpdateIdRequest {
    /**
     * The ID of the theme to update.
     */
    readonly id: number

    readonly postApiThemeColorUpdateIdRequest?: PostApiThemeColorUpdateIdRequest
}

/**
 * Request parameters for postApiThemeActivateId operation in EndpointsApi.
 */
export interface EndpointsApiPostApiThemeActivateIdRequest {
    /**
     * The ID of the activate.
     */
    readonly id: string

    readonly getApiSettingsCurrencyIdRequest?: GetApiSettingsCurrencyIdRequest
}

/**
 * Request parameters for postApiThemeSettingsUpdateId operation in EndpointsApi.
 */
export interface EndpointsApiPostApiThemeSettingsUpdateIdRequest {
    /**
     * The ID of the update.
     */
    readonly id: string

    readonly postApiThemeSettingsUpdateIdRequest?: PostApiThemeSettingsUpdateIdRequest
}

/**
 * Request parameters for postApiThemeUpload operation in EndpointsApi.
 */
export interface EndpointsApiPostApiThemeUploadRequest {
    /**
     * Must be a file.
     */
    readonly themeZip: File

    /**
     * Must not be greater than 255 characters.
     */
    readonly name?: string
}

/**
 * Request parameters for postApiUserPermissionsUpdate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiUserPermissionsUpdateRequest {
    readonly postApiUserPermissionsUpdateRequest: PostApiUserPermissionsUpdateRequest
}

/**
 * Request parameters for postApiUserRoleCreate operation in EndpointsApi.
 */
export interface EndpointsApiPostApiUserRoleCreateRequest {
    readonly postApiUserRoleCreateRequest: PostApiUserRoleCreateRequest
}

/**
 * Request parameters for postApiUserRoleDelete operation in EndpointsApi.
 */
export interface EndpointsApiPostApiUserRoleDeleteRequest {
    readonly postApiUserRoleDeleteRequest: PostApiUserRoleDeleteRequest
}

/**
 * Request parameters for postApiUserRoleUpdateRole operation in EndpointsApi.
 */
export interface EndpointsApiPostApiUserRoleUpdateRoleRequest {
    /**
     * 
     */
    readonly role: string

    readonly postApiUserRoleUpdateRoleRequest: PostApiUserRoleUpdateRoleRequest
}

/**
 * Request parameters for postFrontProductRateId operation in EndpointsApi.
 */
export interface EndpointsApiPostFrontProductRateIdRequest {
    /**
     * The ID of the rate.
     */
    readonly id: string

    readonly postFrontProductRateIdRequest?: PostFrontProductRateIdRequest
}

/**
 * Request parameters for postV1BannerCreate operation in EndpointsApi.
 */
export interface EndpointsApiPostV1BannerCreateRequest {
    readonly postV1BannerCreateRequest: PostV1BannerCreateRequest
}

/**
 * Request parameters for postV1BannerDelete operation in EndpointsApi.
 */
export interface EndpointsApiPostV1BannerDeleteRequest {
    readonly postV1BannerDeleteRequest?: PostV1BannerDeleteRequest
}

/**
 * Request parameters for postV1BannerUpdate operation in EndpointsApi.
 */
export interface EndpointsApiPostV1BannerUpdateRequest {
    readonly postV1BannerUpdateRequest: PostV1BannerUpdateRequest
}

/**
 * Request parameters for postV1FooterCreate operation in EndpointsApi.
 */
export interface EndpointsApiPostV1FooterCreateRequest {
    readonly postV1FooterCreateRequest: PostV1FooterCreateRequest
}

/**
 * Request parameters for postV1FooterDelete operation in EndpointsApi.
 */
export interface EndpointsApiPostV1FooterDeleteRequest {
    readonly postV1FooterDeleteRequest?: PostV1FooterDeleteRequest
}

/**
 * Request parameters for postV1FooterUpdate operation in EndpointsApi.
 */
export interface EndpointsApiPostV1FooterUpdateRequest {
    readonly postV1FooterUpdateRequest: PostV1FooterUpdateRequest
}

/**
 * Request parameters for postV1MenuCreate operation in EndpointsApi.
 */
export interface EndpointsApiPostV1MenuCreateRequest {
    readonly postV1MenuCreateRequest: PostV1MenuCreateRequest
}

/**
 * Request parameters for postV1MenuDelete operation in EndpointsApi.
 */
export interface EndpointsApiPostV1MenuDeleteRequest {
    readonly postV1MenuDeleteRequest?: PostV1MenuDeleteRequest
}

/**
 * Request parameters for postV1MenuUpdateId operation in EndpointsApi.
 */
export interface EndpointsApiPostV1MenuUpdateIdRequest {
    /**
     * The ID of the update.
     */
    readonly id: string

    readonly postV1MenuUpdateIdRequest: PostV1MenuUpdateIdRequest
}

/**
 * Request parameters for postV1NavbarModeUpdate operation in EndpointsApi.
 */
export interface EndpointsApiPostV1NavbarModeUpdateRequest {
    readonly postV1NavbarModeUpdateRequest: PostV1NavbarModeUpdateRequest
}

/**
 * Request parameters for putApiCartItemsCartItemId operation in EndpointsApi.
 */
export interface EndpointsApiPutApiCartItemsCartItemIdRequest {
    /**
     * 
     */
    readonly cartItemId: string

    readonly putApiCartItemsCartItemIdRequest: PutApiCartItemsCartItemIdRequest
}

/**
 * EndpointsApi - object-oriented interface
 */
export class EndpointsApi extends BaseAPI {
    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteApiCartClear(options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).deleteApiCartClear(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiDeleteApiCartItemsCartItemIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteApiCartItemsCartItemId(requestParameters: EndpointsApiDeleteApiCartItemsCartItemIdRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).deleteApiCartItemsCartItemId(requestParameters.cartItemId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Execute the job.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public executeTheJob(options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).executeTheJob(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiAccountsDebugAuth(options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiAccountsDebugAuth(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetApiAdminCartsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiAdminCarts(requestParameters: EndpointsApiGetApiAdminCartsRequest = {}, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiAdminCarts(requestParameters.getApiAdminCartsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiAmazonSettings(options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiAmazonSettings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiAramexSettings(options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiAramexSettings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetApiAttributesSeoIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiAttributesSeoId(requestParameters: EndpointsApiGetApiAttributesSeoIdRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiAttributesSeoId(requestParameters.id, requestParameters.getApiAttributesSeoIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetApiAttributesSeosRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiAttributesSeos(requestParameters: EndpointsApiGetApiAttributesSeosRequest = {}, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiAttributesSeos(requestParameters.getApiAttributesSeosRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetApiBillingCreditIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiBillingCreditId(requestParameters: EndpointsApiGetApiBillingCreditIdRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiBillingCreditId(requestParameters.id, requestParameters.getApiBillingCreditIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetApiBillingCreditsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiBillingCredits(requestParameters: EndpointsApiGetApiBillingCreditsRequest = {}, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiBillingCredits(requestParameters.getApiBillingCreditsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiCart(options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiCart(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiCartDetails(options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiCartDetails(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetApiCatalogAttributeIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiCatalogAttributeId(requestParameters: EndpointsApiGetApiCatalogAttributeIdRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiCatalogAttributeId(requestParameters.id, requestParameters.getApiCatalogAttributeIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetApiCatalogAttributeValueIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiCatalogAttributeValueId(requestParameters: EndpointsApiGetApiCatalogAttributeValueIdRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiCatalogAttributeValueId(requestParameters.id, requestParameters.postV1FooterDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetApiCatalogAttributesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiCatalogAttributes(requestParameters: EndpointsApiGetApiCatalogAttributesRequest = {}, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiCatalogAttributes(requestParameters.getApiContentPageIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetApiCatalogAttributesValuesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiCatalogAttributesValues(requestParameters: EndpointsApiGetApiCatalogAttributesValuesRequest = {}, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiCatalogAttributesValues(requestParameters.getApiCatalogAttributesValuesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetApiCatalogBrandIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiCatalogBrandId(requestParameters: EndpointsApiGetApiCatalogBrandIdRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiCatalogBrandId(requestParameters.id, requestParameters.getApiCatalogBrandIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetApiCatalogBrandsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiCatalogBrands(requestParameters: EndpointsApiGetApiCatalogBrandsRequest = {}, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiCatalogBrands(requestParameters.getApiCatalogBrandsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetApiCatalogCategoriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiCatalogCategories(requestParameters: EndpointsApiGetApiCatalogCategoriesRequest = {}, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiCatalogCategories(requestParameters.getApiCatalogCategoriesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetApiCatalogCategoryIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiCatalogCategoryId(requestParameters: EndpointsApiGetApiCatalogCategoryIdRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiCatalogCategoryId(requestParameters.id, requestParameters.getApiCatalogCategoryIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetApiCatalogProductAttributesIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiCatalogProductAttributesId(requestParameters: EndpointsApiGetApiCatalogProductAttributesIdRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiCatalogProductAttributesId(requestParameters.id, requestParameters.getApiCatalogAttributesValuesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetApiCatalogProductIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiCatalogProductId(requestParameters: EndpointsApiGetApiCatalogProductIdRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiCatalogProductId(requestParameters.id, requestParameters.getApiCatalogProductIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetApiCatalogProductSearchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiCatalogProductSearch(requestParameters: EndpointsApiGetApiCatalogProductSearchRequest = {}, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiCatalogProductSearch(requestParameters.getApiCatalogProductSearchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetApiCatalogProductsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiCatalogProducts(requestParameters: EndpointsApiGetApiCatalogProductsRequest = {}, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiCatalogProducts(requestParameters.getApiCatalogProductsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetApiCatalogProductsAttributesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiCatalogProductsAttributes(requestParameters: EndpointsApiGetApiCatalogProductsAttributesRequest = {}, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiCatalogProductsAttributes(requestParameters.getApiCatalogProductsAttributesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiCatalogProductsExport(options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiCatalogProductsExport(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetApiCatalogStoreIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiCatalogStoreId(requestParameters: EndpointsApiGetApiCatalogStoreIdRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiCatalogStoreId(requestParameters.id, requestParameters.getApiCatalogStoreIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetApiCatalogStoresRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiCatalogStores(requestParameters: EndpointsApiGetApiCatalogStoresRequest = {}, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiCatalogStores(requestParameters.getApiCatalogStoresRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetApiCatalogTagIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiCatalogTagId(requestParameters: EndpointsApiGetApiCatalogTagIdRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiCatalogTagId(requestParameters.id, requestParameters.getApiCatalogTagIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetApiCatalogTagsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiCatalogTags(requestParameters: EndpointsApiGetApiCatalogTagsRequest = {}, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiCatalogTags(requestParameters.getApiCatalogTagsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetApiClientUserIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiClientUserId(requestParameters: EndpointsApiGetApiClientUserIdRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiClientUserId(requestParameters.id, requestParameters.getUsersRequest1, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetApiCommunicationsNewsletterIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiCommunicationsNewsletterId(requestParameters: EndpointsApiGetApiCommunicationsNewsletterIdRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiCommunicationsNewsletterId(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiCommunicationsNewsletters(options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiCommunicationsNewsletters(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetApiCommunicationsSubscriberIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiCommunicationsSubscriberId(requestParameters: EndpointsApiGetApiCommunicationsSubscriberIdRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiCommunicationsSubscriberId(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiCommunicationsSubscribers(options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiCommunicationsSubscribers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetApiContentPageIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiContentPageId(requestParameters: EndpointsApiGetApiContentPageIdRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiContentPageId(requestParameters.id, requestParameters.getApiContentPageIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetApiContentPagesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiContentPages(requestParameters: EndpointsApiGetApiContentPagesRequest = {}, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiContentPages(requestParameters.getApiContentPagesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiDashStats(options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiDashStats(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiInstashopSettings(options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiInstashopSettings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetApiInvoicesSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiInvoicesSettings(requestParameters: EndpointsApiGetApiInvoicesSettingsRequest = {}, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiInvoicesSettings(requestParameters.getApiInvoicesSettingsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetApiInvoicesSettingsIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiInvoicesSettingsId(requestParameters: EndpointsApiGetApiInvoicesSettingsIdRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiInvoicesSettingsId(requestParameters.id, requestParameters.getApiInvoicesSettingsIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetApiMediaFilesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiMediaFiles(requestParameters: EndpointsApiGetApiMediaFilesRequest = {}, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiMediaFiles(requestParameters.getApiContentPagesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetApiMediaFilesIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiMediaFilesId(requestParameters: EndpointsApiGetApiMediaFilesIdRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiMediaFilesId(requestParameters.id, requestParameters.getApiMediaFilesIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetApiMediaSearchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiMediaSearch(requestParameters: EndpointsApiGetApiMediaSearchRequest = {}, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiMediaSearch(requestParameters.getApiMediaSearchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiMediaSettingsSizes(options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiMediaSettingsSizes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiMediaThumbThumbs(options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiMediaThumbThumbs(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiNoonSettings(options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiNoonSettings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetApiOrdersExportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiOrdersExport(requestParameters: EndpointsApiGetApiOrdersExportRequest = {}, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiOrdersExport(requestParameters.getApiOrdersExportRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetApiOrdersOrderIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiOrdersOrderId(requestParameters: EndpointsApiGetApiOrdersOrderIdRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiOrdersOrderId(requestParameters.id, requestParameters.getApiOrdersOrderIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetApiOrdersOrdersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiOrdersOrders(requestParameters: EndpointsApiGetApiOrdersOrdersRequest = {}, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiOrdersOrders(requestParameters.getApiOrdersOrdersRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiOrdersStatus(options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiOrdersStatus(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetApiOrdersStatusIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiOrdersStatusId(requestParameters: EndpointsApiGetApiOrdersStatusIdRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiOrdersStatusId(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetApiPathRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiPath(requestParameters: EndpointsApiGetApiPathRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiPath(requestParameters.path, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetApiPromotionsCodeIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiPromotionsCodeId(requestParameters: EndpointsApiGetApiPromotionsCodeIdRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiPromotionsCodeId(requestParameters.id, requestParameters.getApiPromotionsCodeIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetApiPromotionsCodesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiPromotionsCodes(requestParameters: EndpointsApiGetApiPromotionsCodesRequest = {}, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiPromotionsCodes(requestParameters.getApiPromotionsCodesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetApiPromotionsOfferIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiPromotionsOfferId(requestParameters: EndpointsApiGetApiPromotionsOfferIdRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiPromotionsOfferId(requestParameters.id, requestParameters.getApiPromotionsOfferIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetApiPromotionsOffersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiPromotionsOffers(requestParameters: EndpointsApiGetApiPromotionsOffersRequest = {}, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiPromotionsOffers(requestParameters.getApiPromotionsOffersRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiSalesPingg(options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiSalesPingg(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiSettingsCcavenueSettings(options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiSettingsCcavenueSettings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetApiSettingsCurrenciesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiSettingsCurrencies(requestParameters: EndpointsApiGetApiSettingsCurrenciesRequest = {}, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiSettingsCurrencies(requestParameters.getApiSettingsCurrenciesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetApiSettingsCurrencyIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiSettingsCurrencyId(requestParameters: EndpointsApiGetApiSettingsCurrencyIdRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiSettingsCurrencyId(requestParameters.id, requestParameters.getApiSettingsCurrencyIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiSettingsNetworkSettings(options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiSettingsNetworkSettings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiSettingsOnlinePaymentCardMethods(options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiSettingsOnlinePaymentCardMethods(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiSettingsOnlinePaymentGateways(options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiSettingsOnlinePaymentGateways(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiSettingsPayfortSettings(options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiSettingsPayfortSettings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetApiSettingsPaymentModeIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiSettingsPaymentModeId(requestParameters: EndpointsApiGetApiSettingsPaymentModeIdRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiSettingsPaymentModeId(requestParameters.id, requestParameters.getApiSettingsPaymentModeIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetApiSettingsPaymentModesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiSettingsPaymentModes(requestParameters: EndpointsApiGetApiSettingsPaymentModesRequest = {}, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiSettingsPaymentModes(requestParameters.getApiSettingsPaymentModesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiSettingsPaypalSettings(options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiSettingsPaypalSettings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiSettingsStripeSettings(options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiSettingsStripeSettings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiSettingsTabbySettings(options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiSettingsTabbySettings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiSettingsTamaraSettings(options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiSettingsTamaraSettings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetApiShippingFlatRateIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiShippingFlatRateId(requestParameters: EndpointsApiGetApiShippingFlatRateIdRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiShippingFlatRateId(requestParameters.id, requestParameters.getApiShippingFlatRateIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetApiShippingFlatRatesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiShippingFlatRates(requestParameters: EndpointsApiGetApiShippingFlatRatesRequest = {}, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiShippingFlatRates(requestParameters.getApiShippingFlatRatesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetApiShippingShippingDetailUsernameRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiShippingShippingDetailUsername(requestParameters: EndpointsApiGetApiShippingShippingDetailUsernameRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiShippingShippingDetailUsername(requestParameters.username, requestParameters.getApiShippingShippingDetailUsernameRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetApiShippingShippingDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiShippingShippingDetails(requestParameters: EndpointsApiGetApiShippingShippingDetailsRequest = {}, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiShippingShippingDetails(requestParameters.getApiShippingShippingDetailsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetApiShippingShippingServiceIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiShippingShippingServiceId(requestParameters: EndpointsApiGetApiShippingShippingServiceIdRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiShippingShippingServiceId(requestParameters.id, requestParameters.getApiShippingShippingServiceIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetApiShippingShippingServicesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiShippingShippingServices(requestParameters: EndpointsApiGetApiShippingShippingServicesRequest = {}, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiShippingShippingServices(requestParameters.getApiShippingShippingServicesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiThemeActive(options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiThemeActive(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiThemes(options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiThemes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetApiUserPermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiUserPermissions(requestParameters: EndpointsApiGetApiUserPermissionsRequest = {}, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiUserPermissions(requestParameters.getApiUserPermissionsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetApiUserPermissionsRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiUserPermissionsRole(requestParameters: EndpointsApiGetApiUserPermissionsRoleRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getApiUserPermissionsRole(requestParameters.role, requestParameters.getApiUserPermissionsRoleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetFrontBannerIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFrontBannerId(requestParameters: EndpointsApiGetFrontBannerIdRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getFrontBannerId(requestParameters.id, requestParameters.getFrontBannerIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetFrontBannersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFrontBanners(requestParameters: EndpointsApiGetFrontBannersRequest = {}, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getFrontBanners(requestParameters.getFrontBannersRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetFrontBrandIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFrontBrandId(requestParameters: EndpointsApiGetFrontBrandIdRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getFrontBrandId(requestParameters.id, requestParameters.getFrontBrandIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetFrontBrandsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFrontBrands(requestParameters: EndpointsApiGetFrontBrandsRequest = {}, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getFrontBrands(requestParameters.getFrontBrandsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetFrontCategoriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFrontCategories(requestParameters: EndpointsApiGetFrontCategoriesRequest = {}, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getFrontCategories(requestParameters.getFrontCategoriesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetFrontCategoryIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFrontCategoryId(requestParameters: EndpointsApiGetFrontCategoryIdRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getFrontCategoryId(requestParameters.id, requestParameters.getFrontCategoryIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetFrontFooterIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFrontFooterId(requestParameters: EndpointsApiGetFrontFooterIdRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getFrontFooterId(requestParameters.id, requestParameters.getFrontFooterIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetFrontFootersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFrontFooters(requestParameters: EndpointsApiGetFrontFootersRequest = {}, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getFrontFooters(requestParameters.getFrontFootersRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFrontLogout(options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getFrontLogout(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetFrontMenuIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFrontMenuId(requestParameters: EndpointsApiGetFrontMenuIdRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getFrontMenuId(requestParameters.id, requestParameters.getFrontMenuIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetFrontMenusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFrontMenus(requestParameters: EndpointsApiGetFrontMenusRequest = {}, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getFrontMenus(requestParameters.getFrontMenusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFrontNavbarMode(options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getFrontNavbarMode(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetFrontProductIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFrontProductId(requestParameters: EndpointsApiGetFrontProductIdRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getFrontProductId(requestParameters.id, requestParameters.getFrontProductIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetFrontProductsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFrontProducts(requestParameters: EndpointsApiGetFrontProductsRequest = {}, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getFrontProducts(requestParameters.getFrontProductsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetFrontSeoIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFrontSeoId(requestParameters: EndpointsApiGetFrontSeoIdRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getFrontSeoId(requestParameters.id, requestParameters.getFrontSeoIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetFrontSeosRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFrontSeos(requestParameters: EndpointsApiGetFrontSeosRequest = {}, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getFrontSeos(requestParameters.getFrontMenuIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFrontTestPing(options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getFrontTestPing(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFrontThemeActive(options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getFrontThemeActive(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetFrontVerifyResetPasswordTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFrontVerifyResetPasswordToken(requestParameters: EndpointsApiGetFrontVerifyResetPasswordTokenRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getFrontVerifyResetPasswordToken(requestParameters.token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetFrontVerifyTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFrontVerifyToken(requestParameters: EndpointsApiGetFrontVerifyTokenRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getFrontVerifyToken(requestParameters.token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetV1BannerIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getV1BannerId(requestParameters: EndpointsApiGetV1BannerIdRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getV1BannerId(requestParameters.id, requestParameters.getV1BannersRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetV1BannersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getV1Banners(requestParameters: EndpointsApiGetV1BannersRequest = {}, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getV1Banners(requestParameters.getV1BannersRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getV1ClearAllCache(options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getV1ClearAllCache(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getV1CountriesCountries(options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getV1CountriesCountries(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetV1CountriesCountryIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getV1CountriesCountryId(requestParameters: EndpointsApiGetV1CountriesCountryIdRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getV1CountriesCountryId(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetV1FooterIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getV1FooterId(requestParameters: EndpointsApiGetV1FooterIdRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getV1FooterId(requestParameters.id, requestParameters.getV1FooterIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetV1FootersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getV1Footers(requestParameters: EndpointsApiGetV1FootersRequest = {}, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getV1Footers(requestParameters.getV1FootersRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getV1Logout(options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getV1Logout(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetV1MenuIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getV1MenuId(requestParameters: EndpointsApiGetV1MenuIdRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getV1MenuId(requestParameters.id, requestParameters.getV1MenuIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetV1MenusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getV1Menus(requestParameters: EndpointsApiGetV1MenusRequest = {}, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getV1Menus(requestParameters.getV1MenusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getV1TestPing(options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getV1TestPing(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetV1VerifyResetPasswordTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getV1VerifyResetPasswordToken(requestParameters: EndpointsApiGetV1VerifyResetPasswordTokenRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getV1VerifyResetPasswordToken(requestParameters.token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiGetV1VerifyTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getV1VerifyToken(requestParameters: EndpointsApiGetV1VerifyTokenRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).getV1VerifyToken(requestParameters.token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPatchApiShippingShippingServiceIdActivateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public patchApiShippingShippingServiceIdActivate(requestParameters: EndpointsApiPatchApiShippingShippingServiceIdActivateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).patchApiShippingShippingServiceIdActivate(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiAccountsUserCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiAccountsUserCreate(requestParameters: EndpointsApiPostApiAccountsUserCreateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiAccountsUserCreate(requestParameters.postApiAccountsUserCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiAccountsUserDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiAccountsUserDelete(requestParameters: EndpointsApiPostApiAccountsUserDeleteRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiAccountsUserDelete(requestParameters.postApiAccountsUserDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiAccountsUserUpdateIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiAccountsUserUpdateId(requestParameters: EndpointsApiPostApiAccountsUserUpdateIdRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiAccountsUserUpdateId(requestParameters.id, requestParameters.postApiAccountsUserUpdateIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiAmazonSettingsUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiAmazonSettingsUpdate(requestParameters: EndpointsApiPostApiAmazonSettingsUpdateRequest = {}, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiAmazonSettingsUpdate(requestParameters.postApiAmazonSettingsUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiAramexSettingsUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiAramexSettingsUpdate(requestParameters: EndpointsApiPostApiAramexSettingsUpdateRequest = {}, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiAramexSettingsUpdate(requestParameters.postApiAramexSettingsUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiAttributesSeoCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiAttributesSeoCreate(requestParameters: EndpointsApiPostApiAttributesSeoCreateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiAttributesSeoCreate(requestParameters.postApiAttributesSeoCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiAttributesSeoDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiAttributesSeoDelete(requestParameters: EndpointsApiPostApiAttributesSeoDeleteRequest = {}, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiAttributesSeoDelete(requestParameters.postV1FooterDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiAttributesSeoUpdateIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiAttributesSeoUpdateId(requestParameters: EndpointsApiPostApiAttributesSeoUpdateIdRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiAttributesSeoUpdateId(requestParameters.id, requestParameters.postApiAttributesSeoUpdateIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiBillingBillingDetailsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiBillingBillingDetailsCreate(requestParameters: EndpointsApiPostApiBillingBillingDetailsCreateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiBillingBillingDetailsCreate(requestParameters.postApiBillingBillingDetailsCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiBillingBillingDetailsDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiBillingBillingDetailsDelete(requestParameters: EndpointsApiPostApiBillingBillingDetailsDeleteRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiBillingBillingDetailsDelete(requestParameters.postApiBillingBillingDetailsDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiBillingBillingDetailsUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiBillingBillingDetailsUpdate(requestParameters: EndpointsApiPostApiBillingBillingDetailsUpdateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiBillingBillingDetailsUpdate(requestParameters.postApiBillingBillingDetailsUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiBillingCreditCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiBillingCreditCreate(requestParameters: EndpointsApiPostApiBillingCreditCreateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiBillingCreditCreate(requestParameters.postApiBillingCreditCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiBillingCreditDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiBillingCreditDelete(requestParameters: EndpointsApiPostApiBillingCreditDeleteRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiBillingCreditDelete(requestParameters.postApiBillingCreditDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiBillingCreditUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiBillingCreditUpdate(requestParameters: EndpointsApiPostApiBillingCreditUpdateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiBillingCreditUpdate(requestParameters.postApiBillingCreditUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiCartAddRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiCartAdd(requestParameters: EndpointsApiPostApiCartAddRequest = {}, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiCartAdd(requestParameters.postApiCartAddRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiCatalogAttributeCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiCatalogAttributeCreate(requestParameters: EndpointsApiPostApiCatalogAttributeCreateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiCatalogAttributeCreate(requestParameters.postApiCatalogAttributeCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiCatalogAttributeDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiCatalogAttributeDelete(requestParameters: EndpointsApiPostApiCatalogAttributeDeleteRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiCatalogAttributeDelete(requestParameters.postApiCatalogAttributeDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiCatalogAttributeUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiCatalogAttributeUpdate(requestParameters: EndpointsApiPostApiCatalogAttributeUpdateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiCatalogAttributeUpdate(requestParameters.postApiCatalogAttributeUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiCatalogAttributeValueCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiCatalogAttributeValueCreate(requestParameters: EndpointsApiPostApiCatalogAttributeValueCreateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiCatalogAttributeValueCreate(requestParameters.postApiCatalogAttributeValueCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiCatalogAttributeValueDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiCatalogAttributeValueDelete(requestParameters: EndpointsApiPostApiCatalogAttributeValueDeleteRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiCatalogAttributeValueDelete(requestParameters.postApiCatalogAttributeValueDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiCatalogAttributeValueUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiCatalogAttributeValueUpdate(requestParameters: EndpointsApiPostApiCatalogAttributeValueUpdateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiCatalogAttributeValueUpdate(requestParameters.postApiCatalogAttributeValueUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiCatalogBrandCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiCatalogBrandCreate(requestParameters: EndpointsApiPostApiCatalogBrandCreateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiCatalogBrandCreate(requestParameters.postApiCatalogBrandCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiCatalogBrandDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiCatalogBrandDelete(requestParameters: EndpointsApiPostApiCatalogBrandDeleteRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiCatalogBrandDelete(requestParameters.postApiCatalogBrandDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiCatalogBrandUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiCatalogBrandUpdate(requestParameters: EndpointsApiPostApiCatalogBrandUpdateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiCatalogBrandUpdate(requestParameters.postApiCatalogBrandUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiCatalogCategoryCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiCatalogCategoryCreate(requestParameters: EndpointsApiPostApiCatalogCategoryCreateRequest = {}, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiCatalogCategoryCreate(requestParameters.postApiCatalogCategoryCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiCatalogCategoryDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiCatalogCategoryDelete(requestParameters: EndpointsApiPostApiCatalogCategoryDeleteRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiCatalogCategoryDelete(requestParameters.postApiCatalogCategoryDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiCatalogCategoryUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiCatalogCategoryUpdate(requestParameters: EndpointsApiPostApiCatalogCategoryUpdateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiCatalogCategoryUpdate(requestParameters.postApiCatalogCategoryUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiCatalogProductAttributesCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiCatalogProductAttributesCreate(requestParameters: EndpointsApiPostApiCatalogProductAttributesCreateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiCatalogProductAttributesCreate(requestParameters.postApiCatalogProductAttributesCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiCatalogProductAttributesDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiCatalogProductAttributesDelete(requestParameters: EndpointsApiPostApiCatalogProductAttributesDeleteRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiCatalogProductAttributesDelete(requestParameters.postApiCatalogProductAttributesDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiCatalogProductAttributesUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiCatalogProductAttributesUpdate(requestParameters: EndpointsApiPostApiCatalogProductAttributesUpdateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiCatalogProductAttributesUpdate(requestParameters.postApiCatalogProductAttributesUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiCatalogProductCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiCatalogProductCreate(requestParameters: EndpointsApiPostApiCatalogProductCreateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiCatalogProductCreate(requestParameters.postApiCatalogProductCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiCatalogProductDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiCatalogProductDelete(requestParameters: EndpointsApiPostApiCatalogProductDeleteRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiCatalogProductDelete(requestParameters.postApiCatalogProductDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiCatalogProductUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiCatalogProductUpdate(requestParameters: EndpointsApiPostApiCatalogProductUpdateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiCatalogProductUpdate(requestParameters.postApiCatalogProductUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiCatalogStoreCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiCatalogStoreCreate(requestParameters: EndpointsApiPostApiCatalogStoreCreateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiCatalogStoreCreate(requestParameters.postApiCatalogStoreCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiCatalogStoreDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiCatalogStoreDelete(requestParameters: EndpointsApiPostApiCatalogStoreDeleteRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiCatalogStoreDelete(requestParameters.postApiCatalogStoreDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiCatalogStoreUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiCatalogStoreUpdate(requestParameters: EndpointsApiPostApiCatalogStoreUpdateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiCatalogStoreUpdate(requestParameters.postApiCatalogStoreUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiCatalogTagCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiCatalogTagCreate(requestParameters: EndpointsApiPostApiCatalogTagCreateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiCatalogTagCreate(requestParameters.postApiCatalogTagCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiCatalogTagDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiCatalogTagDelete(requestParameters: EndpointsApiPostApiCatalogTagDeleteRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiCatalogTagDelete(requestParameters.postApiCatalogTagDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiCatalogTagUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiCatalogTagUpdate(requestParameters: EndpointsApiPostApiCatalogTagUpdateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiCatalogTagUpdate(requestParameters.postApiCatalogTagUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiCommunicationsNewsletterCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiCommunicationsNewsletterCreate(requestParameters: EndpointsApiPostApiCommunicationsNewsletterCreateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiCommunicationsNewsletterCreate(requestParameters.postApiCommunicationsNewsletterCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiCommunicationsNewsletterDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiCommunicationsNewsletterDelete(requestParameters: EndpointsApiPostApiCommunicationsNewsletterDeleteRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiCommunicationsNewsletterDelete(requestParameters.postApiCommunicationsNewsletterDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiCommunicationsNewsletterUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiCommunicationsNewsletterUpdate(requestParameters: EndpointsApiPostApiCommunicationsNewsletterUpdateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiCommunicationsNewsletterUpdate(requestParameters.postApiCommunicationsNewsletterUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiCommunicationsSubscriberCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiCommunicationsSubscriberCreate(requestParameters: EndpointsApiPostApiCommunicationsSubscriberCreateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiCommunicationsSubscriberCreate(requestParameters.postApiCommunicationsSubscriberCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiCommunicationsSubscriberDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiCommunicationsSubscriberDelete(requestParameters: EndpointsApiPostApiCommunicationsSubscriberDeleteRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiCommunicationsSubscriberDelete(requestParameters.postApiAccountsUserDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiCommunicationsSubscriberUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiCommunicationsSubscriberUpdate(requestParameters: EndpointsApiPostApiCommunicationsSubscriberUpdateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiCommunicationsSubscriberUpdate(requestParameters.postApiCommunicationsSubscriberUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiContentPageCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiContentPageCreate(requestParameters: EndpointsApiPostApiContentPageCreateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiContentPageCreate(requestParameters.postApiContentPageCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiContentPageDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiContentPageDelete(requestParameters: EndpointsApiPostApiContentPageDeleteRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiContentPageDelete(requestParameters.postApiContentPageDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiContentPageUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiContentPageUpdate(requestParameters: EndpointsApiPostApiContentPageUpdateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiContentPageUpdate(requestParameters.postApiContentPageUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiInstashopSettingsUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiInstashopSettingsUpdate(requestParameters: EndpointsApiPostApiInstashopSettingsUpdateRequest = {}, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiInstashopSettingsUpdate(requestParameters.postApiInstashopSettingsUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiInvoicesSettingsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiInvoicesSettingsCreate(requestParameters: EndpointsApiPostApiInvoicesSettingsCreateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiInvoicesSettingsCreate(requestParameters.postApiInvoicesSettingsCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiInvoicesSettingsDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiInvoicesSettingsDelete(requestParameters: EndpointsApiPostApiInvoicesSettingsDeleteRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiInvoicesSettingsDelete(requestParameters.postApiInvoicesSettingsDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiInvoicesSettingsUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiInvoicesSettingsUpdate(requestParameters: EndpointsApiPostApiInvoicesSettingsUpdateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiInvoicesSettingsUpdate(requestParameters.postApiInvoicesSettingsUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiMediaFileDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiMediaFileDelete(requestParameters: EndpointsApiPostApiMediaFileDeleteRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiMediaFileDelete(requestParameters.postApiMediaFileDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiMediaFileUpdateIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiMediaFileUpdateId(requestParameters: EndpointsApiPostApiMediaFileUpdateIdRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiMediaFileUpdateId(requestParameters.id, requestParameters.postApiMediaFileUpdateIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiMediaFileUploadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiMediaFileUpload(requestParameters: EndpointsApiPostApiMediaFileUploadRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiMediaFileUpload(requestParameters.postApiMediaFileUploadRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiMediaSettingsSizeUpdateIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiMediaSettingsSizeUpdateId(requestParameters: EndpointsApiPostApiMediaSettingsSizeUpdateIdRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiMediaSettingsSizeUpdateId(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiMediaThumbUpdateAudio(options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiMediaThumbUpdateAudio(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiMediaThumbUpdateDocument(options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiMediaThumbUpdateDocument(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiMediaThumbUpdateVideo(options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiMediaThumbUpdateVideo(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiNoonSettingsUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiNoonSettingsUpdate(requestParameters: EndpointsApiPostApiNoonSettingsUpdateRequest = {}, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiNoonSettingsUpdate(requestParameters.postApiNoonSettingsUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiOrdersOrderCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiOrdersOrderCreate(requestParameters: EndpointsApiPostApiOrdersOrderCreateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiOrdersOrderCreate(requestParameters.postApiOrdersOrderCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiOrdersOrderDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiOrdersOrderDelete(requestParameters: EndpointsApiPostApiOrdersOrderDeleteRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiOrdersOrderDelete(requestParameters.postApiOrdersOrderDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiOrdersOrderUpdateIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiOrdersOrderUpdateId(requestParameters: EndpointsApiPostApiOrdersOrderUpdateIdRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiOrdersOrderUpdateId(requestParameters.id, requestParameters.postApiOrdersOrderUpdateIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiOrdersStatusCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiOrdersStatusCreate(requestParameters: EndpointsApiPostApiOrdersStatusCreateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiOrdersStatusCreate(requestParameters.postApiOrdersStatusCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiOrdersStatusDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiOrdersStatusDelete(requestParameters: EndpointsApiPostApiOrdersStatusDeleteRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiOrdersStatusDelete(requestParameters.postApiOrdersStatusDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiOrdersStatusUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiOrdersStatusUpdate(requestParameters: EndpointsApiPostApiOrdersStatusUpdateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiOrdersStatusUpdate(requestParameters.postApiOrdersStatusUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiPaymentInitiateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiPaymentInitiate(requestParameters: EndpointsApiPostApiPaymentInitiateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiPaymentInitiate(requestParameters.postApiPaymentInitiateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiPromotionsCodeCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiPromotionsCodeCreate(requestParameters: EndpointsApiPostApiPromotionsCodeCreateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiPromotionsCodeCreate(requestParameters.postApiPromotionsCodeCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiPromotionsCodeDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiPromotionsCodeDelete(requestParameters: EndpointsApiPostApiPromotionsCodeDeleteRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiPromotionsCodeDelete(requestParameters.postApiPromotionsCodeDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiPromotionsCodeUpdateIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiPromotionsCodeUpdateId(requestParameters: EndpointsApiPostApiPromotionsCodeUpdateIdRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiPromotionsCodeUpdateId(requestParameters.id, requestParameters.postApiPromotionsCodeUpdateIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiPromotionsOfferCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiPromotionsOfferCreate(requestParameters: EndpointsApiPostApiPromotionsOfferCreateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiPromotionsOfferCreate(requestParameters.postApiPromotionsOfferCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiPromotionsOfferDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiPromotionsOfferDelete(requestParameters: EndpointsApiPostApiPromotionsOfferDeleteRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiPromotionsOfferDelete(requestParameters.postApiCatalogProductDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiPromotionsOfferUpdateIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiPromotionsOfferUpdateId(requestParameters: EndpointsApiPostApiPromotionsOfferUpdateIdRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiPromotionsOfferUpdateId(requestParameters.id, requestParameters.postApiPromotionsOfferUpdateIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiSettingsCcavenueSettingsUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiSettingsCcavenueSettingsUpdate(requestParameters: EndpointsApiPostApiSettingsCcavenueSettingsUpdateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiSettingsCcavenueSettingsUpdate(requestParameters.postApiSettingsCcavenueSettingsUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiSettingsCurrencyCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiSettingsCurrencyCreate(requestParameters: EndpointsApiPostApiSettingsCurrencyCreateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiSettingsCurrencyCreate(requestParameters.postApiSettingsCurrencyCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiSettingsCurrencyDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiSettingsCurrencyDelete(requestParameters: EndpointsApiPostApiSettingsCurrencyDeleteRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiSettingsCurrencyDelete(requestParameters.postApiCatalogTagDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiSettingsCurrencyUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiSettingsCurrencyUpdate(requestParameters: EndpointsApiPostApiSettingsCurrencyUpdateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiSettingsCurrencyUpdate(requestParameters.postApiSettingsCurrencyUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiSettingsNetworkSettingsUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiSettingsNetworkSettingsUpdate(requestParameters: EndpointsApiPostApiSettingsNetworkSettingsUpdateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiSettingsNetworkSettingsUpdate(requestParameters.postApiSettingsNetworkSettingsUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiSettingsOnlinePaymentCardMethodActivateIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiSettingsOnlinePaymentCardMethodActivateId(requestParameters: EndpointsApiPostApiSettingsOnlinePaymentCardMethodActivateIdRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiSettingsOnlinePaymentCardMethodActivateId(requestParameters.id, requestParameters.postApiSettingsOnlinePaymentGatewayActivateIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiSettingsOnlinePaymentGatewayActivateIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiSettingsOnlinePaymentGatewayActivateId(requestParameters: EndpointsApiPostApiSettingsOnlinePaymentGatewayActivateIdRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiSettingsOnlinePaymentGatewayActivateId(requestParameters.id, requestParameters.postApiSettingsOnlinePaymentGatewayActivateIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiSettingsPayfortSettingsUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiSettingsPayfortSettingsUpdate(requestParameters: EndpointsApiPostApiSettingsPayfortSettingsUpdateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiSettingsPayfortSettingsUpdate(requestParameters.postApiSettingsPayfortSettingsUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiSettingsPaymentModeCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiSettingsPaymentModeCreate(requestParameters: EndpointsApiPostApiSettingsPaymentModeCreateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiSettingsPaymentModeCreate(requestParameters.postApiSettingsPaymentModeCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiSettingsPaymentModeDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiSettingsPaymentModeDelete(requestParameters: EndpointsApiPostApiSettingsPaymentModeDeleteRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiSettingsPaymentModeDelete(requestParameters.postApiSettingsPaymentModeDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiSettingsPaymentModeUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiSettingsPaymentModeUpdate(requestParameters: EndpointsApiPostApiSettingsPaymentModeUpdateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiSettingsPaymentModeUpdate(requestParameters.postApiSettingsPaymentModeUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiSettingsPaypalSettingsUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiSettingsPaypalSettingsUpdate(requestParameters: EndpointsApiPostApiSettingsPaypalSettingsUpdateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiSettingsPaypalSettingsUpdate(requestParameters.postApiSettingsPaypalSettingsUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiSettingsStripeSettingsUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiSettingsStripeSettingsUpdate(requestParameters: EndpointsApiPostApiSettingsStripeSettingsUpdateRequest = {}, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiSettingsStripeSettingsUpdate(requestParameters.postApiSettingsStripeSettingsUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiSettingsTabbySettingsUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiSettingsTabbySettingsUpdate(requestParameters: EndpointsApiPostApiSettingsTabbySettingsUpdateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiSettingsTabbySettingsUpdate(requestParameters.postApiSettingsTabbySettingsUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiSettingsTamaraSettingsUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiSettingsTamaraSettingsUpdate(requestParameters: EndpointsApiPostApiSettingsTamaraSettingsUpdateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiSettingsTamaraSettingsUpdate(requestParameters.postApiSettingsTamaraSettingsUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiShippingCostCalculatorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiShippingCostCalculator(requestParameters: EndpointsApiPostApiShippingCostCalculatorRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiShippingCostCalculator(requestParameters.postApiShippingCostCalculatorRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiShippingFlatRateCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiShippingFlatRateCreate(requestParameters: EndpointsApiPostApiShippingFlatRateCreateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiShippingFlatRateCreate(requestParameters.postApiShippingFlatRateCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiShippingFlatRateDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiShippingFlatRateDelete(requestParameters: EndpointsApiPostApiShippingFlatRateDeleteRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiShippingFlatRateDelete(requestParameters.postApiCatalogCategoryDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiShippingFlatRateUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiShippingFlatRateUpdate(requestParameters: EndpointsApiPostApiShippingFlatRateUpdateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiShippingFlatRateUpdate(requestParameters.postApiShippingFlatRateUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiShippingShippingDetailsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiShippingShippingDetailsCreate(requestParameters: EndpointsApiPostApiShippingShippingDetailsCreateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiShippingShippingDetailsCreate(requestParameters.postApiShippingShippingDetailsCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiShippingShippingDetailsDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiShippingShippingDetailsDelete(requestParameters: EndpointsApiPostApiShippingShippingDetailsDeleteRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiShippingShippingDetailsDelete(requestParameters.postApiShippingShippingDetailsDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiShippingShippingDetailsUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiShippingShippingDetailsUpdate(requestParameters: EndpointsApiPostApiShippingShippingDetailsUpdateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiShippingShippingDetailsUpdate(requestParameters.postApiShippingShippingDetailsUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiShippingShippingServiceCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiShippingShippingServiceCreate(requestParameters: EndpointsApiPostApiShippingShippingServiceCreateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiShippingShippingServiceCreate(requestParameters.postApiShippingShippingServiceCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiShippingShippingServiceDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiShippingShippingServiceDelete(requestParameters: EndpointsApiPostApiShippingShippingServiceDeleteRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiShippingShippingServiceDelete(requestParameters.postApiShippingShippingServiceDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiShippingShippingServiceUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiShippingShippingServiceUpdate(requestParameters: EndpointsApiPostApiShippingShippingServiceUpdateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiShippingShippingServiceUpdate(requestParameters.postApiShippingShippingServiceUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiThemeActivateIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiThemeActivateId(requestParameters: EndpointsApiPostApiThemeActivateIdRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiThemeActivateId(requestParameters.id, requestParameters.getApiSettingsCurrencyIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new theme
     * @param {EndpointsApiPostApiThemeCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiThemeCreate(requestParameters: EndpointsApiPostApiThemeCreateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiThemeCreate(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a theme's color palette
     * @param {EndpointsApiPostApiThemeColorUpdateIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiThemeColorUpdateId(requestParameters: EndpointsApiPostApiThemeColorUpdateIdRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiThemeColorUpdateId(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a saved color theme
     * @param {EndpointsApiDeleteApiThemeColorIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteApiThemeColorId(requestParameters: EndpointsApiDeleteApiThemeColorIdRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).deleteApiThemeColorId(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiThemeSettingsUpdateIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiThemeSettingsUpdateId(requestParameters: EndpointsApiPostApiThemeSettingsUpdateIdRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiThemeSettingsUpdateId(requestParameters.id, requestParameters.postApiThemeSettingsUpdateIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiThemeUploadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiThemeUpload(requestParameters: EndpointsApiPostApiThemeUploadRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiThemeUpload(requestParameters.themeZip, requestParameters.name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiUserPermissionsUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiUserPermissionsUpdate(requestParameters: EndpointsApiPostApiUserPermissionsUpdateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiUserPermissionsUpdate(requestParameters.postApiUserPermissionsUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiUserRoleCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiUserRoleCreate(requestParameters: EndpointsApiPostApiUserRoleCreateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiUserRoleCreate(requestParameters.postApiUserRoleCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiUserRoleDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiUserRoleDelete(requestParameters: EndpointsApiPostApiUserRoleDeleteRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiUserRoleDelete(requestParameters.postApiUserRoleDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostApiUserRoleUpdateRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postApiUserRoleUpdateRole(requestParameters: EndpointsApiPostApiUserRoleUpdateRoleRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postApiUserRoleUpdateRole(requestParameters.role, requestParameters.postApiUserRoleUpdateRoleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postFrontLogin(options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postFrontLogin(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostFrontProductRateIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postFrontProductRateId(requestParameters: EndpointsApiPostFrontProductRateIdRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postFrontProductRateId(requestParameters.id, requestParameters.postFrontProductRateIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postFrontRegister(options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postFrontRegister(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postFrontReset(options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postFrontReset(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postFrontResetPassword(options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postFrontResetPassword(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostV1BannerCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postV1BannerCreate(requestParameters: EndpointsApiPostV1BannerCreateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postV1BannerCreate(requestParameters.postV1BannerCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostV1BannerDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postV1BannerDelete(requestParameters: EndpointsApiPostV1BannerDeleteRequest = {}, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postV1BannerDelete(requestParameters.postV1BannerDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostV1BannerUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postV1BannerUpdate(requestParameters: EndpointsApiPostV1BannerUpdateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postV1BannerUpdate(requestParameters.postV1BannerUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostV1FooterCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postV1FooterCreate(requestParameters: EndpointsApiPostV1FooterCreateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postV1FooterCreate(requestParameters.postV1FooterCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostV1FooterDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postV1FooterDelete(requestParameters: EndpointsApiPostV1FooterDeleteRequest = {}, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postV1FooterDelete(requestParameters.postV1FooterDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostV1FooterUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postV1FooterUpdate(requestParameters: EndpointsApiPostV1FooterUpdateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postV1FooterUpdate(requestParameters.postV1FooterUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postV1Login(options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postV1Login(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostV1MenuCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postV1MenuCreate(requestParameters: EndpointsApiPostV1MenuCreateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postV1MenuCreate(requestParameters.postV1MenuCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostV1MenuDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postV1MenuDelete(requestParameters: EndpointsApiPostV1MenuDeleteRequest = {}, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postV1MenuDelete(requestParameters.postV1MenuDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPostV1MenuUpdateIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postV1MenuUpdateId(requestParameters: EndpointsApiPostV1MenuUpdateIdRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postV1MenuUpdateId(requestParameters.id, requestParameters.postV1MenuUpdateIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    /**
     * 
     * @summary 
     * @param {EndpointsApiPostV1NavbarModeUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postV1NavbarModeUpdate(requestParameters: EndpointsApiPostV1NavbarModeUpdateRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postV1NavbarModeUpdate(requestParameters.postV1NavbarModeUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postV1Register(options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postV1Register(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postV1Reset(options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postV1Reset(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postV1ResetPassword(options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).postV1ResetPassword(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EndpointsApiPutApiCartItemsCartItemIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putApiCartItemsCartItemId(requestParameters: EndpointsApiPutApiCartItemsCartItemIdRequest, options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).putApiCartItemsCartItemId(requestParameters.cartItemId, requestParameters.putApiCartItemsCartItemIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Serve the generated OpenAPI YAML file.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public serveTheGeneratedOpenAPIYAMLFile(options?: RawAxiosRequestConfig) {
        return EndpointsApiFp(this.configuration).serveTheGeneratedOpenAPIYAMLFile(options).then((request) => request(this.axios, this.basePath));
    }
}